//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v10.9.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import handlers from "@/config/axios/globalHandler";
import useApiStore from "@/stores/api";
import type { ServiceType } from "@/stores/api/types";
import axios, { AxiosError } from "axios";
import type {
  AxiosInstance,
  AxiosRequestConfig,
  AxiosResponse,
  CancelToken,
} from "axios";

export class Client {
  private instance: AxiosInstance;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance ? instance : axios.create();

    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * Verify billing address
   * @param addressLine1 (optional)
   * @param city (optional)
   * @param region (optional)
   * @param country (optional)
   * @param postalCode (optional)
   * @return Success
   */
  verifyAddress(
    request?: {
      addressLine1?: string | undefined;
      city?: string | undefined;
      region?: string | undefined;
      country?: string | undefined;
      postalCode?: string | undefined;
    },
    cancelToken?: CancelToken | undefined
  ): Promise<VerifyAccountAddressResponseApiResponse> {
    let url_ = this.baseUrl + "/v1/accounts/verifyaddress?";
    if (request?.addressLine1 === null)
      throw new Error("The parameter 'addressLine1' cannot be null.");
    else if (request?.addressLine1 !== undefined)
      url_ +=
        "addressLine1=" + encodeURIComponent("" + request?.addressLine1) + "&";
    if (request?.city === null)
      throw new Error("The parameter 'city' cannot be null.");
    else if (request?.city !== undefined)
      url_ += "city=" + encodeURIComponent("" + request?.city) + "&";
    if (request?.region === null)
      throw new Error("The parameter 'region' cannot be null.");
    else if (request?.region !== undefined)
      url_ += "region=" + encodeURIComponent("" + request?.region) + "&";
    if (request?.country === null)
      throw new Error("The parameter 'country' cannot be null.");
    else if (request?.country !== undefined)
      url_ += "country=" + encodeURIComponent("" + request?.country) + "&";
    if (request?.postalCode === null)
      throw new Error("The parameter 'postalCode' cannot be null.");
    else if (request?.postalCode !== undefined)
      url_ +=
        "postalCode=" + encodeURIComponent("" + request?.postalCode) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processVerifyAddress(_response);
      });
  }

  protected processVerifyAddress(
    response: AxiosResponse
  ): Promise<VerifyAccountAddressResponseApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<VerifyAccountAddressResponseApiResponse>(
        result200
      );
    } else if (status === 422) {
      const _responseText = response.data;
      let result422: any = null;
      let resultData422 = _responseText;
      result422 = JSON.parse(resultData422);
      return throwException(
        "Client Error",
        status,
        _responseText,
        _headers,
        result422
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<VerifyAccountAddressResponseApiResponse>(
      null as any
    );
  }

  /**
   * Get an ApiKey by id
   * @return Success
   */
  getApiKey(
    request?: { id: string },
    cancelToken?: CancelToken | undefined
  ): Promise<GetApiKeyResponseApiResponse> {
    let url_ = this.baseUrl + "/v1/apikeys/{id}";
    if (request?.id === undefined || request?.id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + request?.id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetApiKey(_response);
      });
  }

  protected processGetApiKey(
    response: AxiosResponse
  ): Promise<GetApiKeyResponseApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<GetApiKeyResponseApiResponse>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<GetApiKeyResponseApiResponse>(null as any);
  }

  /**
   * Update an ApiKey
   * @param body (optional)
   * @return Success
   */
  updateApiKey(
    request?: { id: string; body?: UpdateApiKeyRequest | undefined },
    cancelToken?: CancelToken | undefined
  ): Promise<UpdateApiKeyResponseApiResponse> {
    let url_ = this.baseUrl + "/v1/apikeys/{id}";
    if (request?.id === undefined || request?.id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + request?.id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(request?.body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "PATCH",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processUpdateApiKey(_response);
      });
  }

  protected processUpdateApiKey(
    response: AxiosResponse
  ): Promise<UpdateApiKeyResponseApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<UpdateApiKeyResponseApiResponse>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<UpdateApiKeyResponseApiResponse>(null as any);
  }

  /**
   * Upsert an ApiKey
   * @param body (optional)
   * @return Success
   */
  upsertApiKey(
    request?: { id: string; body?: UpsertApiKeyRequest | undefined },
    cancelToken?: CancelToken | undefined
  ): Promise<UpsertApiKeyResponseApiResponse> {
    let url_ = this.baseUrl + "/v1/apikeys/{id}";
    if (request?.id === undefined || request?.id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + request?.id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(request?.body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processUpsertApiKey(_response);
      });
  }

  protected processUpsertApiKey(
    response: AxiosResponse
  ): Promise<UpsertApiKeyResponseApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<UpsertApiKeyResponseApiResponse>(result200);
    } else if (status === 201) {
      const _responseText = response.data;
      let result201: any = null;
      let resultData201 = _responseText;
      result201 = JSON.parse(resultData201);
      return Promise.resolve<UpsertApiKeyResponseApiResponse>(result201);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<UpsertApiKeyResponseApiResponse>(null as any);
  }

  /**
   * Delete an ApiKey
   * @return Success
   */
  deleteApiKey(
    request?: { id: string },
    cancelToken?: CancelToken | undefined
  ): Promise<DeleteApiKeyResponseApiResponse> {
    let url_ = this.baseUrl + "/v1/apikeys/{id}";
    if (request?.id === undefined || request?.id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + request?.id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processDeleteApiKey(_response);
      });
  }

  protected processDeleteApiKey(
    response: AxiosResponse
  ): Promise<DeleteApiKeyResponseApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<DeleteApiKeyResponseApiResponse>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<DeleteApiKeyResponseApiResponse>(null as any);
  }

  /**
   * Get a List of ApiKeys
   * @param limit (optional)
   * @param page (optional)
   * @param sort (optional)
   * @param q (optional)
   * @param expand (optional)
   * @return Success
   */
  listApiKeys(
    request?: {
      limit?: number | undefined;
      page?: number | undefined;
      sort?: string | undefined;
      q?: string | undefined;
      expand?: string | undefined;
    },
    cancelToken?: CancelToken | undefined
  ): Promise<ListApiKeyItemPagedApiResponse> {
    let url_ = this.baseUrl + "/v1/apikeys?";
    if (request?.limit === null)
      throw new Error("The parameter 'limit' cannot be null.");
    else if (request?.limit !== undefined)
      url_ += "limit=" + encodeURIComponent("" + request?.limit) + "&";
    if (request?.page === null)
      throw new Error("The parameter 'page' cannot be null.");
    else if (request?.page !== undefined)
      url_ += "page=" + encodeURIComponent("" + request?.page) + "&";
    if (request?.sort === null)
      throw new Error("The parameter 'sort' cannot be null.");
    else if (request?.sort !== undefined)
      url_ += "sort=" + encodeURIComponent("" + request?.sort) + "&";
    if (request?.q === null)
      throw new Error("The parameter 'q' cannot be null.");
    else if (request?.q !== undefined)
      url_ += "q=" + encodeURIComponent("" + request?.q) + "&";
    if (request?.expand === null)
      throw new Error("The parameter 'expand' cannot be null.");
    else if (request?.expand !== undefined)
      url_ += "expand=" + encodeURIComponent("" + request?.expand) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processListApiKeys(_response);
      });
  }

  protected processListApiKeys(
    response: AxiosResponse
  ): Promise<ListApiKeyItemPagedApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<ListApiKeyItemPagedApiResponse>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<ListApiKeyItemPagedApiResponse>(null as any);
  }

  /**
   * Create an ApiKey
   * @param body (optional)
   * @return Success
   */
  createApiKey(
    request?: { body?: CreateApiKeyRequest | undefined },
    cancelToken?: CancelToken | undefined
  ): Promise<CreateApiKeyResponseApiResponse> {
    let url_ = this.baseUrl + "/v1/apikeys";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(request?.body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processCreateApiKey(_response);
      });
  }

  protected processCreateApiKey(
    response: AxiosResponse
  ): Promise<CreateApiKeyResponseApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 201) {
      const _responseText = response.data;
      let result201: any = null;
      let resultData201 = _responseText;
      result201 = JSON.parse(resultData201);
      return Promise.resolve<CreateApiKeyResponseApiResponse>(result201);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<CreateApiKeyResponseApiResponse>(null as any);
  }

  /**
   * Get AppVersion by id
   * @return Success
   */
  getAppVersion(
    request?: { id: string },
    cancelToken?: CancelToken | undefined
  ): Promise<GetAppVersionResponseApiResponse> {
    let url_ = this.baseUrl + "/v1/appversions/{id}";
    if (request?.id === undefined || request?.id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + request?.id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetAppVersion(_response);
      });
  }

  protected processGetAppVersion(
    response: AxiosResponse
  ): Promise<GetAppVersionResponseApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<GetAppVersionResponseApiResponse>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<GetAppVersionResponseApiResponse>(null as any);
  }

  /**
   * Create or replace AppVersion
   * @param body (optional)
   * @return Success
   */
  upsertAppVersion(
    request?: { id: string; body?: UpsertAppVersionRequest | undefined },
    cancelToken?: CancelToken | undefined
  ): Promise<UpsertAppVersionResponseApiResponse> {
    let url_ = this.baseUrl + "/v1/appversions/{id}";
    if (request?.id === undefined || request?.id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + request?.id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(request?.body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processUpsertAppVersion(_response);
      });
  }

  protected processUpsertAppVersion(
    response: AxiosResponse
  ): Promise<UpsertAppVersionResponseApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<UpsertAppVersionResponseApiResponse>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<UpsertAppVersionResponseApiResponse>(null as any);
  }

  /**
   * Update AppVersion
   * @param body (optional)
   * @return Success
   */
  updateAppVersion(
    request?: { id: string; body?: UpdateAppVersionRequest | undefined },
    cancelToken?: CancelToken | undefined
  ): Promise<UpdateAppVersionResponseApiResponse> {
    let url_ = this.baseUrl + "/v1/appversions/{id}";
    if (request?.id === undefined || request?.id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + request?.id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(request?.body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "PATCH",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processUpdateAppVersion(_response);
      });
  }

  protected processUpdateAppVersion(
    response: AxiosResponse
  ): Promise<UpdateAppVersionResponseApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<UpdateAppVersionResponseApiResponse>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<UpdateAppVersionResponseApiResponse>(null as any);
  }

  /**
   * Delete AppVersion by id
   * @return Success
   */
  deleteAppVersion(
    request?: { id: string },
    cancelToken?: CancelToken | undefined
  ): Promise<StringApiResponse> {
    let url_ = this.baseUrl + "/v1/appversions/{id}";
    if (request?.id === undefined || request?.id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + request?.id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processDeleteAppVersion(_response);
      });
  }

  protected processDeleteAppVersion(
    response: AxiosResponse
  ): Promise<StringApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<StringApiResponse>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<StringApiResponse>(null as any);
  }

  /**
   * Get List of AppVersions
   * @param limit (optional)
   * @param page (optional)
   * @param sort (optional)
   * @param q (optional)
   * @return Success
   */
  listAppVersions(
    request?: {
      limit?: number | undefined;
      page?: number | undefined;
      sort?: string | undefined;
      q?: string | undefined;
    },
    cancelToken?: CancelToken | undefined
  ): Promise<GetAppVersionResponsePagedApiResponse> {
    let url_ = this.baseUrl + "/v1/appversions?";
    if (request?.limit === null)
      throw new Error("The parameter 'limit' cannot be null.");
    else if (request?.limit !== undefined)
      url_ += "limit=" + encodeURIComponent("" + request?.limit) + "&";
    if (request?.page === null)
      throw new Error("The parameter 'page' cannot be null.");
    else if (request?.page !== undefined)
      url_ += "page=" + encodeURIComponent("" + request?.page) + "&";
    if (request?.sort === null)
      throw new Error("The parameter 'sort' cannot be null.");
    else if (request?.sort !== undefined)
      url_ += "sort=" + encodeURIComponent("" + request?.sort) + "&";
    if (request?.q === null)
      throw new Error("The parameter 'q' cannot be null.");
    else if (request?.q !== undefined)
      url_ += "q=" + encodeURIComponent("" + request?.q) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processListAppVersions(_response);
      });
  }

  protected processListAppVersions(
    response: AxiosResponse
  ): Promise<GetAppVersionResponsePagedApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<GetAppVersionResponsePagedApiResponse>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<GetAppVersionResponsePagedApiResponse>(null as any);
  }

  /**
   * Create AppVersion
   * @param body (optional)
   * @return Success
   */
  createAppVersion(
    request?: { body?: CreateAppVersionRequest | undefined },
    cancelToken?: CancelToken | undefined
  ): Promise<CreateAppVersionResponseApiResponse> {
    let url_ = this.baseUrl + "/v1/appversions";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(request?.body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processCreateAppVersion(_response);
      });
  }

  protected processCreateAppVersion(
    response: AxiosResponse
  ): Promise<CreateAppVersionResponseApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<CreateAppVersionResponseApiResponse>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<CreateAppVersionResponseApiResponse>(null as any);
  }

  /**
   * Creates an asset in the temporary folder
   * @param file (optional)
   * @return Success
   */
  createAssetInTempFolder(
    request?: { file?: FileParameter | undefined },
    cancelToken?: CancelToken | undefined
  ): Promise<CreateAssetResponseApiResponse> {
    let url_ = this.baseUrl + "/v1/assetstorage";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = new FormData();
    if (request?.file === null || request?.file === undefined)
      throw new Error("The parameter 'file' cannot be null.");
    else
      content_.append(
        "file",
        request?.file.data,
        request?.file.fileName ? request?.file.fileName : "file"
      );

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processCreateAssetInTempFolder(_response);
      });
  }

  protected processCreateAssetInTempFolder(
    response: AxiosResponse
  ): Promise<CreateAssetResponseApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<CreateAssetResponseApiResponse>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<CreateAssetResponseApiResponse>(null as any);
  }

  /**
   * Get Calendar Integration Status
   * @return Success
   */
  getCalendarIntegrationStatus(
    cancelToken?: CancelToken | undefined
  ): Promise<GetCalendarIntegrationStatusResponseApiResponse> {
    let url_ = this.baseUrl + "/v1/integrations/calendar";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetCalendarIntegrationStatus(_response);
      });
  }

  protected processGetCalendarIntegrationStatus(
    response: AxiosResponse
  ): Promise<GetCalendarIntegrationStatusResponseApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<GetCalendarIntegrationStatusResponseApiResponse>(
        result200
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<GetCalendarIntegrationStatusResponseApiResponse>(
      null as any
    );
  }

  /**
   * Remove Microsoft Calendar Integration
   * @return Success
   */
  removeCalendarIntegration(
    cancelToken?: CancelToken | undefined
  ): Promise<RemoveCalendarIntegrationResponseApiResponse> {
    let url_ = this.baseUrl + "/v1/integrations/calendar";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processRemoveCalendarIntegration(_response);
      });
  }

  protected processRemoveCalendarIntegration(
    response: AxiosResponse
  ): Promise<RemoveCalendarIntegrationResponseApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<RemoveCalendarIntegrationResponseApiResponse>(
        result200
      );
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = JSON.parse(resultData400);
      return throwException(
        "Bad Request",
        status,
        _responseText,
        _headers,
        result400
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<RemoveCalendarIntegrationResponseApiResponse>(
      null as any
    );
  }

  /**
   * Create Microsoft Calendar Integration
   * @param body (optional)
   * @return Success
   */
  createMicrosoftCalendarIntegration(
    request?: { body?: CreateMicrosoftCalendarIntegrationRequest | undefined },
    cancelToken?: CancelToken | undefined
  ): Promise<CreateMicrosoftCalendarIntegrationResponseApiResponse> {
    let url_ = this.baseUrl + "/v1/integrations/calendar/microsoft";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(request?.body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processCreateMicrosoftCalendarIntegration(_response);
      });
  }

  protected processCreateMicrosoftCalendarIntegration(
    response: AxiosResponse
  ): Promise<CreateMicrosoftCalendarIntegrationResponseApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 201) {
      const _responseText = response.data;
      let result201: any = null;
      let resultData201 = _responseText;
      result201 = JSON.parse(resultData201);
      return Promise.resolve<CreateMicrosoftCalendarIntegrationResponseApiResponse>(
        result201
      );
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = JSON.parse(resultData400);
      return throwException(
        "Bad Request",
        status,
        _responseText,
        _headers,
        result400
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<CreateMicrosoftCalendarIntegrationResponseApiResponse>(
      null as any
    );
  }

  /**
   * Get Calendar Integration Status
   * @param userId (optional)
   * @return Success
   */
  validateCalendarIntegrationUser(
    request?: { userId?: string | undefined },
    cancelToken?: CancelToken | undefined
  ): Promise<ValidateCalendarIntegrationUserResponseApiResponse> {
    let url_ = this.baseUrl + "/v1/integrations/calendar/isvaliduser?";
    if (request?.userId === null)
      throw new Error("The parameter 'userId' cannot be null.");
    else if (request?.userId !== undefined)
      url_ += "userId=" + encodeURIComponent("" + request?.userId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processValidateCalendarIntegrationUser(_response);
      });
  }

  protected processValidateCalendarIntegrationUser(
    response: AxiosResponse
  ): Promise<ValidateCalendarIntegrationUserResponseApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<ValidateCalendarIntegrationUserResponseApiResponse>(
        result200
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<ValidateCalendarIntegrationUserResponseApiResponse>(
      null as any
    );
  }

  /**
   * Get SSO configuration
   * @return Success
   */
  getSSOConfiguration(
    request?: { email: string },
    cancelToken?: CancelToken | undefined
  ): Promise<GetUserSSOConfigurationResponseApiResponse> {
    let url_ = this.baseUrl + "/v1/config/sso/{email}";
    if (request?.email === undefined || request?.email === null)
      throw new Error("The parameter 'email' must be defined.");
    url_ = url_.replace("{email}", encodeURIComponent("" + request?.email));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetSSOConfiguration(_response);
      });
  }

  protected processGetSSOConfiguration(
    response: AxiosResponse
  ): Promise<GetUserSSOConfigurationResponseApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<GetUserSSOConfigurationResponseApiResponse>(
        result200
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<GetUserSSOConfigurationResponseApiResponse>(
      null as any
    );
  }

  /**
   * Get Department by id
   * @return Success
   */
  getDepartment(
    request?: { id: string },
    cancelToken?: CancelToken | undefined
  ): Promise<GetDepartmentResponseApiResponse> {
    let url_ = this.baseUrl + "/v1/departments/{id}";
    if (request?.id === undefined || request?.id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + request?.id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetDepartment(_response);
      });
  }

  protected processGetDepartment(
    response: AxiosResponse
  ): Promise<GetDepartmentResponseApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<GetDepartmentResponseApiResponse>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<GetDepartmentResponseApiResponse>(null as any);
  }

  /**
   * Update Department
   * @param body (optional)
   * @return Success
   */
  updateDepartment(
    request?: { id: string; body?: UpdateDepartmentRequest | undefined },
    cancelToken?: CancelToken | undefined
  ): Promise<UpdateDepartmentResponseApiResponse> {
    let url_ = this.baseUrl + "/v1/departments/{id}";
    if (request?.id === undefined || request?.id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + request?.id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(request?.body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "PATCH",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processUpdateDepartment(_response);
      });
  }

  protected processUpdateDepartment(
    response: AxiosResponse
  ): Promise<UpdateDepartmentResponseApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<UpdateDepartmentResponseApiResponse>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<UpdateDepartmentResponseApiResponse>(null as any);
  }

  /**
   * Delete Department by id
   * @return Success
   */
  deleteDepartment(
    request?: { id: string },
    cancelToken?: CancelToken | undefined
  ): Promise<StringApiResponse> {
    let url_ = this.baseUrl + "/v1/departments/{id}";
    if (request?.id === undefined || request?.id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + request?.id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processDeleteDepartment(_response);
      });
  }

  protected processDeleteDepartment(
    response: AxiosResponse
  ): Promise<StringApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<StringApiResponse>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<StringApiResponse>(null as any);
  }

  /**
   * Get List of Departments
   * @param limit (optional)
   * @param page (optional)
   * @param sort (optional)
   * @param q (optional)
   * @param expand (optional)
   * @return Success
   */
  listDepartments(
    request?: {
      limit?: number | undefined;
      page?: number | undefined;
      sort?: string | undefined;
      q?: string | undefined;
      expand?: string | undefined;
    },
    cancelToken?: CancelToken | undefined
  ): Promise<ListDepartmentItemPagedApiResponse> {
    let url_ = this.baseUrl + "/v1/departments?";
    if (request?.limit === null)
      throw new Error("The parameter 'limit' cannot be null.");
    else if (request?.limit !== undefined)
      url_ += "limit=" + encodeURIComponent("" + request?.limit) + "&";
    if (request?.page === null)
      throw new Error("The parameter 'page' cannot be null.");
    else if (request?.page !== undefined)
      url_ += "page=" + encodeURIComponent("" + request?.page) + "&";
    if (request?.sort === null)
      throw new Error("The parameter 'sort' cannot be null.");
    else if (request?.sort !== undefined)
      url_ += "sort=" + encodeURIComponent("" + request?.sort) + "&";
    if (request?.q === null)
      throw new Error("The parameter 'q' cannot be null.");
    else if (request?.q !== undefined)
      url_ += "q=" + encodeURIComponent("" + request?.q) + "&";
    if (request?.expand === null)
      throw new Error("The parameter 'expand' cannot be null.");
    else if (request?.expand !== undefined)
      url_ += "expand=" + encodeURIComponent("" + request?.expand) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processListDepartments(_response);
      });
  }

  protected processListDepartments(
    response: AxiosResponse
  ): Promise<ListDepartmentItemPagedApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<ListDepartmentItemPagedApiResponse>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<ListDepartmentItemPagedApiResponse>(null as any);
  }

  /**
   * Create Department
   * @param body (optional)
   * @return Success
   */
  createDepartment(
    request?: { body?: CreateDepartmentRequest | undefined },
    cancelToken?: CancelToken | undefined
  ): Promise<CreateDepartmentResponseApiResponse> {
    let url_ = this.baseUrl + "/v1/departments";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(request?.body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processCreateDepartment(_response);
      });
  }

  protected processCreateDepartment(
    response: AxiosResponse
  ): Promise<CreateDepartmentResponseApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 201) {
      const _responseText = response.data;
      let result201: any = null;
      let resultData201 = _responseText;
      result201 = JSON.parse(resultData201);
      return Promise.resolve<CreateDepartmentResponseApiResponse>(result201);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<CreateDepartmentResponseApiResponse>(null as any);
  }

  /**
   * Get List of Devices
   * @param limit (optional)
   * @param page (optional)
   * @param sort (optional)
   * @param q (optional)
   * @param expand (optional)
   * @return Success
   */
  get_Devices(
    request?: {
      limit?: number | undefined;
      page?: number | undefined;
      sort?: string | undefined;
      q?: string | undefined;
      expand?: string | undefined;
    },
    cancelToken?: CancelToken | undefined
  ): Promise<GetDeviceResponsePagedApiResponse> {
    let url_ = this.baseUrl + "/v1/devices?";
    if (request?.limit === null)
      throw new Error("The parameter 'limit' cannot be null.");
    else if (request?.limit !== undefined)
      url_ += "limit=" + encodeURIComponent("" + request?.limit) + "&";
    if (request?.page === null)
      throw new Error("The parameter 'page' cannot be null.");
    else if (request?.page !== undefined)
      url_ += "page=" + encodeURIComponent("" + request?.page) + "&";
    if (request?.sort === null)
      throw new Error("The parameter 'sort' cannot be null.");
    else if (request?.sort !== undefined)
      url_ += "sort=" + encodeURIComponent("" + request?.sort) + "&";
    if (request?.q === null)
      throw new Error("The parameter 'q' cannot be null.");
    else if (request?.q !== undefined)
      url_ += "q=" + encodeURIComponent("" + request?.q) + "&";
    if (request?.expand === null)
      throw new Error("The parameter 'expand' cannot be null.");
    else if (request?.expand !== undefined)
      url_ += "expand=" + encodeURIComponent("" + request?.expand) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_Devices(_response);
      });
  }

  protected processGet_Devices(
    response: AxiosResponse
  ): Promise<GetDeviceResponsePagedApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<GetDeviceResponsePagedApiResponse>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<GetDeviceResponsePagedApiResponse>(null as any);
  }

  /**
   * Get Device by id
   * @return Success
   */
  get_Device(
    request?: { id: string },
    cancelToken?: CancelToken | undefined
  ): Promise<GetDeviceResponseApiResponse> {
    let url_ = this.baseUrl + "/v1/devices/{id}";
    if (request?.id === undefined || request?.id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + request?.id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_Device(_response);
      });
  }

  protected processGet_Device(
    response: AxiosResponse
  ): Promise<GetDeviceResponseApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<GetDeviceResponseApiResponse>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<GetDeviceResponseApiResponse>(null as any);
  }

  /**
   * Update Device
   * @param body (optional)
   * @return Success
   */
  update_Device(
    request?: { id: string; body?: UpdateDeviceRequest | undefined },
    cancelToken?: CancelToken | undefined
  ): Promise<UpdateDeviceResponseApiResponse> {
    let url_ = this.baseUrl + "/v1/devices/{id}";
    if (request?.id === undefined || request?.id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + request?.id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(request?.body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "PATCH",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processUpdate_Device(_response);
      });
  }

  protected processUpdate_Device(
    response: AxiosResponse
  ): Promise<UpdateDeviceResponseApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<UpdateDeviceResponseApiResponse>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<UpdateDeviceResponseApiResponse>(null as any);
  }

  /**
   * Delete AppVersion by id
   * @return Success
   */
  delete_Device(
    request?: { id: string },
    cancelToken?: CancelToken | undefined
  ): Promise<StringApiResponse> {
    let url_ = this.baseUrl + "/v1/devices/{id}";
    if (request?.id === undefined || request?.id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + request?.id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processDelete_Device(_response);
      });
  }

  protected processDelete_Device(
    response: AxiosResponse
  ): Promise<StringApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<StringApiResponse>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<StringApiResponse>(null as any);
  }

  /**
   * Get Induction by id
   * @return Success
   */
  getInduction(
    request?: { id: string },
    cancelToken?: CancelToken | undefined
  ): Promise<GetInductionResponseApiResponse> {
    let url_ = this.baseUrl + "/v1/inductions/{id}";
    if (request?.id === undefined || request?.id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + request?.id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetInduction(_response);
      });
  }

  protected processGetInduction(
    response: AxiosResponse
  ): Promise<GetInductionResponseApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<GetInductionResponseApiResponse>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<GetInductionResponseApiResponse>(null as any);
  }

  /**
   * Upsert Induction
   * @param body (optional)
   * @return Success
   */
  upsertInduction(
    request?: { id: string; body?: UpsertInductionRequest | undefined },
    cancelToken?: CancelToken | undefined
  ): Promise<UpsertInductionResponseApiResponse> {
    let url_ = this.baseUrl + "/v1/inductions/{id}";
    if (request?.id === undefined || request?.id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + request?.id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(request?.body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processUpsertInduction(_response);
      });
  }

  protected processUpsertInduction(
    response: AxiosResponse
  ): Promise<UpsertInductionResponseApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<UpsertInductionResponseApiResponse>(result200);
    } else if (status === 201) {
      const _responseText = response.data;
      let result201: any = null;
      let resultData201 = _responseText;
      result201 = JSON.parse(resultData201);
      return Promise.resolve<UpsertInductionResponseApiResponse>(result201);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<UpsertInductionResponseApiResponse>(null as any);
  }

  /**
   * Update Induction
   * @param body (optional)
   * @return Success
   */
  updateInduction(
    request?: { id: string; body?: UpdateInductionRequest | undefined },
    cancelToken?: CancelToken | undefined
  ): Promise<UpdateInductionResponseApiResponse> {
    let url_ = this.baseUrl + "/v1/inductions/{id}";
    if (request?.id === undefined || request?.id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + request?.id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(request?.body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "PATCH",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processUpdateInduction(_response);
      });
  }

  protected processUpdateInduction(
    response: AxiosResponse
  ): Promise<UpdateInductionResponseApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<UpdateInductionResponseApiResponse>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<UpdateInductionResponseApiResponse>(null as any);
  }

  /**
   * Delete Induction by id
   * @return Success
   */
  deleteInduction(
    request?: { id: string },
    cancelToken?: CancelToken | undefined
  ): Promise<DeleteInductionResponseApiResponse> {
    let url_ = this.baseUrl + "/v1/inductions/{id}";
    if (request?.id === undefined || request?.id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + request?.id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processDeleteInduction(_response);
      });
  }

  protected processDeleteInduction(
    response: AxiosResponse
  ): Promise<DeleteInductionResponseApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<DeleteInductionResponseApiResponse>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<DeleteInductionResponseApiResponse>(null as any);
  }

  /**
   * Get List of Inductions
   * @param limit (optional)
   * @param page (optional)
   * @param sort (optional)
   * @param q (optional)
   * @param expand (optional)
   * @return Success
   */
  listInductions(
    request?: {
      limit?: number | undefined;
      page?: number | undefined;
      sort?: string | undefined;
      q?: string | undefined;
      expand?: string | undefined;
    },
    cancelToken?: CancelToken | undefined
  ): Promise<ListInductionItemPagedApiResponse> {
    let url_ = this.baseUrl + "/v1/inductions?";
    if (request?.limit === null)
      throw new Error("The parameter 'limit' cannot be null.");
    else if (request?.limit !== undefined)
      url_ += "limit=" + encodeURIComponent("" + request?.limit) + "&";
    if (request?.page === null)
      throw new Error("The parameter 'page' cannot be null.");
    else if (request?.page !== undefined)
      url_ += "page=" + encodeURIComponent("" + request?.page) + "&";
    if (request?.sort === null)
      throw new Error("The parameter 'sort' cannot be null.");
    else if (request?.sort !== undefined)
      url_ += "sort=" + encodeURIComponent("" + request?.sort) + "&";
    if (request?.q === null)
      throw new Error("The parameter 'q' cannot be null.");
    else if (request?.q !== undefined)
      url_ += "q=" + encodeURIComponent("" + request?.q) + "&";
    if (request?.expand === null)
      throw new Error("The parameter 'expand' cannot be null.");
    else if (request?.expand !== undefined)
      url_ += "expand=" + encodeURIComponent("" + request?.expand) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processListInductions(_response);
      });
  }

  protected processListInductions(
    response: AxiosResponse
  ): Promise<ListInductionItemPagedApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<ListInductionItemPagedApiResponse>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<ListInductionItemPagedApiResponse>(null as any);
  }

  /**
   * Create Induction
   * @param body (optional)
   * @return Success
   */
  createInduction(
    request?: { body?: CreateInductionRequest | undefined },
    cancelToken?: CancelToken | undefined
  ): Promise<CreateInductionResponseApiResponse> {
    let url_ = this.baseUrl + "/v1/inductions";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(request?.body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processCreateInduction(_response);
      });
  }

  protected processCreateInduction(
    response: AxiosResponse
  ): Promise<CreateInductionResponseApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 201) {
      const _responseText = response.data;
      let result201: any = null;
      let resultData201 = _responseText;
      result201 = JSON.parse(resultData201);
      return Promise.resolve<CreateInductionResponseApiResponse>(result201);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<CreateInductionResponseApiResponse>(null as any);
  }

  /**
   * Invalidate Inductions
   * @param body (optional)
   * @return Success
   */
  invalidateInductions(
    request?: { body?: BulkInductionRequest | undefined },
    cancelToken?: CancelToken | undefined
  ): Promise<BulkInductionResponseApiResponse> {
    let url_ = this.baseUrl + "/v1/inductions/invalidate";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(request?.body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processInvalidateInductions(_response);
      });
  }

  protected processInvalidateInductions(
    response: AxiosResponse
  ): Promise<BulkInductionResponseApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<BulkInductionResponseApiResponse>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<BulkInductionResponseApiResponse>(null as any);
  }

  /**
   * Delete Inductions
   * @param body (optional)
   * @return Success
   */
  removeInductions(
    request?: { body?: BulkInductionRequest | undefined },
    cancelToken?: CancelToken | undefined
  ): Promise<BulkInductionResponseApiResponse> {
    let url_ = this.baseUrl + "/v1/inductions/remove";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(request?.body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processRemoveInductions(_response);
      });
  }

  protected processRemoveInductions(
    response: AxiosResponse
  ): Promise<BulkInductionResponseApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<BulkInductionResponseApiResponse>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<BulkInductionResponseApiResponse>(null as any);
  }

  /**
   * Get completed inductions export csv
   * @return Success
   */
  downloadCompletedInductionsExport(
    request?: { inductionIds: string[] },
    cancelToken?: CancelToken | undefined
  ): Promise<FileResponse> {
    let url_ = this.baseUrl + "/v1/inductions/export/completed?";
    if (request?.inductionIds === undefined || request?.inductionIds === null)
      throw new Error(
        "The parameter 'inductionIds' must be defined and cannot be null."
      );
    else
      request?.inductionIds &&
        request?.inductionIds.forEach((item) => {
          url_ += "inductionIds=" + encodeURIComponent("" + item) + "&";
        });
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      responseType: "blob",
      method: "GET",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processDownloadCompletedInductionsExport(_response);
      });
  }

  protected processDownloadCompletedInductionsExport(
    response: AxiosResponse
  ): Promise<FileResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers["content-disposition"]
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return Promise.resolve({
        fileName: fileName,
        status: status,
        data: new Blob([response.data], {
          type: response.headers["content-type"],
        }),
        headers: _headers,
      });
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<FileResponse>(null as any);
  }

  /**
   * Get Resource Booking Insights
   * @param locationId (optional)
   * @param locationGroupId (optional)
   * @param days (optional)
   * @param startDate (optional)
   * @return Success
   */
  getResourceBookingInsight(
    request?: {
      locationId?: string | undefined;
      locationGroupId?: string | undefined;
      days?: number | undefined;
      startDate?: Date | undefined;
    },
    cancelToken?: CancelToken | undefined
  ): Promise<GetInsightResponseItemListApiResponse> {
    let url_ = this.baseUrl + "/v1/insights/resourcebookings?";
    if (request?.locationId === null)
      throw new Error("The parameter 'locationId' cannot be null.");
    else if (request?.locationId !== undefined)
      url_ +=
        "locationId=" + encodeURIComponent("" + request?.locationId) + "&";
    if (request?.locationGroupId === null)
      throw new Error("The parameter 'locationGroupId' cannot be null.");
    else if (request?.locationGroupId !== undefined)
      url_ +=
        "locationGroupId=" +
        encodeURIComponent("" + request?.locationGroupId) +
        "&";
    if (request?.days === null)
      throw new Error("The parameter 'days' cannot be null.");
    else if (request?.days !== undefined)
      url_ += "days=" + encodeURIComponent("" + request?.days) + "&";
    if (request?.startDate === null)
      throw new Error("The parameter 'startDate' cannot be null.");
    else if (request?.startDate !== undefined)
      url_ +=
        "startDate=" +
        encodeURIComponent(
          request?.startDate ? "" + request?.startDate.toISOString() : ""
        ) +
        "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetResourceBookingInsight(_response);
      });
  }

  protected processGetResourceBookingInsight(
    response: AxiosResponse
  ): Promise<GetInsightResponseItemListApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<GetInsightResponseItemListApiResponse>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<GetInsightResponseItemListApiResponse>(null as any);
  }

  /**
   * Get Level by id
   * @param expand (optional)
   * @return Success
   */
  getLevel(
    request?: { id: string; expand?: string | undefined },
    cancelToken?: CancelToken | undefined
  ): Promise<GetLevelResponseApiResponse> {
    let url_ = this.baseUrl + "/v1/levels/{id}?";
    if (request?.id === undefined || request?.id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + request?.id));
    if (request?.expand === null)
      throw new Error("The parameter 'expand' cannot be null.");
    else if (request?.expand !== undefined)
      url_ += "expand=" + encodeURIComponent("" + request?.expand) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetLevel(_response);
      });
  }

  protected processGetLevel(
    response: AxiosResponse
  ): Promise<GetLevelResponseApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<GetLevelResponseApiResponse>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<GetLevelResponseApiResponse>(null as any);
  }

  /**
   * Create or replace Level
   * @param body (optional)
   * @return Success
   */
  upsertLevel(
    request?: { id: string; body?: UpsertLevelRequest | undefined },
    cancelToken?: CancelToken | undefined
  ): Promise<UpsertLevelResponseApiResponse> {
    let url_ = this.baseUrl + "/v1/levels/{id}";
    if (request?.id === undefined || request?.id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + request?.id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(request?.body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processUpsertLevel(_response);
      });
  }

  protected processUpsertLevel(
    response: AxiosResponse
  ): Promise<UpsertLevelResponseApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<UpsertLevelResponseApiResponse>(result200);
    } else if (status === 201) {
      const _responseText = response.data;
      let result201: any = null;
      let resultData201 = _responseText;
      result201 = JSON.parse(resultData201);
      return Promise.resolve<UpsertLevelResponseApiResponse>(result201);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<UpsertLevelResponseApiResponse>(null as any);
  }

  /**
   * Update Level
   * @param body (optional)
   * @return Success
   */
  updateLevel(
    request?: { id: string; body?: UpdateLevelRequest | undefined },
    cancelToken?: CancelToken | undefined
  ): Promise<UpdateLevelResponseApiResponse> {
    let url_ = this.baseUrl + "/v1/levels/{id}";
    if (request?.id === undefined || request?.id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + request?.id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(request?.body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "PATCH",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processUpdateLevel(_response);
      });
  }

  protected processUpdateLevel(
    response: AxiosResponse
  ): Promise<UpdateLevelResponseApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<UpdateLevelResponseApiResponse>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<UpdateLevelResponseApiResponse>(null as any);
  }

  /**
   * Delete Level by id
   * @return Success
   */
  deleteLevel(
    request?: { id: string },
    cancelToken?: CancelToken | undefined
  ): Promise<DeleteLevelResponseApiResponse> {
    let url_ = this.baseUrl + "/v1/levels/{id}";
    if (request?.id === undefined || request?.id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + request?.id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processDeleteLevel(_response);
      });
  }

  protected processDeleteLevel(
    response: AxiosResponse
  ): Promise<DeleteLevelResponseApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<DeleteLevelResponseApiResponse>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<DeleteLevelResponseApiResponse>(null as any);
  }

  /**
   * Get List of SpaceZones
   * @return Success
   */
  listLevelZones(
    request?: { id: string },
    cancelToken?: CancelToken | undefined
  ): Promise<ListSpaceZoneItemPagedApiResponse> {
    let url_ = this.baseUrl + "/v1/levels/{id}/zones";
    if (request?.id === undefined || request?.id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + request?.id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processListLevelZones(_response);
      });
  }

  protected processListLevelZones(
    response: AxiosResponse
  ): Promise<ListSpaceZoneItemPagedApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<ListSpaceZoneItemPagedApiResponse>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<ListSpaceZoneItemPagedApiResponse>(null as any);
  }

  /**
   * Get List of Levels
   * @param locationId (optional)
   * @param locationGroupId (optional)
   * @param spaceCategoryId (optional)
   * @param limit (optional)
   * @param page (optional)
   * @param sort (optional)
   * @param q (optional)
   * @param expand (optional)
   * @return Success
   */
  listLevels(
    request?: {
      locationId?: string | undefined;
      locationGroupId?: string | undefined;
      spaceCategoryId?: string | undefined;
      limit?: number | undefined;
      page?: number | undefined;
      sort?: string | undefined;
      q?: string | undefined;
      expand?: string | undefined;
    },
    cancelToken?: CancelToken | undefined
  ): Promise<GetLevelResponsePagedApiResponse> {
    let url_ = this.baseUrl + "/v1/levels?";
    if (request?.locationId === null)
      throw new Error("The parameter 'locationId' cannot be null.");
    else if (request?.locationId !== undefined)
      url_ +=
        "locationId=" + encodeURIComponent("" + request?.locationId) + "&";
    if (request?.locationGroupId === null)
      throw new Error("The parameter 'locationGroupId' cannot be null.");
    else if (request?.locationGroupId !== undefined)
      url_ +=
        "locationGroupId=" +
        encodeURIComponent("" + request?.locationGroupId) +
        "&";
    if (request?.spaceCategoryId === null)
      throw new Error("The parameter 'spaceCategoryId' cannot be null.");
    else if (request?.spaceCategoryId !== undefined)
      url_ +=
        "spaceCategoryId=" +
        encodeURIComponent("" + request?.spaceCategoryId) +
        "&";
    if (request?.limit === null)
      throw new Error("The parameter 'limit' cannot be null.");
    else if (request?.limit !== undefined)
      url_ += "limit=" + encodeURIComponent("" + request?.limit) + "&";
    if (request?.page === null)
      throw new Error("The parameter 'page' cannot be null.");
    else if (request?.page !== undefined)
      url_ += "page=" + encodeURIComponent("" + request?.page) + "&";
    if (request?.sort === null)
      throw new Error("The parameter 'sort' cannot be null.");
    else if (request?.sort !== undefined)
      url_ += "sort=" + encodeURIComponent("" + request?.sort) + "&";
    if (request?.q === null)
      throw new Error("The parameter 'q' cannot be null.");
    else if (request?.q !== undefined)
      url_ += "q=" + encodeURIComponent("" + request?.q) + "&";
    if (request?.expand === null)
      throw new Error("The parameter 'expand' cannot be null.");
    else if (request?.expand !== undefined)
      url_ += "expand=" + encodeURIComponent("" + request?.expand) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processListLevels(_response);
      });
  }

  protected processListLevels(
    response: AxiosResponse
  ): Promise<GetLevelResponsePagedApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<GetLevelResponsePagedApiResponse>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<GetLevelResponsePagedApiResponse>(null as any);
  }

  /**
   * Create Level
   * @param body (optional)
   * @return Success
   */
  createLevel(
    request?: { body?: CreateLevelRequest | undefined },
    cancelToken?: CancelToken | undefined
  ): Promise<CreateLevelResponseApiResponse> {
    let url_ = this.baseUrl + "/v1/levels";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(request?.body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processCreateLevel(_response);
      });
  }

  protected processCreateLevel(
    response: AxiosResponse
  ): Promise<CreateLevelResponseApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<CreateLevelResponseApiResponse>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<CreateLevelResponseApiResponse>(null as any);
  }

  /**
   * Get Movement by id
   * @param expand (optional)
   * @return Success
   */
  getMovement(
    request?: { id: string; expand?: string | undefined },
    cancelToken?: CancelToken | undefined
  ): Promise<GetMovementResponseApiResponse> {
    let url_ = this.baseUrl + "/v1/movements/{id}?";
    if (request?.id === undefined || request?.id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + request?.id));
    if (request?.expand === null)
      throw new Error("The parameter 'expand' cannot be null.");
    else if (request?.expand !== undefined)
      url_ += "expand=" + encodeURIComponent("" + request?.expand) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetMovement(_response);
      });
  }

  protected processGetMovement(
    response: AxiosResponse
  ): Promise<GetMovementResponseApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<GetMovementResponseApiResponse>(result200);
    } else if (status === 404) {
      const _responseText = response.data;
      let result404: any = null;
      let resultData404 = _responseText;
      result404 = JSON.parse(resultData404);
      return throwException(
        "Not Found",
        status,
        _responseText,
        _headers,
        result404
      );
    } else if (status === 403) {
      const _responseText = response.data;
      let result403: any = null;
      let resultData403 = _responseText;
      result403 = JSON.parse(resultData403);
      return throwException(
        "Forbidden",
        status,
        _responseText,
        _headers,
        result403
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<GetMovementResponseApiResponse>(null as any);
  }

  /**
   * Get Movement fields by id
   * @param limit (optional)
   * @param page (optional)
   * @param sort (optional)
   * @param q (optional)
   * @param expand (optional)
   * @return Success
   */
  getMovementFields(
    request?: {
      id: string;
      limit?: number | undefined;
      page?: number | undefined;
      sort?: string | undefined;
      q?: string | undefined;
      expand?: string | undefined;
    },
    cancelToken?: CancelToken | undefined
  ): Promise<ListMovementFieldsItemPagedApiResponse> {
    let url_ = this.baseUrl + "/v1/movements/{id}/fields?";
    if (request?.id === undefined || request?.id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + request?.id));
    if (request?.limit === null)
      throw new Error("The parameter 'limit' cannot be null.");
    else if (request?.limit !== undefined)
      url_ += "limit=" + encodeURIComponent("" + request?.limit) + "&";
    if (request?.page === null)
      throw new Error("The parameter 'page' cannot be null.");
    else if (request?.page !== undefined)
      url_ += "page=" + encodeURIComponent("" + request?.page) + "&";
    if (request?.sort === null)
      throw new Error("The parameter 'sort' cannot be null.");
    else if (request?.sort !== undefined)
      url_ += "sort=" + encodeURIComponent("" + request?.sort) + "&";
    if (request?.q === null)
      throw new Error("The parameter 'q' cannot be null.");
    else if (request?.q !== undefined)
      url_ += "q=" + encodeURIComponent("" + request?.q) + "&";
    if (request?.expand === null)
      throw new Error("The parameter 'expand' cannot be null.");
    else if (request?.expand !== undefined)
      url_ += "expand=" + encodeURIComponent("" + request?.expand) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetMovementFields(_response);
      });
  }

  protected processGetMovementFields(
    response: AxiosResponse
  ): Promise<ListMovementFieldsItemPagedApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<ListMovementFieldsItemPagedApiResponse>(result200);
    } else if (status === 404) {
      const _responseText = response.data;
      let result404: any = null;
      let resultData404 = _responseText;
      result404 = JSON.parse(resultData404);
      return throwException(
        "Not Found",
        status,
        _responseText,
        _headers,
        result404
      );
    } else if (status === 403) {
      const _responseText = response.data;
      let result403: any = null;
      let resultData403 = _responseText;
      result403 = JSON.parse(resultData403);
      return throwException(
        "Forbidden",
        status,
        _responseText,
        _headers,
        result403
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<ListMovementFieldsItemPagedApiResponse>(null as any);
  }

  /**
   * Get a List of Movements
   * @param locationId (optional)
   * @param locationGroupId (optional)
   * @param userId (optional)
   * @param reviewStatus (optional)
   * @param isRemote (optional)
   * @param limit (optional)
   * @param page (optional)
   * @param sort (optional)
   * @param q (optional)
   * @param expand (optional)
   * @return Success
   */
  listMovements(
    request?: {
      startedAt: string;
      finishedAt: string;
      locationId?: string | undefined;
      locationGroupId?: string | undefined;
      userId?: string | undefined;
      reviewStatus?: string | undefined;
      isRemote?: boolean | undefined;
      limit?: number | undefined;
      page?: number | undefined;
      sort?: string | undefined;
      q?: string | undefined;
      expand?: string | undefined;
    },
    cancelToken?: CancelToken | undefined
  ): Promise<ListMovementItemPagedApiResponse> {
    let url_ = this.baseUrl + "/v1/movements?";
    if (request?.startedAt === undefined || request?.startedAt === null)
      throw new Error(
        "The parameter 'startedAt' must be defined and cannot be null."
      );
    else
      url_ += "startedAt=" + encodeURIComponent("" + request?.startedAt) + "&";
    if (request?.finishedAt === undefined || request?.finishedAt === null)
      throw new Error(
        "The parameter 'finishedAt' must be defined and cannot be null."
      );
    else
      url_ +=
        "finishedAt=" + encodeURIComponent("" + request?.finishedAt) + "&";
    if (request?.locationId === null)
      throw new Error("The parameter 'locationId' cannot be null.");
    else if (request?.locationId !== undefined)
      url_ +=
        "locationId=" + encodeURIComponent("" + request?.locationId) + "&";
    if (request?.locationGroupId === null)
      throw new Error("The parameter 'locationGroupId' cannot be null.");
    else if (request?.locationGroupId !== undefined)
      url_ +=
        "locationGroupId=" +
        encodeURIComponent("" + request?.locationGroupId) +
        "&";
    if (request?.userId === null)
      throw new Error("The parameter 'userId' cannot be null.");
    else if (request?.userId !== undefined)
      url_ += "userId=" + encodeURIComponent("" + request?.userId) + "&";
    if (request?.reviewStatus === null)
      throw new Error("The parameter 'reviewStatus' cannot be null.");
    else if (request?.reviewStatus !== undefined)
      url_ +=
        "reviewStatus=" + encodeURIComponent("" + request?.reviewStatus) + "&";
    if (request?.isRemote === null)
      throw new Error("The parameter 'isRemote' cannot be null.");
    else if (request?.isRemote !== undefined)
      url_ += "isRemote=" + encodeURIComponent("" + request?.isRemote) + "&";
    if (request?.limit === null)
      throw new Error("The parameter 'limit' cannot be null.");
    else if (request?.limit !== undefined)
      url_ += "limit=" + encodeURIComponent("" + request?.limit) + "&";
    if (request?.page === null)
      throw new Error("The parameter 'page' cannot be null.");
    else if (request?.page !== undefined)
      url_ += "page=" + encodeURIComponent("" + request?.page) + "&";
    if (request?.sort === null)
      throw new Error("The parameter 'sort' cannot be null.");
    else if (request?.sort !== undefined)
      url_ += "sort=" + encodeURIComponent("" + request?.sort) + "&";
    if (request?.q === null)
      throw new Error("The parameter 'q' cannot be null.");
    else if (request?.q !== undefined)
      url_ += "q=" + encodeURIComponent("" + request?.q) + "&";
    if (request?.expand === null)
      throw new Error("The parameter 'expand' cannot be null.");
    else if (request?.expand !== undefined)
      url_ += "expand=" + encodeURIComponent("" + request?.expand) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processListMovements(_response);
      });
  }

  protected processListMovements(
    response: AxiosResponse
  ): Promise<ListMovementItemPagedApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<ListMovementItemPagedApiResponse>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<ListMovementItemPagedApiResponse>(null as any);
  }

  /**
   * Get a count of Movements
   * @param locationId (optional)
   * @param locationGroupId (optional)
   * @param userId (optional)
   * @param reviewStatus (optional)
   * @param isRemote (optional)
   * @param limit (optional)
   * @param page (optional)
   * @param sort (optional)
   * @param q (optional)
   * @param expand (optional)
   * @return Success
   */
  countMovements(
    request?: {
      startedAt: string;
      finishedAt: string;
      locationId?: string | undefined;
      locationGroupId?: string | undefined;
      userId?: string | undefined;
      reviewStatus?: string | undefined;
      isRemote?: boolean | undefined;
      limit?: number | undefined;
      page?: number | undefined;
      sort?: string | undefined;
      q?: string | undefined;
      expand?: string | undefined;
    },
    cancelToken?: CancelToken | undefined
  ): Promise<CountMovementResponseApiResponse> {
    let url_ = this.baseUrl + "/v1/movements/counts?";
    if (request?.startedAt === undefined || request?.startedAt === null)
      throw new Error(
        "The parameter 'startedAt' must be defined and cannot be null."
      );
    else
      url_ += "startedAt=" + encodeURIComponent("" + request?.startedAt) + "&";
    if (request?.finishedAt === undefined || request?.finishedAt === null)
      throw new Error(
        "The parameter 'finishedAt' must be defined and cannot be null."
      );
    else
      url_ +=
        "finishedAt=" + encodeURIComponent("" + request?.finishedAt) + "&";
    if (request?.locationId === null)
      throw new Error("The parameter 'locationId' cannot be null.");
    else if (request?.locationId !== undefined)
      url_ +=
        "locationId=" + encodeURIComponent("" + request?.locationId) + "&";
    if (request?.locationGroupId === null)
      throw new Error("The parameter 'locationGroupId' cannot be null.");
    else if (request?.locationGroupId !== undefined)
      url_ +=
        "locationGroupId=" +
        encodeURIComponent("" + request?.locationGroupId) +
        "&";
    if (request?.userId === null)
      throw new Error("The parameter 'userId' cannot be null.");
    else if (request?.userId !== undefined)
      url_ += "userId=" + encodeURIComponent("" + request?.userId) + "&";
    if (request?.reviewStatus === null)
      throw new Error("The parameter 'reviewStatus' cannot be null.");
    else if (request?.reviewStatus !== undefined)
      url_ +=
        "reviewStatus=" + encodeURIComponent("" + request?.reviewStatus) + "&";
    if (request?.isRemote === null)
      throw new Error("The parameter 'isRemote' cannot be null.");
    else if (request?.isRemote !== undefined)
      url_ += "isRemote=" + encodeURIComponent("" + request?.isRemote) + "&";
    if (request?.limit === null)
      throw new Error("The parameter 'limit' cannot be null.");
    else if (request?.limit !== undefined)
      url_ += "limit=" + encodeURIComponent("" + request?.limit) + "&";
    if (request?.page === null)
      throw new Error("The parameter 'page' cannot be null.");
    else if (request?.page !== undefined)
      url_ += "page=" + encodeURIComponent("" + request?.page) + "&";
    if (request?.sort === null)
      throw new Error("The parameter 'sort' cannot be null.");
    else if (request?.sort !== undefined)
      url_ += "sort=" + encodeURIComponent("" + request?.sort) + "&";
    if (request?.q === null)
      throw new Error("The parameter 'q' cannot be null.");
    else if (request?.q !== undefined)
      url_ += "q=" + encodeURIComponent("" + request?.q) + "&";
    if (request?.expand === null)
      throw new Error("The parameter 'expand' cannot be null.");
    else if (request?.expand !== undefined)
      url_ += "expand=" + encodeURIComponent("" + request?.expand) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processCountMovements(_response);
      });
  }

  protected processCountMovements(
    response: AxiosResponse
  ): Promise<CountMovementResponseApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<CountMovementResponseApiResponse>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<CountMovementResponseApiResponse>(null as any);
  }

  /**
   * Create MsGraphWebHook
   * @param validationToken (optional)
   * @return Success
   * @deprecated
   */
  createMsGraphWebHook(
    request?: { validationToken?: string | undefined },
    cancelToken?: CancelToken | undefined
  ): Promise<MsGraphWebHookNotificationsResponse> {
    let url_ = this.baseUrl + "/v1/msgraphwebhooks?";
    if (request?.validationToken === null)
      throw new Error("The parameter 'validationToken' cannot be null.");
    else if (request?.validationToken !== undefined)
      url_ +=
        "validationToken=" +
        encodeURIComponent("" + request?.validationToken) +
        "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "POST",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processCreateMsGraphWebHook(_response);
      });
  }

  protected processCreateMsGraphWebHook(
    response: AxiosResponse
  ): Promise<MsGraphWebHookNotificationsResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<MsGraphWebHookNotificationsResponse>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = JSON.parse(resultData400);
      return throwException(
        "Bad Request",
        status,
        _responseText,
        _headers,
        result400
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<MsGraphWebHookNotificationsResponse>(null as any);
  }

  /**
   * Create MsGraphWebHook
   * @param id company pk
   * @param validationToken (optional)
   * @return Success
   */
  createMsGraphWebHook2(
    request?: { id: string; validationToken?: string | undefined },
    cancelToken?: CancelToken | undefined
  ): Promise<MsGraphWebHookNotificationsResponse> {
    let url_ = this.baseUrl + "/v1/msgraphwebhooks/{id}?";
    if (request?.id === undefined || request?.id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + request?.id));
    if (request?.validationToken === null)
      throw new Error("The parameter 'validationToken' cannot be null.");
    else if (request?.validationToken !== undefined)
      url_ +=
        "validationToken=" +
        encodeURIComponent("" + request?.validationToken) +
        "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "POST",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processCreateMsGraphWebHook2(_response);
      });
  }

  protected processCreateMsGraphWebHook2(
    response: AxiosResponse
  ): Promise<MsGraphWebHookNotificationsResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<MsGraphWebHookNotificationsResponse>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = JSON.parse(resultData400);
      return throwException(
        "Bad Request",
        status,
        _responseText,
        _headers,
        result400
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<MsGraphWebHookNotificationsResponse>(null as any);
  }

  /**
   * Get Plan by id
   * @return Success
   */
  getPlan(
    request?: { id: string },
    cancelToken?: CancelToken | undefined
  ): Promise<GetPlanResponseApiResponse> {
    let url_ = this.baseUrl + "/v1/plans/{id}";
    if (request?.id === undefined || request?.id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + request?.id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetPlan(_response);
      });
  }

  protected processGetPlan(
    response: AxiosResponse
  ): Promise<GetPlanResponseApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<GetPlanResponseApiResponse>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<GetPlanResponseApiResponse>(null as any);
  }

  /**
   * Get List of Plans
   * @param group (optional)
   * @param level (optional)
   * @param currency (optional)
   * @param frequency (optional)
   * @param limit (optional)
   * @param page (optional)
   * @param sort (optional)
   * @param q (optional)
   * @param expand (optional)
   * @return Success
   */
  listPlans(
    request?: {
      group?: string | undefined;
      level?: string | undefined;
      currency?: string | undefined;
      frequency?: string | undefined;
      limit?: number | undefined;
      page?: number | undefined;
      sort?: string | undefined;
      q?: string | undefined;
      expand?: string | undefined;
    },
    cancelToken?: CancelToken | undefined
  ): Promise<ListPlanItemPagedApiResponse> {
    let url_ = this.baseUrl + "/v1/plans?";
    if (request?.group === null)
      throw new Error("The parameter 'group' cannot be null.");
    else if (request?.group !== undefined)
      url_ += "group=" + encodeURIComponent("" + request?.group) + "&";
    if (request?.level === null)
      throw new Error("The parameter 'level' cannot be null.");
    else if (request?.level !== undefined)
      url_ += "level=" + encodeURIComponent("" + request?.level) + "&";
    if (request?.currency === null)
      throw new Error("The parameter 'currency' cannot be null.");
    else if (request?.currency !== undefined)
      url_ += "currency=" + encodeURIComponent("" + request?.currency) + "&";
    if (request?.frequency === null)
      throw new Error("The parameter 'frequency' cannot be null.");
    else if (request?.frequency !== undefined)
      url_ += "frequency=" + encodeURIComponent("" + request?.frequency) + "&";
    if (request?.limit === null)
      throw new Error("The parameter 'limit' cannot be null.");
    else if (request?.limit !== undefined)
      url_ += "limit=" + encodeURIComponent("" + request?.limit) + "&";
    if (request?.page === null)
      throw new Error("The parameter 'page' cannot be null.");
    else if (request?.page !== undefined)
      url_ += "page=" + encodeURIComponent("" + request?.page) + "&";
    if (request?.sort === null)
      throw new Error("The parameter 'sort' cannot be null.");
    else if (request?.sort !== undefined)
      url_ += "sort=" + encodeURIComponent("" + request?.sort) + "&";
    if (request?.q === null)
      throw new Error("The parameter 'q' cannot be null.");
    else if (request?.q !== undefined)
      url_ += "q=" + encodeURIComponent("" + request?.q) + "&";
    if (request?.expand === null)
      throw new Error("The parameter 'expand' cannot be null.");
    else if (request?.expand !== undefined)
      url_ += "expand=" + encodeURIComponent("" + request?.expand) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processListPlans(_response);
      });
  }

  protected processListPlans(
    response: AxiosResponse
  ): Promise<ListPlanItemPagedApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<ListPlanItemPagedApiResponse>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<ListPlanItemPagedApiResponse>(null as any);
  }

  /**
   * Get Preregistration by id
   * @param expand (optional)
   * @return Success
   */
  getPreregistration(
    request?: { id: string; expand?: string | undefined },
    cancelToken?: CancelToken | undefined
  ): Promise<GetPreregistrationResponseApiResponse> {
    let url_ = this.baseUrl + "/v1/preregistrations/{id}?";
    if (request?.id === undefined || request?.id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + request?.id));
    if (request?.expand === null)
      throw new Error("The parameter 'expand' cannot be null.");
    else if (request?.expand !== undefined)
      url_ += "expand=" + encodeURIComponent("" + request?.expand) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetPreregistration(_response);
      });
  }

  protected processGetPreregistration(
    response: AxiosResponse
  ): Promise<GetPreregistrationResponseApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<GetPreregistrationResponseApiResponse>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<GetPreregistrationResponseApiResponse>(null as any);
  }

  /**
   * Get List of Preregistrations
   * @param locationId (optional)
   * @param locationGroupId (optional)
   * @param fullName (optional)
   * @param companyName (optional)
   * @param startDate (optional)
   * @param endDate (optional)
   * @param limit (optional)
   * @param page (optional)
   * @param sort (optional)
   * @param q (optional)
   * @param expand (optional)
   * @return Success
   */
  listPreregistrations(
    request?: {
      locationId?: string | undefined;
      locationGroupId?: string | undefined;
      fullName?: string | undefined;
      companyName?: string | undefined;
      startDate?: string | undefined;
      endDate?: string | undefined;
      limit?: number | undefined;
      page?: number | undefined;
      sort?: string | undefined;
      q?: string | undefined;
      expand?: string | undefined;
    },
    cancelToken?: CancelToken | undefined
  ): Promise<ListPreregistrationsItemPagedApiResponse> {
    let url_ = this.baseUrl + "/v1/preregistrations?";
    if (request?.locationId === null)
      throw new Error("The parameter 'locationId' cannot be null.");
    else if (request?.locationId !== undefined)
      url_ +=
        "locationId=" + encodeURIComponent("" + request?.locationId) + "&";
    if (request?.locationGroupId === null)
      throw new Error("The parameter 'locationGroupId' cannot be null.");
    else if (request?.locationGroupId !== undefined)
      url_ +=
        "locationGroupId=" +
        encodeURIComponent("" + request?.locationGroupId) +
        "&";
    if (request?.fullName === null)
      throw new Error("The parameter 'fullName' cannot be null.");
    else if (request?.fullName !== undefined)
      url_ += "fullName=" + encodeURIComponent("" + request?.fullName) + "&";
    if (request?.companyName === null)
      throw new Error("The parameter 'companyName' cannot be null.");
    else if (request?.companyName !== undefined)
      url_ +=
        "companyName=" + encodeURIComponent("" + request?.companyName) + "&";
    if (request?.startDate === null)
      throw new Error("The parameter 'startDate' cannot be null.");
    else if (request?.startDate !== undefined)
      url_ += "startDate=" + encodeURIComponent("" + request?.startDate) + "&";
    if (request?.endDate === null)
      throw new Error("The parameter 'endDate' cannot be null.");
    else if (request?.endDate !== undefined)
      url_ += "endDate=" + encodeURIComponent("" + request?.endDate) + "&";
    if (request?.limit === null)
      throw new Error("The parameter 'limit' cannot be null.");
    else if (request?.limit !== undefined)
      url_ += "limit=" + encodeURIComponent("" + request?.limit) + "&";
    if (request?.page === null)
      throw new Error("The parameter 'page' cannot be null.");
    else if (request?.page !== undefined)
      url_ += "page=" + encodeURIComponent("" + request?.page) + "&";
    if (request?.sort === null)
      throw new Error("The parameter 'sort' cannot be null.");
    else if (request?.sort !== undefined)
      url_ += "sort=" + encodeURIComponent("" + request?.sort) + "&";
    if (request?.q === null)
      throw new Error("The parameter 'q' cannot be null.");
    else if (request?.q !== undefined)
      url_ += "q=" + encodeURIComponent("" + request?.q) + "&";
    if (request?.expand === null)
      throw new Error("The parameter 'expand' cannot be null.");
    else if (request?.expand !== undefined)
      url_ += "expand=" + encodeURIComponent("" + request?.expand) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processListPreregistrations(_response);
      });
  }

  protected processListPreregistrations(
    response: AxiosResponse
  ): Promise<ListPreregistrationsItemPagedApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<ListPreregistrationsItemPagedApiResponse>(
        result200
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<ListPreregistrationsItemPagedApiResponse>(
      null as any
    );
  }

  /**
   * Get Preregistration fields by id
   * @param limit (optional)
   * @param page (optional)
   * @param sort (optional)
   * @param q (optional)
   * @param expand (optional)
   * @return Success
   */
  getPreregistrationFields(
    request?: {
      id: string;
      limit?: number | undefined;
      page?: number | undefined;
      sort?: string | undefined;
      q?: string | undefined;
      expand?: string | undefined;
    },
    cancelToken?: CancelToken | undefined
  ): Promise<ListPreregistrationFieldsItemPagedApiResponse> {
    let url_ = this.baseUrl + "/v1/preregistrations/{id}/fields?";
    if (request?.id === undefined || request?.id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + request?.id));
    if (request?.limit === null)
      throw new Error("The parameter 'limit' cannot be null.");
    else if (request?.limit !== undefined)
      url_ += "limit=" + encodeURIComponent("" + request?.limit) + "&";
    if (request?.page === null)
      throw new Error("The parameter 'page' cannot be null.");
    else if (request?.page !== undefined)
      url_ += "page=" + encodeURIComponent("" + request?.page) + "&";
    if (request?.sort === null)
      throw new Error("The parameter 'sort' cannot be null.");
    else if (request?.sort !== undefined)
      url_ += "sort=" + encodeURIComponent("" + request?.sort) + "&";
    if (request?.q === null)
      throw new Error("The parameter 'q' cannot be null.");
    else if (request?.q !== undefined)
      url_ += "q=" + encodeURIComponent("" + request?.q) + "&";
    if (request?.expand === null)
      throw new Error("The parameter 'expand' cannot be null.");
    else if (request?.expand !== undefined)
      url_ += "expand=" + encodeURIComponent("" + request?.expand) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetPreregistrationFields(_response);
      });
  }

  protected processGetPreregistrationFields(
    response: AxiosResponse
  ): Promise<ListPreregistrationFieldsItemPagedApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<ListPreregistrationFieldsItemPagedApiResponse>(
        result200
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<ListPreregistrationFieldsItemPagedApiResponse>(
      null as any
    );
  }

  /**
   * Complete an Induction for a Preregistration
   * @return Success
   */
  preregistrationCompleteInduction(
    request?: { id: string; inductionId: string },
    cancelToken?: CancelToken | undefined
  ): Promise<CompleteInductionResponseApiResponse> {
    let url_ =
      this.baseUrl + "/v1/preregistrations/{id}/inductions/{inductionId}";
    if (request?.id === undefined || request?.id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + request?.id));
    if (request?.inductionId === undefined || request?.inductionId === null)
      throw new Error("The parameter 'inductionId' must be defined.");
    url_ = url_.replace(
      "{inductionId}",
      encodeURIComponent("" + request?.inductionId)
    );
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "POST",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processPreregistrationCompleteInduction(_response);
      });
  }

  protected processPreregistrationCompleteInduction(
    response: AxiosResponse
  ): Promise<CompleteInductionResponseApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<CompleteInductionResponseApiResponse>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<CompleteInductionResponseApiResponse>(null as any);
  }

  /**
   * Get List of completed Inductions for a Preregistration
   * @param limit (optional)
   * @param page (optional)
   * @param sort (optional)
   * @param q (optional)
   * @param expand (optional)
   * @return Success
   */
  listPreregistrationCompletedInductions(
    request?: {
      id: string;
      limit?: number | undefined;
      page?: number | undefined;
      sort?: string | undefined;
      q?: string | undefined;
      expand?: string | undefined;
    },
    cancelToken?: CancelToken | undefined
  ): Promise<ListPreregistrationInductionsItemPagedApiResponse> {
    let url_ = this.baseUrl + "/v1/preregistrations/{id}/inductions?";
    if (request?.id === undefined || request?.id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + request?.id));
    if (request?.limit === null)
      throw new Error("The parameter 'limit' cannot be null.");
    else if (request?.limit !== undefined)
      url_ += "limit=" + encodeURIComponent("" + request?.limit) + "&";
    if (request?.page === null)
      throw new Error("The parameter 'page' cannot be null.");
    else if (request?.page !== undefined)
      url_ += "page=" + encodeURIComponent("" + request?.page) + "&";
    if (request?.sort === null)
      throw new Error("The parameter 'sort' cannot be null.");
    else if (request?.sort !== undefined)
      url_ += "sort=" + encodeURIComponent("" + request?.sort) + "&";
    if (request?.q === null)
      throw new Error("The parameter 'q' cannot be null.");
    else if (request?.q !== undefined)
      url_ += "q=" + encodeURIComponent("" + request?.q) + "&";
    if (request?.expand === null)
      throw new Error("The parameter 'expand' cannot be null.");
    else if (request?.expand !== undefined)
      url_ += "expand=" + encodeURIComponent("" + request?.expand) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processListPreregistrationCompletedInductions(_response);
      });
  }

  protected processListPreregistrationCompletedInductions(
    response: AxiosResponse
  ): Promise<ListPreregistrationInductionsItemPagedApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<ListPreregistrationInductionsItemPagedApiResponse>(
        result200
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<ListPreregistrationInductionsItemPagedApiResponse>(
      null as any
    );
  }

  /**
   * Get CSV import template
   * @return Success
   */
  getPreregistrationCSVTemplate(
    request?: { visitorCategoryId: string; locationId: string },
    cancelToken?: CancelToken | undefined
  ): Promise<FileResponse> {
    let url_ = this.baseUrl + "/v1/preregistrations/import/template?";
    if (
      request?.visitorCategoryId === undefined ||
      request?.visitorCategoryId === null
    )
      throw new Error(
        "The parameter 'visitorCategoryId' must be defined and cannot be null."
      );
    else
      url_ +=
        "visitorCategoryId=" +
        encodeURIComponent("" + request?.visitorCategoryId) +
        "&";
    if (request?.locationId === undefined || request?.locationId === null)
      throw new Error(
        "The parameter 'locationId' must be defined and cannot be null."
      );
    else
      url_ +=
        "locationId=" + encodeURIComponent("" + request?.locationId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      responseType: "blob",
      method: "GET",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetPreregistrationCSVTemplate(_response);
      });
  }

  protected processGetPreregistrationCSVTemplate(
    response: AxiosResponse
  ): Promise<FileResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers["content-disposition"]
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return Promise.resolve({
        fileName: fileName,
        status: status,
        data: new Blob([response.data], {
          type: response.headers["content-type"],
        }),
        headers: _headers,
      });
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<FileResponse>(null as any);
  }

  /**
   * Import Preregistrations by CSV
   * @param notify (optional)
   * @param message (optional)
   * @param induction (optional)
   * @param file (optional)
   * @return Success
   */
  importPreregistrations(
    request?: {
      visitorCategoryId: string;
      locationId: string;
      reCaptchaResult: string;
      notify?: boolean | undefined;
      message?: string | undefined;
      induction?: boolean | undefined;
      file?: FileParameter | undefined;
    },
    cancelToken?: CancelToken | undefined
  ): Promise<ImportPreregistrationsResponseApiResponse> {
    let url_ = this.baseUrl + "/v1/preregistrations/import?";
    if (
      request?.visitorCategoryId === undefined ||
      request?.visitorCategoryId === null
    )
      throw new Error(
        "The parameter 'visitorCategoryId' must be defined and cannot be null."
      );
    else
      url_ +=
        "visitorCategoryId=" +
        encodeURIComponent("" + request?.visitorCategoryId) +
        "&";
    if (request?.locationId === undefined || request?.locationId === null)
      throw new Error(
        "The parameter 'locationId' must be defined and cannot be null."
      );
    else
      url_ +=
        "locationId=" + encodeURIComponent("" + request?.locationId) + "&";
    if (
      request?.reCaptchaResult === undefined ||
      request?.reCaptchaResult === null
    )
      throw new Error(
        "The parameter 'reCaptchaResult' must be defined and cannot be null."
      );
    else
      url_ +=
        "reCaptchaResult=" +
        encodeURIComponent("" + request?.reCaptchaResult) +
        "&";
    if (request?.notify === null)
      throw new Error("The parameter 'notify' cannot be null.");
    else if (request?.notify !== undefined)
      url_ += "notify=" + encodeURIComponent("" + request?.notify) + "&";
    if (request?.message === null)
      throw new Error("The parameter 'message' cannot be null.");
    else if (request?.message !== undefined)
      url_ += "message=" + encodeURIComponent("" + request?.message) + "&";
    if (request?.induction === null)
      throw new Error("The parameter 'induction' cannot be null.");
    else if (request?.induction !== undefined)
      url_ += "induction=" + encodeURIComponent("" + request?.induction) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = new FormData();
    if (request?.file === null || request?.file === undefined)
      throw new Error("The parameter 'file' cannot be null.");
    else
      content_.append(
        "file",
        request?.file.data,
        request?.file.fileName ? request?.file.fileName : "file"
      );

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processImportPreregistrations(_response);
      });
  }

  protected processImportPreregistrations(
    response: AxiosResponse
  ): Promise<ImportPreregistrationsResponseApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<ImportPreregistrationsResponseApiResponse>(
        result200
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<ImportPreregistrationsResponseApiResponse>(
      null as any
    );
  }

  /**
   * Get List of Regions
   * @return Success
   */
  listRegions(
    cancelToken?: CancelToken | undefined
  ): Promise<GetRegionResponseIEnumerableApiResponse> {
    let url_ = this.baseUrl + "/v1/regions";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processListRegions(_response);
      });
  }

  protected processListRegions(
    response: AxiosResponse
  ): Promise<GetRegionResponseIEnumerableApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<GetRegionResponseIEnumerableApiResponse>(
        result200
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<GetRegionResponseIEnumerableApiResponse>(
      null as any
    );
  }

  /**
   * Get Room by id
   * @return Success
   */
  getRoom(
    request?: { id: string },
    cancelToken?: CancelToken | undefined
  ): Promise<GetRoomResponseApiResponse> {
    let url_ = this.baseUrl + "/v1/rooms/{id}";
    if (request?.id === undefined || request?.id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + request?.id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetRoom(_response);
      });
  }

  protected processGetRoom(
    response: AxiosResponse
  ): Promise<GetRoomResponseApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<GetRoomResponseApiResponse>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = JSON.parse(resultData400);
      return throwException(
        "Bad Request",
        status,
        _responseText,
        _headers,
        result400
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<GetRoomResponseApiResponse>(null as any);
  }

  /**
   * Update Room
   * @param body (optional)
   * @return Success
   */
  updateRoom(
    request?: { id: string; body?: UpdateRoomRequest | undefined },
    cancelToken?: CancelToken | undefined
  ): Promise<UpdateRoomResponseApiResponse> {
    let url_ = this.baseUrl + "/v1/rooms/{id}";
    if (request?.id === undefined || request?.id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + request?.id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(request?.body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "PATCH",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processUpdateRoom(_response);
      });
  }

  protected processUpdateRoom(
    response: AxiosResponse
  ): Promise<UpdateRoomResponseApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<UpdateRoomResponseApiResponse>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = JSON.parse(resultData400);
      return throwException(
        "Bad Request",
        status,
        _responseText,
        _headers,
        result400
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<UpdateRoomResponseApiResponse>(null as any);
  }

  /**
   * Create or replace Room
   * @param body (optional)
   * @return Success
   */
  upsertRoom(
    request?: { id: string; body?: UpsertRoomRequest | undefined },
    cancelToken?: CancelToken | undefined
  ): Promise<UpsertRoomResponseApiResponse> {
    let url_ = this.baseUrl + "/v1/rooms/{id}";
    if (request?.id === undefined || request?.id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + request?.id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(request?.body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processUpsertRoom(_response);
      });
  }

  protected processUpsertRoom(
    response: AxiosResponse
  ): Promise<UpsertRoomResponseApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<UpsertRoomResponseApiResponse>(result200);
    } else if (status === 201) {
      const _responseText = response.data;
      let result201: any = null;
      let resultData201 = _responseText;
      result201 = JSON.parse(resultData201);
      return Promise.resolve<UpsertRoomResponseApiResponse>(result201);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = JSON.parse(resultData400);
      return throwException(
        "Bad Request",
        status,
        _responseText,
        _headers,
        result400
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<UpsertRoomResponseApiResponse>(null as any);
  }

  /**
   * Delete Room by id
   * @return Success
   */
  deleteRoom(
    request?: { id: string },
    cancelToken?: CancelToken | undefined
  ): Promise<DeleteRoomResponseApiResponse> {
    let url_ = this.baseUrl + "/v1/rooms/{id}";
    if (request?.id === undefined || request?.id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + request?.id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processDeleteRoom(_response);
      });
  }

  protected processDeleteRoom(
    response: AxiosResponse
  ): Promise<DeleteRoomResponseApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<DeleteRoomResponseApiResponse>(result200);
    } else if (status === 404) {
      const _responseText = response.data;
      let result404: any = null;
      let resultData404 = _responseText;
      result404 = JSON.parse(resultData404);
      return throwException(
        "Not Found",
        status,
        _responseText,
        _headers,
        result404
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<DeleteRoomResponseApiResponse>(null as any);
  }

  /**
   * Get Room for device
   * @return Success
   */
  getDeviceRoom(
    cancelToken?: CancelToken | undefined
  ): Promise<GetRoomResponseApiResponse> {
    let url_ = this.baseUrl + "/v1/rooms/device";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetDeviceRoom(_response);
      });
  }

  protected processGetDeviceRoom(
    response: AxiosResponse
  ): Promise<GetRoomResponseApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<GetRoomResponseApiResponse>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = JSON.parse(resultData400);
      return throwException(
        "Bad Request",
        status,
        _responseText,
        _headers,
        result400
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<GetRoomResponseApiResponse>(null as any);
  }

  /**
   * Get List of Rooms
   * @param limit (optional)
   * @param page (optional)
   * @param sort (optional)
   * @param q (optional)
   * @param expand (optional)
   * @return Success
   */
  listRooms(
    request?: {
      limit?: number | undefined;
      page?: number | undefined;
      sort?: string | undefined;
      q?: string | undefined;
      expand?: string | undefined;
    },
    cancelToken?: CancelToken | undefined
  ): Promise<ListRoomItemPagedApiResponse> {
    let url_ = this.baseUrl + "/v1/rooms?";
    if (request?.limit === null)
      throw new Error("The parameter 'limit' cannot be null.");
    else if (request?.limit !== undefined)
      url_ += "limit=" + encodeURIComponent("" + request?.limit) + "&";
    if (request?.page === null)
      throw new Error("The parameter 'page' cannot be null.");
    else if (request?.page !== undefined)
      url_ += "page=" + encodeURIComponent("" + request?.page) + "&";
    if (request?.sort === null)
      throw new Error("The parameter 'sort' cannot be null.");
    else if (request?.sort !== undefined)
      url_ += "sort=" + encodeURIComponent("" + request?.sort) + "&";
    if (request?.q === null)
      throw new Error("The parameter 'q' cannot be null.");
    else if (request?.q !== undefined)
      url_ += "q=" + encodeURIComponent("" + request?.q) + "&";
    if (request?.expand === null)
      throw new Error("The parameter 'expand' cannot be null.");
    else if (request?.expand !== undefined)
      url_ += "expand=" + encodeURIComponent("" + request?.expand) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processListRooms(_response);
      });
  }

  protected processListRooms(
    response: AxiosResponse
  ): Promise<ListRoomItemPagedApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<ListRoomItemPagedApiResponse>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = JSON.parse(resultData400);
      return throwException(
        "Bad Request",
        status,
        _responseText,
        _headers,
        result400
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<ListRoomItemPagedApiResponse>(null as any);
  }

  /**
   * Create Room
   * @param body (optional)
   * @return Success
   */
  createRoom(
    request?: { body?: CreateRoomRequest | undefined },
    cancelToken?: CancelToken | undefined
  ): Promise<CreateRoomResponseApiResponse> {
    let url_ = this.baseUrl + "/v1/rooms";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(request?.body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processCreateRoom(_response);
      });
  }

  protected processCreateRoom(
    response: AxiosResponse
  ): Promise<CreateRoomResponseApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 201) {
      const _responseText = response.data;
      let result201: any = null;
      let resultData201 = _responseText;
      result201 = JSON.parse(resultData201);
      return Promise.resolve<CreateRoomResponseApiResponse>(result201);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = JSON.parse(resultData400);
      return throwException(
        "Bad Request",
        status,
        _responseText,
        _headers,
        result400
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<CreateRoomResponseApiResponse>(null as any);
  }

  /**
   * Get Room Devices
   * @param limit (optional)
   * @param page (optional)
   * @param sort (optional)
   * @param q (optional)
   * @param expand (optional)
   * @return Success
   */
  get_Room_Devices(
    request?: {
      id: string;
      limit?: number | undefined;
      page?: number | undefined;
      sort?: string | undefined;
      q?: string | undefined;
      expand?: string | undefined;
    },
    cancelToken?: CancelToken | undefined
  ): Promise<ListRoomDevicesResponsePagedApiResponse> {
    let url_ = this.baseUrl + "/v1/rooms/{id}/devices?";
    if (request?.id === undefined || request?.id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + request?.id));
    if (request?.limit === null)
      throw new Error("The parameter 'limit' cannot be null.");
    else if (request?.limit !== undefined)
      url_ += "limit=" + encodeURIComponent("" + request?.limit) + "&";
    if (request?.page === null)
      throw new Error("The parameter 'page' cannot be null.");
    else if (request?.page !== undefined)
      url_ += "page=" + encodeURIComponent("" + request?.page) + "&";
    if (request?.sort === null)
      throw new Error("The parameter 'sort' cannot be null.");
    else if (request?.sort !== undefined)
      url_ += "sort=" + encodeURIComponent("" + request?.sort) + "&";
    if (request?.q === null)
      throw new Error("The parameter 'q' cannot be null.");
    else if (request?.q !== undefined)
      url_ += "q=" + encodeURIComponent("" + request?.q) + "&";
    if (request?.expand === null)
      throw new Error("The parameter 'expand' cannot be null.");
    else if (request?.expand !== undefined)
      url_ += "expand=" + encodeURIComponent("" + request?.expand) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_Room_Devices(_response);
      });
  }

  protected processGet_Room_Devices(
    response: AxiosResponse
  ): Promise<ListRoomDevicesResponsePagedApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<ListRoomDevicesResponsePagedApiResponse>(
        result200
      );
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = JSON.parse(resultData400);
      return throwException(
        "Bad Request",
        status,
        _responseText,
        _headers,
        result400
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<ListRoomDevicesResponsePagedApiResponse>(
      null as any
    );
  }

  /**
   * Create Room Device
   * @param body (optional)
   * @return Success
   */
  createRoomDevice(
    request?: { id: string; body?: CreateRoomDeviceRequest | undefined },
    cancelToken?: CancelToken | undefined
  ): Promise<CreateRoomDeviceResponseApiResponse> {
    let url_ = this.baseUrl + "/v1/rooms/{id}/device";
    if (request?.id === undefined || request?.id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + request?.id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(request?.body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processCreateRoomDevice(_response);
      });
  }

  protected processCreateRoomDevice(
    response: AxiosResponse
  ): Promise<CreateRoomDeviceResponseApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 201) {
      const _responseText = response.data;
      let result201: any = null;
      let resultData201 = _responseText;
      result201 = JSON.parse(resultData201);
      return Promise.resolve<CreateRoomDeviceResponseApiResponse>(result201);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = JSON.parse(resultData400);
      return throwException(
        "Bad Request",
        status,
        _responseText,
        _headers,
        result400
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<CreateRoomDeviceResponseApiResponse>(null as any);
  }

  /**
   * Bulk Remove Rooms
   * @param body (optional)
   * @return Success
   */
  removeRooms(
    request?: { body?: BulkDeleteRoomRequest | undefined },
    cancelToken?: CancelToken | undefined
  ): Promise<BulkDeleteRoomResponseApiResponse> {
    let url_ = this.baseUrl + "/v1/rooms/remove";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(request?.body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processRemoveRooms(_response);
      });
  }

  protected processRemoveRooms(
    response: AxiosResponse
  ): Promise<BulkDeleteRoomResponseApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<BulkDeleteRoomResponseApiResponse>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<BulkDeleteRoomResponseApiResponse>(null as any);
  }

  /**
   * Get a RoomCategory by id
   * @param locationGroupId (optional)
   * @param locationId (optional)
   * @return Success
   */
  getRoomCategory(
    request?: {
      id: string;
      locationGroupId?: string | undefined;
      locationId?: string | undefined;
    },
    cancelToken?: CancelToken | undefined
  ): Promise<GetRoomCategoryResponseApiResponse> {
    let url_ = this.baseUrl + "/v1/roomcategories/{id}?";
    if (request?.id === undefined || request?.id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + request?.id));
    if (request?.locationGroupId === null)
      throw new Error("The parameter 'locationGroupId' cannot be null.");
    else if (request?.locationGroupId !== undefined)
      url_ +=
        "locationGroupId=" +
        encodeURIComponent("" + request?.locationGroupId) +
        "&";
    if (request?.locationId === null)
      throw new Error("The parameter 'locationId' cannot be null.");
    else if (request?.locationId !== undefined)
      url_ +=
        "locationId=" + encodeURIComponent("" + request?.locationId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetRoomCategory(_response);
      });
  }

  protected processGetRoomCategory(
    response: AxiosResponse
  ): Promise<GetRoomCategoryResponseApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<GetRoomCategoryResponseApiResponse>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<GetRoomCategoryResponseApiResponse>(null as any);
  }

  /**
   * Update a RoomCategory
   * @param body (optional)
   * @return Success
   */
  updateRoomCategory(
    request?: { id: string; body?: UpdateRoomCategoryRequest | undefined },
    cancelToken?: CancelToken | undefined
  ): Promise<UpdateRoomCategoryResponseApiResponse> {
    let url_ = this.baseUrl + "/v1/roomcategories/{id}";
    if (request?.id === undefined || request?.id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + request?.id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(request?.body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "PATCH",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processUpdateRoomCategory(_response);
      });
  }

  protected processUpdateRoomCategory(
    response: AxiosResponse
  ): Promise<UpdateRoomCategoryResponseApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<UpdateRoomCategoryResponseApiResponse>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<UpdateRoomCategoryResponseApiResponse>(null as any);
  }

  /**
   * Get List of Available SpaceResources
   * @param spaceCategoryId (optional)
   * @param locationId (optional)
   * @param locationGroupId (optional)
   * @param levelId (optional)
   * @param features (optional)
   * @param zones (optional)
   * @param userId (optional)
   * @param spaceResourceId (optional)
   * @param spaceBookingId (optional)
   * @param limit (optional)
   * @param page (optional)
   * @param sort (optional)
   * @param q (optional)
   * @param expand (optional)
   * @return Success
   */
  listAvailableSpaceResources(
    request?: {
      startDateTime: Date;
      endDateTime: Date;
      spaceCategoryId?: string | undefined;
      locationId?: string | undefined;
      locationGroupId?: string | undefined;
      levelId?: string | undefined;
      features?: string | undefined;
      zones?: string | undefined;
      userId?: string | undefined;
      spaceResourceId?: string | undefined;
      spaceBookingId?: string | undefined;
      limit?: number | undefined;
      page?: number | undefined;
      sort?: string | undefined;
      q?: string | undefined;
      expand?: string | undefined;
    },
    cancelToken?: CancelToken | undefined
  ): Promise<ListSpaceAvailabilityItemPagedApiResponse> {
    let url_ = this.baseUrl + "/v1/spaceavailability?";
    if (request?.startDateTime === undefined || request?.startDateTime === null)
      throw new Error(
        "The parameter 'startDateTime' must be defined and cannot be null."
      );
    else
      url_ +=
        "startDateTime=" +
        encodeURIComponent(
          request?.startDateTime
            ? "" + request?.startDateTime.toISOString()
            : ""
        ) +
        "&";
    if (request?.endDateTime === undefined || request?.endDateTime === null)
      throw new Error(
        "The parameter 'endDateTime' must be defined and cannot be null."
      );
    else
      url_ +=
        "endDateTime=" +
        encodeURIComponent(
          request?.endDateTime ? "" + request?.endDateTime.toISOString() : ""
        ) +
        "&";
    if (request?.spaceCategoryId === null)
      throw new Error("The parameter 'spaceCategoryId' cannot be null.");
    else if (request?.spaceCategoryId !== undefined)
      url_ +=
        "spaceCategoryId=" +
        encodeURIComponent("" + request?.spaceCategoryId) +
        "&";
    if (request?.locationId === null)
      throw new Error("The parameter 'locationId' cannot be null.");
    else if (request?.locationId !== undefined)
      url_ +=
        "locationId=" + encodeURIComponent("" + request?.locationId) + "&";
    if (request?.locationGroupId === null)
      throw new Error("The parameter 'locationGroupId' cannot be null.");
    else if (request?.locationGroupId !== undefined)
      url_ +=
        "locationGroupId=" +
        encodeURIComponent("" + request?.locationGroupId) +
        "&";
    if (request?.levelId === null)
      throw new Error("The parameter 'levelId' cannot be null.");
    else if (request?.levelId !== undefined)
      url_ += "levelId=" + encodeURIComponent("" + request?.levelId) + "&";
    if (request?.features === null)
      throw new Error("The parameter 'features' cannot be null.");
    else if (request?.features !== undefined)
      url_ += "features=" + encodeURIComponent("" + request?.features) + "&";
    if (request?.zones === null)
      throw new Error("The parameter 'zones' cannot be null.");
    else if (request?.zones !== undefined)
      url_ += "zones=" + encodeURIComponent("" + request?.zones) + "&";
    if (request?.userId === null)
      throw new Error("The parameter 'userId' cannot be null.");
    else if (request?.userId !== undefined)
      url_ += "userId=" + encodeURIComponent("" + request?.userId) + "&";
    if (request?.spaceResourceId === null)
      throw new Error("The parameter 'spaceResourceId' cannot be null.");
    else if (request?.spaceResourceId !== undefined)
      url_ +=
        "spaceResourceId=" +
        encodeURIComponent("" + request?.spaceResourceId) +
        "&";
    if (request?.spaceBookingId === null)
      throw new Error("The parameter 'spaceBookingId' cannot be null.");
    else if (request?.spaceBookingId !== undefined)
      url_ +=
        "spaceBookingId=" +
        encodeURIComponent("" + request?.spaceBookingId) +
        "&";
    if (request?.limit === null)
      throw new Error("The parameter 'limit' cannot be null.");
    else if (request?.limit !== undefined)
      url_ += "limit=" + encodeURIComponent("" + request?.limit) + "&";
    if (request?.page === null)
      throw new Error("The parameter 'page' cannot be null.");
    else if (request?.page !== undefined)
      url_ += "page=" + encodeURIComponent("" + request?.page) + "&";
    if (request?.sort === null)
      throw new Error("The parameter 'sort' cannot be null.");
    else if (request?.sort !== undefined)
      url_ += "sort=" + encodeURIComponent("" + request?.sort) + "&";
    if (request?.q === null)
      throw new Error("The parameter 'q' cannot be null.");
    else if (request?.q !== undefined)
      url_ += "q=" + encodeURIComponent("" + request?.q) + "&";
    if (request?.expand === null)
      throw new Error("The parameter 'expand' cannot be null.");
    else if (request?.expand !== undefined)
      url_ += "expand=" + encodeURIComponent("" + request?.expand) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processListAvailableSpaceResources(_response);
      });
  }

  protected processListAvailableSpaceResources(
    response: AxiosResponse
  ): Promise<ListSpaceAvailabilityItemPagedApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<ListSpaceAvailabilityItemPagedApiResponse>(
        result200
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<ListSpaceAvailabilityItemPagedApiResponse>(
      null as any
    );
  }

  /**
   * Get Recurring Space Availability for a given Space Resource.
   * @param userId (optional)
   * @param until (optional)
   * @param count (optional)
   * @param spaceRecurringBookingId (optional)
   * @return Success
   */
  getRecurringSpaceAvailability(
    request?: {
      spaceResourceId: string;
      startTime: Date;
      endTime: Date;
      frequency: SpaceRecurringFrequency;
      userId?: string | undefined;
      until?: Date | undefined;
      count?: number | undefined;
      spaceRecurringBookingId?: string | undefined;
    },
    cancelToken?: CancelToken | undefined
  ): Promise<RecurringSpaceResourcesAvailabilityResponseApiResponse> {
    let url_ =
      this.baseUrl + "/v1/spaceavailability/{spaceResourceId}/recurring?";
    if (
      request?.spaceResourceId === undefined ||
      request?.spaceResourceId === null
    )
      throw new Error("The parameter 'spaceResourceId' must be defined.");
    url_ = url_.replace(
      "{spaceResourceId}",
      encodeURIComponent("" + request?.spaceResourceId)
    );
    if (request?.startTime === undefined || request?.startTime === null)
      throw new Error(
        "The parameter 'startTime' must be defined and cannot be null."
      );
    else
      url_ +=
        "startTime=" +
        encodeURIComponent(
          request?.startTime ? "" + request?.startTime.toISOString() : ""
        ) +
        "&";
    if (request?.endTime === undefined || request?.endTime === null)
      throw new Error(
        "The parameter 'endTime' must be defined and cannot be null."
      );
    else
      url_ +=
        "endTime=" +
        encodeURIComponent(
          request?.endTime ? "" + request?.endTime.toISOString() : ""
        ) +
        "&";
    if (request?.frequency === undefined || request?.frequency === null)
      throw new Error(
        "The parameter 'frequency' must be defined and cannot be null."
      );
    else
      url_ += "frequency=" + encodeURIComponent("" + request?.frequency) + "&";
    if (request?.userId === null)
      throw new Error("The parameter 'userId' cannot be null.");
    else if (request?.userId !== undefined)
      url_ += "userId=" + encodeURIComponent("" + request?.userId) + "&";
    if (request?.until === null)
      throw new Error("The parameter 'until' cannot be null.");
    else if (request?.until !== undefined)
      url_ +=
        "until=" +
        encodeURIComponent(
          request?.until ? "" + request?.until.toISOString() : ""
        ) +
        "&";
    if (request?.count === null)
      throw new Error("The parameter 'count' cannot be null.");
    else if (request?.count !== undefined)
      url_ += "count=" + encodeURIComponent("" + request?.count) + "&";
    if (request?.spaceRecurringBookingId === null)
      throw new Error(
        "The parameter 'spaceRecurringBookingId' cannot be null."
      );
    else if (request?.spaceRecurringBookingId !== undefined)
      url_ +=
        "spaceRecurringBookingId=" +
        encodeURIComponent("" + request?.spaceRecurringBookingId) +
        "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetRecurringSpaceAvailability(_response);
      });
  }

  protected processGetRecurringSpaceAvailability(
    response: AxiosResponse
  ): Promise<RecurringSpaceResourcesAvailabilityResponseApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<RecurringSpaceResourcesAvailabilityResponseApiResponse>(
        result200
      );
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = JSON.parse(resultData400);
      return throwException(
        "Bad Request",
        status,
        _responseText,
        _headers,
        result400
      );
    } else if (status === 422) {
      const _responseText = response.data;
      let result422: any = null;
      let resultData422 = _responseText;
      result422 = JSON.parse(resultData422);
      return throwException(
        "Client Error",
        status,
        _responseText,
        _headers,
        result422
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<RecurringSpaceResourcesAvailabilityResponseApiResponse>(
      null as any
    );
  }

  /**
   * Get SpaceBooking by id
   * @return Success
   */
  getSpaceBooking(
    request?: { id: string },
    cancelToken?: CancelToken | undefined
  ): Promise<GetSpaceBookingResponseApiResponse> {
    let url_ = this.baseUrl + "/v1/spacebookings/{id}";
    if (request?.id === undefined || request?.id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + request?.id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetSpaceBooking(_response);
      });
  }

  protected processGetSpaceBooking(
    response: AxiosResponse
  ): Promise<GetSpaceBookingResponseApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<GetSpaceBookingResponseApiResponse>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<GetSpaceBookingResponseApiResponse>(null as any);
  }

  /**
   * Upsert a SpaceBooking
   * @param body (optional)
   * @return Success
   */
  upsertSpaceBooking(
    request?: { id: string; body?: UpsertSpaceBookingRequest | undefined },
    cancelToken?: CancelToken | undefined
  ): Promise<CreateSpaceBookingResponseApiResponse> {
    let url_ = this.baseUrl + "/v1/spacebookings/{id}";
    if (request?.id === undefined || request?.id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + request?.id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(request?.body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processUpsertSpaceBooking(_response);
      });
  }

  protected processUpsertSpaceBooking(
    response: AxiosResponse
  ): Promise<CreateSpaceBookingResponseApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<CreateSpaceBookingResponseApiResponse>(result200);
    } else if (status === 201) {
      const _responseText = response.data;
      let result201: any = null;
      let resultData201 = _responseText;
      result201 = JSON.parse(resultData201);
      return Promise.resolve<CreateSpaceBookingResponseApiResponse>(result201);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<CreateSpaceBookingResponseApiResponse>(null as any);
  }

  /**
   * Update SpaceBooking
   * @param body (optional)
   * @return Success
   */
  updateSpaceBooking(
    request?: { id: string; body?: UpdateSpaceBookingRequest | undefined },
    cancelToken?: CancelToken | undefined
  ): Promise<UpdateSpaceBookingResponseApiResponse> {
    let url_ = this.baseUrl + "/v1/spacebookings/{id}";
    if (request?.id === undefined || request?.id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + request?.id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(request?.body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "PATCH",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processUpdateSpaceBooking(_response);
      });
  }

  protected processUpdateSpaceBooking(
    response: AxiosResponse
  ): Promise<UpdateSpaceBookingResponseApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<UpdateSpaceBookingResponseApiResponse>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<UpdateSpaceBookingResponseApiResponse>(null as any);
  }

  /**
   * Delete SpaceBooking by id
   * @return Success
   */
  deleteSpaceBooking(
    request?: { id: string },
    cancelToken?: CancelToken | undefined
  ): Promise<StringApiResponse> {
    let url_ = this.baseUrl + "/v1/spacebookings/{id}";
    if (request?.id === undefined || request?.id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + request?.id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processDeleteSpaceBooking(_response);
      });
  }

  protected processDeleteSpaceBooking(
    response: AxiosResponse
  ): Promise<StringApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<StringApiResponse>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<StringApiResponse>(null as any);
  }

  /**
   * Get Counts of SpaceBookings
   * @param levelId (optional)
   * @param spaceRecurringBookingId (optional)
   * @param startTime (optional)
   * @param endTime (optional)
   * @param includeInProgress (optional)
   * @return Success
   */
  countSpaceBookings(
    request?: {
      levelId?: string | undefined;
      spaceRecurringBookingId?: string | undefined;
      startTime?: Date | undefined;
      endTime?: Date | undefined;
      includeInProgress?: boolean | undefined;
    },
    cancelToken?: CancelToken | undefined
  ): Promise<SpaceBookingCountsApiResponse> {
    let url_ = this.baseUrl + "/v1/spacebookings/counts?";
    if (request?.levelId === null)
      throw new Error("The parameter 'levelId' cannot be null.");
    else if (request?.levelId !== undefined)
      url_ += "levelId=" + encodeURIComponent("" + request?.levelId) + "&";
    if (request?.spaceRecurringBookingId === null)
      throw new Error(
        "The parameter 'spaceRecurringBookingId' cannot be null."
      );
    else if (request?.spaceRecurringBookingId !== undefined)
      url_ +=
        "spaceRecurringBookingId=" +
        encodeURIComponent("" + request?.spaceRecurringBookingId) +
        "&";
    if (request?.startTime === null)
      throw new Error("The parameter 'startTime' cannot be null.");
    else if (request?.startTime !== undefined)
      url_ +=
        "startTime=" +
        encodeURIComponent(
          request?.startTime ? "" + request?.startTime.toISOString() : ""
        ) +
        "&";
    if (request?.endTime === null)
      throw new Error("The parameter 'endTime' cannot be null.");
    else if (request?.endTime !== undefined)
      url_ +=
        "endTime=" +
        encodeURIComponent(
          request?.endTime ? "" + request?.endTime.toISOString() : ""
        ) +
        "&";
    if (request?.includeInProgress === null)
      throw new Error("The parameter 'includeInProgress' cannot be null.");
    else if (request?.includeInProgress !== undefined)
      url_ +=
        "includeInProgress=" +
        encodeURIComponent("" + request?.includeInProgress) +
        "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processCountSpaceBookings(_response);
      });
  }

  protected processCountSpaceBookings(
    response: AxiosResponse
  ): Promise<SpaceBookingCountsApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<SpaceBookingCountsApiResponse>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<SpaceBookingCountsApiResponse>(null as any);
  }

  /**
   * Get a Filtered List of SpaceBookings
   * @param locationGroupId (optional)
   * @param locationId (optional)
   * @param startTime (optional)
   * @param endTime (optional)
   * @param levelId (optional)
   * @param spaceCategoryId (optional)
   * @param userId (optional)
   * @param spaceResourceId (optional)
   * @param includeInProgress (optional)
   * @param spaceRecurringBookingId (optional)
   * @param limit (optional)
   * @param page (optional)
   * @param sort (optional)
   * @param q (optional)
   * @param expand (optional)
   * @return Success
   */
  listSpaceBookings(
    request?: {
      locationGroupId?: string | undefined;
      locationId?: string | undefined;
      startTime?: string | undefined;
      endTime?: string | undefined;
      levelId?: string | undefined;
      spaceCategoryId?: string | undefined;
      userId?: string | undefined;
      spaceResourceId?: string | undefined;
      includeInProgress?: boolean | undefined;
      spaceRecurringBookingId?: string | undefined;
      limit?: number | undefined;
      page?: number | undefined;
      sort?: string | undefined;
      q?: string | undefined;
      expand?: string | undefined;
    },
    cancelToken?: CancelToken | undefined
  ): Promise<ListSpaceBookingItemPagedApiResponse> {
    let url_ = this.baseUrl + "/v1/spacebookings?";
    if (request?.locationGroupId === null)
      throw new Error("The parameter 'locationGroupId' cannot be null.");
    else if (request?.locationGroupId !== undefined)
      url_ +=
        "locationGroupId=" +
        encodeURIComponent("" + request?.locationGroupId) +
        "&";
    if (request?.locationId === null)
      throw new Error("The parameter 'locationId' cannot be null.");
    else if (request?.locationId !== undefined)
      url_ +=
        "locationId=" + encodeURIComponent("" + request?.locationId) + "&";
    if (request?.startTime === null)
      throw new Error("The parameter 'startTime' cannot be null.");
    else if (request?.startTime !== undefined)
      url_ += "startTime=" + encodeURIComponent("" + request?.startTime) + "&";
    if (request?.endTime === null)
      throw new Error("The parameter 'endTime' cannot be null.");
    else if (request?.endTime !== undefined)
      url_ += "endTime=" + encodeURIComponent("" + request?.endTime) + "&";
    if (request?.levelId === null)
      throw new Error("The parameter 'levelId' cannot be null.");
    else if (request?.levelId !== undefined)
      url_ += "levelId=" + encodeURIComponent("" + request?.levelId) + "&";
    if (request?.spaceCategoryId === null)
      throw new Error("The parameter 'spaceCategoryId' cannot be null.");
    else if (request?.spaceCategoryId !== undefined)
      url_ +=
        "spaceCategoryId=" +
        encodeURIComponent("" + request?.spaceCategoryId) +
        "&";
    if (request?.userId === null)
      throw new Error("The parameter 'userId' cannot be null.");
    else if (request?.userId !== undefined)
      url_ += "userId=" + encodeURIComponent("" + request?.userId) + "&";
    if (request?.spaceResourceId === null)
      throw new Error("The parameter 'spaceResourceId' cannot be null.");
    else if (request?.spaceResourceId !== undefined)
      url_ +=
        "spaceResourceId=" +
        encodeURIComponent("" + request?.spaceResourceId) +
        "&";
    if (request?.includeInProgress === null)
      throw new Error("The parameter 'includeInProgress' cannot be null.");
    else if (request?.includeInProgress !== undefined)
      url_ +=
        "includeInProgress=" +
        encodeURIComponent("" + request?.includeInProgress) +
        "&";
    if (request?.spaceRecurringBookingId === null)
      throw new Error(
        "The parameter 'spaceRecurringBookingId' cannot be null."
      );
    else if (request?.spaceRecurringBookingId !== undefined)
      url_ +=
        "spaceRecurringBookingId=" +
        encodeURIComponent("" + request?.spaceRecurringBookingId) +
        "&";
    if (request?.limit === null)
      throw new Error("The parameter 'limit' cannot be null.");
    else if (request?.limit !== undefined)
      url_ += "limit=" + encodeURIComponent("" + request?.limit) + "&";
    if (request?.page === null)
      throw new Error("The parameter 'page' cannot be null.");
    else if (request?.page !== undefined)
      url_ += "page=" + encodeURIComponent("" + request?.page) + "&";
    if (request?.sort === null)
      throw new Error("The parameter 'sort' cannot be null.");
    else if (request?.sort !== undefined)
      url_ += "sort=" + encodeURIComponent("" + request?.sort) + "&";
    if (request?.q === null)
      throw new Error("The parameter 'q' cannot be null.");
    else if (request?.q !== undefined)
      url_ += "q=" + encodeURIComponent("" + request?.q) + "&";
    if (request?.expand === null)
      throw new Error("The parameter 'expand' cannot be null.");
    else if (request?.expand !== undefined)
      url_ += "expand=" + encodeURIComponent("" + request?.expand) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processListSpaceBookings(_response);
      });
  }

  protected processListSpaceBookings(
    response: AxiosResponse
  ): Promise<ListSpaceBookingItemPagedApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<ListSpaceBookingItemPagedApiResponse>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<ListSpaceBookingItemPagedApiResponse>(null as any);
  }

  /**
   * Create SpaceBooking
   * @param body (optional)
   * @return Success
   */
  createSpaceBooking(
    request?: { body?: CreateSpaceBookingRequest | undefined },
    cancelToken?: CancelToken | undefined
  ): Promise<CreateSpaceBookingResponseApiResponse> {
    let url_ = this.baseUrl + "/v1/spacebookings";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(request?.body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processCreateSpaceBooking(_response);
      });
  }

  protected processCreateSpaceBooking(
    response: AxiosResponse
  ): Promise<CreateSpaceBookingResponseApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 201) {
      const _responseText = response.data;
      let result201: any = null;
      let resultData201 = _responseText;
      result201 = JSON.parse(resultData201);
      return Promise.resolve<CreateSpaceBookingResponseApiResponse>(result201);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<CreateSpaceBookingResponseApiResponse>(null as any);
  }

  /**
   * Check In booking
   * @param actionTime (optional)
   * @return Success
   */
  checkInSpaceBooking(
    request?: { id: string; actionTime?: Date | undefined },
    cancelToken?: CancelToken | undefined
  ): Promise<StringApiResponse> {
    let url_ = this.baseUrl + "/v1/spacebookings/{id}/checkin?";
    if (request?.id === undefined || request?.id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + request?.id));
    if (request?.actionTime === null)
      throw new Error("The parameter 'actionTime' cannot be null.");
    else if (request?.actionTime !== undefined)
      url_ +=
        "actionTime=" +
        encodeURIComponent(
          request?.actionTime ? "" + request?.actionTime.toISOString() : ""
        ) +
        "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "POST",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processCheckInSpaceBooking(_response);
      });
  }

  protected processCheckInSpaceBooking(
    response: AxiosResponse
  ): Promise<StringApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<StringApiResponse>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<StringApiResponse>(null as any);
  }

  /**
   * Check Out booking
   * @param actionTime (optional)
   * @return Success
   */
  checkOutSpaceBooking(
    request?: { id: string; actionTime?: Date | undefined },
    cancelToken?: CancelToken | undefined
  ): Promise<StringApiResponse> {
    let url_ = this.baseUrl + "/v1/spacebookings/{id}/checkout?";
    if (request?.id === undefined || request?.id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + request?.id));
    if (request?.actionTime === null)
      throw new Error("The parameter 'actionTime' cannot be null.");
    else if (request?.actionTime !== undefined)
      url_ +=
        "actionTime=" +
        encodeURIComponent(
          request?.actionTime ? "" + request?.actionTime.toISOString() : ""
        ) +
        "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "POST",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processCheckOutSpaceBooking(_response);
      });
  }

  protected processCheckOutSpaceBooking(
    response: AxiosResponse
  ): Promise<StringApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<StringApiResponse>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<StringApiResponse>(null as any);
  }

  /**
   * Get filtered space bookings export csv
   * @param locationGroupId (optional)
   * @param locationId (optional)
   * @param startTime (optional)
   * @param endTime (optional)
   * @param levelId (optional)
   * @param spaceCategoryId (optional)
   * @param userId (optional)
   * @param spaceResourceId (optional)
   * @param includeInProgress (optional)
   * @param spaceRecurringBookingId (optional)
   * @param limit (optional)
   * @param page (optional)
   * @param sort (optional)
   * @param q (optional)
   * @param expand (optional)
   * @return Success
   */
  downloadSpaceBookingsExport(
    request?: {
      locationGroupId?: string | undefined;
      locationId?: string | undefined;
      startTime?: string | undefined;
      endTime?: string | undefined;
      levelId?: string | undefined;
      spaceCategoryId?: string | undefined;
      userId?: string | undefined;
      spaceResourceId?: string | undefined;
      includeInProgress?: boolean | undefined;
      spaceRecurringBookingId?: string | undefined;
      limit?: number | undefined;
      page?: number | undefined;
      sort?: string | undefined;
      q?: string | undefined;
      expand?: string | undefined;
    },
    cancelToken?: CancelToken | undefined
  ): Promise<FileResponse> {
    let url_ = this.baseUrl + "/v1/spacebookings/export?";
    if (request?.locationGroupId === null)
      throw new Error("The parameter 'locationGroupId' cannot be null.");
    else if (request?.locationGroupId !== undefined)
      url_ +=
        "locationGroupId=" +
        encodeURIComponent("" + request?.locationGroupId) +
        "&";
    if (request?.locationId === null)
      throw new Error("The parameter 'locationId' cannot be null.");
    else if (request?.locationId !== undefined)
      url_ +=
        "locationId=" + encodeURIComponent("" + request?.locationId) + "&";
    if (request?.startTime === null)
      throw new Error("The parameter 'startTime' cannot be null.");
    else if (request?.startTime !== undefined)
      url_ += "startTime=" + encodeURIComponent("" + request?.startTime) + "&";
    if (request?.endTime === null)
      throw new Error("The parameter 'endTime' cannot be null.");
    else if (request?.endTime !== undefined)
      url_ += "endTime=" + encodeURIComponent("" + request?.endTime) + "&";
    if (request?.levelId === null)
      throw new Error("The parameter 'levelId' cannot be null.");
    else if (request?.levelId !== undefined)
      url_ += "levelId=" + encodeURIComponent("" + request?.levelId) + "&";
    if (request?.spaceCategoryId === null)
      throw new Error("The parameter 'spaceCategoryId' cannot be null.");
    else if (request?.spaceCategoryId !== undefined)
      url_ +=
        "spaceCategoryId=" +
        encodeURIComponent("" + request?.spaceCategoryId) +
        "&";
    if (request?.userId === null)
      throw new Error("The parameter 'userId' cannot be null.");
    else if (request?.userId !== undefined)
      url_ += "userId=" + encodeURIComponent("" + request?.userId) + "&";
    if (request?.spaceResourceId === null)
      throw new Error("The parameter 'spaceResourceId' cannot be null.");
    else if (request?.spaceResourceId !== undefined)
      url_ +=
        "spaceResourceId=" +
        encodeURIComponent("" + request?.spaceResourceId) +
        "&";
    if (request?.includeInProgress === null)
      throw new Error("The parameter 'includeInProgress' cannot be null.");
    else if (request?.includeInProgress !== undefined)
      url_ +=
        "includeInProgress=" +
        encodeURIComponent("" + request?.includeInProgress) +
        "&";
    if (request?.spaceRecurringBookingId === null)
      throw new Error(
        "The parameter 'spaceRecurringBookingId' cannot be null."
      );
    else if (request?.spaceRecurringBookingId !== undefined)
      url_ +=
        "spaceRecurringBookingId=" +
        encodeURIComponent("" + request?.spaceRecurringBookingId) +
        "&";
    if (request?.limit === null)
      throw new Error("The parameter 'limit' cannot be null.");
    else if (request?.limit !== undefined)
      url_ += "limit=" + encodeURIComponent("" + request?.limit) + "&";
    if (request?.page === null)
      throw new Error("The parameter 'page' cannot be null.");
    else if (request?.page !== undefined)
      url_ += "page=" + encodeURIComponent("" + request?.page) + "&";
    if (request?.sort === null)
      throw new Error("The parameter 'sort' cannot be null.");
    else if (request?.sort !== undefined)
      url_ += "sort=" + encodeURIComponent("" + request?.sort) + "&";
    if (request?.q === null)
      throw new Error("The parameter 'q' cannot be null.");
    else if (request?.q !== undefined)
      url_ += "q=" + encodeURIComponent("" + request?.q) + "&";
    if (request?.expand === null)
      throw new Error("The parameter 'expand' cannot be null.");
    else if (request?.expand !== undefined)
      url_ += "expand=" + encodeURIComponent("" + request?.expand) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      responseType: "blob",
      method: "GET",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processDownloadSpaceBookingsExport(_response);
      });
  }

  protected processDownloadSpaceBookingsExport(
    response: AxiosResponse
  ): Promise<FileResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers["content-disposition"]
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return Promise.resolve({
        fileName: fileName,
        status: status,
        data: new Blob([response.data], {
          type: response.headers["content-type"],
        }),
        headers: _headers,
      });
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<FileResponse>(null as any);
  }

  /**
   * Get a SpaceCategory by id
   * @param locationGroupId (optional)
   * @param locationId (optional)
   * @return Success
   */
  getSpaceCategory(
    request?: {
      id: string;
      locationGroupId?: string | undefined;
      locationId?: string | undefined;
    },
    cancelToken?: CancelToken | undefined
  ): Promise<GetSpaceCategoryResponseApiResponse> {
    let url_ = this.baseUrl + "/v1/spacecategories/{id}?";
    if (request?.id === undefined || request?.id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + request?.id));
    if (request?.locationGroupId === null)
      throw new Error("The parameter 'locationGroupId' cannot be null.");
    else if (request?.locationGroupId !== undefined)
      url_ +=
        "locationGroupId=" +
        encodeURIComponent("" + request?.locationGroupId) +
        "&";
    if (request?.locationId === null)
      throw new Error("The parameter 'locationId' cannot be null.");
    else if (request?.locationId !== undefined)
      url_ +=
        "locationId=" + encodeURIComponent("" + request?.locationId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetSpaceCategory(_response);
      });
  }

  protected processGetSpaceCategory(
    response: AxiosResponse
  ): Promise<GetSpaceCategoryResponseApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<GetSpaceCategoryResponseApiResponse>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<GetSpaceCategoryResponseApiResponse>(null as any);
  }

  /**
   * Update a SpaceCategory
   * @param body (optional)
   * @return Success
   */
  updateSpaceCategory(
    request?: { id: string; body?: UpdateSpaceCategoryRequest | undefined },
    cancelToken?: CancelToken | undefined
  ): Promise<UpdateSpaceCategoryResponseApiResponse> {
    let url_ = this.baseUrl + "/v1/spacecategories/{id}";
    if (request?.id === undefined || request?.id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + request?.id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(request?.body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "PATCH",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processUpdateSpaceCategory(_response);
      });
  }

  protected processUpdateSpaceCategory(
    response: AxiosResponse
  ): Promise<UpdateSpaceCategoryResponseApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<UpdateSpaceCategoryResponseApiResponse>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<UpdateSpaceCategoryResponseApiResponse>(null as any);
  }

  /**
   * Upsert a SpaceCategory
   * @param body (optional)
   * @return Success
   */
  upsertSpaceCategory(
    request?: { id: string; body?: UpsertSpaceCategoryRequest | undefined },
    cancelToken?: CancelToken | undefined
  ): Promise<UpsertSpaceCategoryResponseApiResponse> {
    let url_ = this.baseUrl + "/v1/spacecategories/{id}";
    if (request?.id === undefined || request?.id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + request?.id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(request?.body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processUpsertSpaceCategory(_response);
      });
  }

  protected processUpsertSpaceCategory(
    response: AxiosResponse
  ): Promise<UpsertSpaceCategoryResponseApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<UpsertSpaceCategoryResponseApiResponse>(result200);
    } else if (status === 201) {
      const _responseText = response.data;
      let result201: any = null;
      let resultData201 = _responseText;
      result201 = JSON.parse(resultData201);
      return Promise.resolve<UpsertSpaceCategoryResponseApiResponse>(result201);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<UpsertSpaceCategoryResponseApiResponse>(null as any);
  }

  /**
   * Delete A SpaceCategory
   * @return Success
   */
  deleteSpaceCategory(
    request?: { id: string },
    cancelToken?: CancelToken | undefined
  ): Promise<DeleteSpaceCategoryResponseApiResponse> {
    let url_ = this.baseUrl + "/v1/spacecategories/{id}";
    if (request?.id === undefined || request?.id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + request?.id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processDeleteSpaceCategory(_response);
      });
  }

  protected processDeleteSpaceCategory(
    response: AxiosResponse
  ): Promise<DeleteSpaceCategoryResponseApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<DeleteSpaceCategoryResponseApiResponse>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<DeleteSpaceCategoryResponseApiResponse>(null as any);
  }

  /**
   * Get a List of SpaceCategories
   * @param limit (optional)
   * @param locationGroupId (optional)
   * @param locationId (optional)
   * @param page (optional)
   * @param sort (optional)
   * @param q (optional)
   * @param expand (optional)
   * @return Success
   */
  listSpaceCategories(
    request?: {
      limit?: number | undefined;
      locationGroupId?: string | undefined;
      locationId?: string | undefined;
      page?: number | undefined;
      sort?: string | undefined;
      q?: string | undefined;
      expand?: string | undefined;
    },
    cancelToken?: CancelToken | undefined
  ): Promise<ListSpaceCategoryItemPagedApiResponse> {
    let url_ = this.baseUrl + "/v1/spacecategories?";
    if (request?.limit === null)
      throw new Error("The parameter 'limit' cannot be null.");
    else if (request?.limit !== undefined)
      url_ += "limit=" + encodeURIComponent("" + request?.limit) + "&";
    if (request?.locationGroupId === null)
      throw new Error("The parameter 'locationGroupId' cannot be null.");
    else if (request?.locationGroupId !== undefined)
      url_ +=
        "locationGroupId=" +
        encodeURIComponent("" + request?.locationGroupId) +
        "&";
    if (request?.locationId === null)
      throw new Error("The parameter 'locationId' cannot be null.");
    else if (request?.locationId !== undefined)
      url_ +=
        "locationId=" + encodeURIComponent("" + request?.locationId) + "&";
    if (request?.page === null)
      throw new Error("The parameter 'page' cannot be null.");
    else if (request?.page !== undefined)
      url_ += "page=" + encodeURIComponent("" + request?.page) + "&";
    if (request?.sort === null)
      throw new Error("The parameter 'sort' cannot be null.");
    else if (request?.sort !== undefined)
      url_ += "sort=" + encodeURIComponent("" + request?.sort) + "&";
    if (request?.q === null)
      throw new Error("The parameter 'q' cannot be null.");
    else if (request?.q !== undefined)
      url_ += "q=" + encodeURIComponent("" + request?.q) + "&";
    if (request?.expand === null)
      throw new Error("The parameter 'expand' cannot be null.");
    else if (request?.expand !== undefined)
      url_ += "expand=" + encodeURIComponent("" + request?.expand) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processListSpaceCategories(_response);
      });
  }

  protected processListSpaceCategories(
    response: AxiosResponse
  ): Promise<ListSpaceCategoryItemPagedApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<ListSpaceCategoryItemPagedApiResponse>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<ListSpaceCategoryItemPagedApiResponse>(null as any);
  }

  /**
   * Create a SpaceCategory
   * @param body (optional)
   * @return Success
   */
  createSpaceCategory(
    request?: { body?: CreateSpaceCategoryRequest | undefined },
    cancelToken?: CancelToken | undefined
  ): Promise<CreateSpaceCategoryResponseApiResponse> {
    let url_ = this.baseUrl + "/v1/spacecategories";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(request?.body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processCreateSpaceCategory(_response);
      });
  }

  protected processCreateSpaceCategory(
    response: AxiosResponse
  ): Promise<CreateSpaceCategoryResponseApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 201) {
      const _responseText = response.data;
      let result201: any = null;
      let resultData201 = _responseText;
      result201 = JSON.parse(resultData201);
      return Promise.resolve<CreateSpaceCategoryResponseApiResponse>(result201);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<CreateSpaceCategoryResponseApiResponse>(null as any);
  }

  /**
   * Get SpaceFeature by id
   * @return Success
   */
  getSpaceFeature(
    request?: { id: string },
    cancelToken?: CancelToken | undefined
  ): Promise<GetSpaceFeatureResponseApiResponse> {
    let url_ = this.baseUrl + "/v1/spacefeatures/{id}";
    if (request?.id === undefined || request?.id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + request?.id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetSpaceFeature(_response);
      });
  }

  protected processGetSpaceFeature(
    response: AxiosResponse
  ): Promise<GetSpaceFeatureResponseApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<GetSpaceFeatureResponseApiResponse>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<GetSpaceFeatureResponseApiResponse>(null as any);
  }

  /**
   * Create or replace SpaceFeature
   * @param body (optional)
   * @return Success
   */
  upsertSpaceFeature(
    request?: { id: string; body?: UpsertSpaceFeatureRequest | undefined },
    cancelToken?: CancelToken | undefined
  ): Promise<UpsertSpaceFeatureResponseApiResponse> {
    let url_ = this.baseUrl + "/v1/spacefeatures/{id}";
    if (request?.id === undefined || request?.id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + request?.id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(request?.body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processUpsertSpaceFeature(_response);
      });
  }

  protected processUpsertSpaceFeature(
    response: AxiosResponse
  ): Promise<UpsertSpaceFeatureResponseApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<UpsertSpaceFeatureResponseApiResponse>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<UpsertSpaceFeatureResponseApiResponse>(null as any);
  }

  /**
   * Update SpaceFeature
   * @param body (optional)
   * @return Success
   */
  updateSpaceFeature(
    request?: { id: string; body?: UpdateSpaceFeatureRequest | undefined },
    cancelToken?: CancelToken | undefined
  ): Promise<UpdateSpaceFeatureResponseApiResponse> {
    let url_ = this.baseUrl + "/v1/spacefeatures/{id}";
    if (request?.id === undefined || request?.id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + request?.id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(request?.body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "PATCH",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processUpdateSpaceFeature(_response);
      });
  }

  protected processUpdateSpaceFeature(
    response: AxiosResponse
  ): Promise<UpdateSpaceFeatureResponseApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<UpdateSpaceFeatureResponseApiResponse>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<UpdateSpaceFeatureResponseApiResponse>(null as any);
  }

  /**
   * Delete SpaceFeature by id
   * @return Success
   */
  deleteSpaceFeature(
    request?: { id: string },
    cancelToken?: CancelToken | undefined
  ): Promise<StringApiResponse> {
    let url_ = this.baseUrl + "/v1/spacefeatures/{id}";
    if (request?.id === undefined || request?.id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + request?.id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processDeleteSpaceFeature(_response);
      });
  }

  protected processDeleteSpaceFeature(
    response: AxiosResponse
  ): Promise<StringApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<StringApiResponse>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<StringApiResponse>(null as any);
  }

  /**
   * Get List of SpaceFeatures
   * @param spaceCategoryId (optional)
   * @param limit (optional)
   * @param page (optional)
   * @param sort (optional)
   * @param q (optional)
   * @param expand (optional)
   * @return Success
   */
  listSpaceFeatures(
    request?: {
      spaceCategoryId?: string | undefined;
      limit?: number | undefined;
      page?: number | undefined;
      sort?: string | undefined;
      q?: string | undefined;
      expand?: string | undefined;
    },
    cancelToken?: CancelToken | undefined
  ): Promise<GetSpaceFeatureResponsePagedApiResponse> {
    let url_ = this.baseUrl + "/v1/spacefeatures?";
    if (request?.spaceCategoryId === null)
      throw new Error("The parameter 'spaceCategoryId' cannot be null.");
    else if (request?.spaceCategoryId !== undefined)
      url_ +=
        "spaceCategoryId=" +
        encodeURIComponent("" + request?.spaceCategoryId) +
        "&";
    if (request?.limit === null)
      throw new Error("The parameter 'limit' cannot be null.");
    else if (request?.limit !== undefined)
      url_ += "limit=" + encodeURIComponent("" + request?.limit) + "&";
    if (request?.page === null)
      throw new Error("The parameter 'page' cannot be null.");
    else if (request?.page !== undefined)
      url_ += "page=" + encodeURIComponent("" + request?.page) + "&";
    if (request?.sort === null)
      throw new Error("The parameter 'sort' cannot be null.");
    else if (request?.sort !== undefined)
      url_ += "sort=" + encodeURIComponent("" + request?.sort) + "&";
    if (request?.q === null)
      throw new Error("The parameter 'q' cannot be null.");
    else if (request?.q !== undefined)
      url_ += "q=" + encodeURIComponent("" + request?.q) + "&";
    if (request?.expand === null)
      throw new Error("The parameter 'expand' cannot be null.");
    else if (request?.expand !== undefined)
      url_ += "expand=" + encodeURIComponent("" + request?.expand) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processListSpaceFeatures(_response);
      });
  }

  protected processListSpaceFeatures(
    response: AxiosResponse
  ): Promise<GetSpaceFeatureResponsePagedApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<GetSpaceFeatureResponsePagedApiResponse>(
        result200
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<GetSpaceFeatureResponsePagedApiResponse>(
      null as any
    );
  }

  /**
   * Create SpaceFeature
   * @param body (optional)
   * @return Success
   */
  createSpaceFeature(
    request?: { body?: CreateSpaceFeatureRequest | undefined },
    cancelToken?: CancelToken | undefined
  ): Promise<CreateSpaceFeatureResponseApiResponse> {
    let url_ = this.baseUrl + "/v1/spacefeatures";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(request?.body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processCreateSpaceFeature(_response);
      });
  }

  protected processCreateSpaceFeature(
    response: AxiosResponse
  ): Promise<CreateSpaceFeatureResponseApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<CreateSpaceFeatureResponseApiResponse>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<CreateSpaceFeatureResponseApiResponse>(null as any);
  }

  /**
   * Create Recurring SpaceBooking
   * @param body (optional)
   * @return Success
   */
  createSpaceRecurringBooking(
    request?: { body?: CreateSpaceRecurringBookingRequest | undefined },
    cancelToken?: CancelToken | undefined
  ): Promise<CreateSpaceRecurringBookingResponseApiResponse> {
    let url_ = this.baseUrl + "/v1/spacerecurringbookings";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(request?.body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processCreateSpaceRecurringBooking(_response);
      });
  }

  protected processCreateSpaceRecurringBooking(
    response: AxiosResponse
  ): Promise<CreateSpaceRecurringBookingResponseApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 201) {
      const _responseText = response.data;
      let result201: any = null;
      let resultData201 = _responseText;
      result201 = JSON.parse(resultData201);
      return Promise.resolve<CreateSpaceRecurringBookingResponseApiResponse>(
        result201
      );
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = JSON.parse(resultData400);
      return throwException(
        "Bad Request",
        status,
        _responseText,
        _headers,
        result400
      );
    } else if (status === 403) {
      const _responseText = response.data;
      let result403: any = null;
      let resultData403 = _responseText;
      result403 = JSON.parse(resultData403);
      return throwException(
        "Forbidden",
        status,
        _responseText,
        _headers,
        result403
      );
    } else if (status === 422) {
      const _responseText = response.data;
      let result422: any = null;
      let resultData422 = _responseText;
      result422 = JSON.parse(resultData422);
      return throwException(
        "Client Error",
        status,
        _responseText,
        _headers,
        result422
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<CreateSpaceRecurringBookingResponseApiResponse>(
      null as any
    );
  }

  /**
   * Update SpaceRecurringBooking
   * @param body (optional)
   * @return Success
   */
  updateSpaceRecurringBooking(
    request?: {
      id: string;
      body?: UpdateSpaceRecurringBookingRequest | undefined;
    },
    cancelToken?: CancelToken | undefined
  ): Promise<UpdateSpaceRecurringBookingResponseApiResponse> {
    let url_ = this.baseUrl + "/v1/spacerecurringbookings/{id}";
    if (request?.id === undefined || request?.id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + request?.id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(request?.body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "PATCH",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processUpdateSpaceRecurringBooking(_response);
      });
  }

  protected processUpdateSpaceRecurringBooking(
    response: AxiosResponse
  ): Promise<UpdateSpaceRecurringBookingResponseApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<UpdateSpaceRecurringBookingResponseApiResponse>(
        result200
      );
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = JSON.parse(resultData400);
      return throwException(
        "Bad Request",
        status,
        _responseText,
        _headers,
        result400
      );
    } else if (status === 403) {
      const _responseText = response.data;
      let result403: any = null;
      let resultData403 = _responseText;
      result403 = JSON.parse(resultData403);
      return throwException(
        "Forbidden",
        status,
        _responseText,
        _headers,
        result403
      );
    } else if (status === 422) {
      const _responseText = response.data;
      let result422: any = null;
      let resultData422 = _responseText;
      result422 = JSON.parse(resultData422);
      return throwException(
        "Client Error",
        status,
        _responseText,
        _headers,
        result422
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<UpdateSpaceRecurringBookingResponseApiResponse>(
      null as any
    );
  }

  /**
   * Upsert SpaceRecurringBooking
   * @param body (optional)
   * @return Success
   */
  upsertSpaceRecurringBooking(
    request?: {
      id: string;
      body?: UpsertSpaceRecurringBookingRequest | undefined;
    },
    cancelToken?: CancelToken | undefined
  ): Promise<UpsertSpaceRecurringBookingResponseApiResponse> {
    let url_ = this.baseUrl + "/v1/spacerecurringbookings/{id}";
    if (request?.id === undefined || request?.id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + request?.id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(request?.body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processUpsertSpaceRecurringBooking(_response);
      });
  }

  protected processUpsertSpaceRecurringBooking(
    response: AxiosResponse
  ): Promise<UpsertSpaceRecurringBookingResponseApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<UpsertSpaceRecurringBookingResponseApiResponse>(
        result200
      );
    } else if (status === 201) {
      const _responseText = response.data;
      let result201: any = null;
      let resultData201 = _responseText;
      result201 = JSON.parse(resultData201);
      return Promise.resolve<UpsertSpaceRecurringBookingResponseApiResponse>(
        result201
      );
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = JSON.parse(resultData400);
      return throwException(
        "Bad Request",
        status,
        _responseText,
        _headers,
        result400
      );
    } else if (status === 403) {
      const _responseText = response.data;
      let result403: any = null;
      let resultData403 = _responseText;
      result403 = JSON.parse(resultData403);
      return throwException(
        "Forbidden",
        status,
        _responseText,
        _headers,
        result403
      );
    } else if (status === 422) {
      const _responseText = response.data;
      let result422: any = null;
      let resultData422 = _responseText;
      result422 = JSON.parse(resultData422);
      return throwException(
        "Client Error",
        status,
        _responseText,
        _headers,
        result422
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<UpsertSpaceRecurringBookingResponseApiResponse>(
      null as any
    );
  }

  /**
   * Delete SpaceRecurringBooking by id
   * @return Success
   */
  deleteSpaceRecurringBooking(
    request?: { id: string },
    cancelToken?: CancelToken | undefined
  ): Promise<DeleteSpaceRecurringBookingResponseApiResponse> {
    let url_ = this.baseUrl + "/v1/spacerecurringbookings/{id}";
    if (request?.id === undefined || request?.id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + request?.id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processDeleteSpaceRecurringBooking(_response);
      });
  }

  protected processDeleteSpaceRecurringBooking(
    response: AxiosResponse
  ): Promise<DeleteSpaceRecurringBookingResponseApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<DeleteSpaceRecurringBookingResponseApiResponse>(
        result200
      );
    } else if (status === 404) {
      const _responseText = response.data;
      let result404: any = null;
      let resultData404 = _responseText;
      result404 = JSON.parse(resultData404);
      return throwException(
        "Not Found",
        status,
        _responseText,
        _headers,
        result404
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<DeleteSpaceRecurringBookingResponseApiResponse>(
      null as any
    );
  }

  /**
   * Get SpaceResource by id
   * @return Success
   */
  getSpaceResource(
    request?: { id: string },
    cancelToken?: CancelToken | undefined
  ): Promise<GetSpaceResourceResponseApiResponse> {
    let url_ = this.baseUrl + "/v1/spaceresources/{id}";
    if (request?.id === undefined || request?.id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + request?.id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetSpaceResource(_response);
      });
  }

  protected processGetSpaceResource(
    response: AxiosResponse
  ): Promise<GetSpaceResourceResponseApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<GetSpaceResourceResponseApiResponse>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<GetSpaceResourceResponseApiResponse>(null as any);
  }

  /**
   * Upsert SpaceResource with id
   * @param body (optional)
   * @return Success
   */
  upsertSpaceResource(
    request?: { id: string; body?: CreateSpaceResourceRequest | undefined },
    cancelToken?: CancelToken | undefined
  ): Promise<UpsertSpaceResourceResponseApiResponse> {
    let url_ = this.baseUrl + "/v1/spaceresources/{id}";
    if (request?.id === undefined || request?.id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + request?.id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(request?.body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processUpsertSpaceResource(_response);
      });
  }

  protected processUpsertSpaceResource(
    response: AxiosResponse
  ): Promise<UpsertSpaceResourceResponseApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<UpsertSpaceResourceResponseApiResponse>(result200);
    } else if (status === 201) {
      const _responseText = response.data;
      let result201: any = null;
      let resultData201 = _responseText;
      result201 = JSON.parse(resultData201);
      return Promise.resolve<UpsertSpaceResourceResponseApiResponse>(result201);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<UpsertSpaceResourceResponseApiResponse>(null as any);
  }

  /**
   * Update SpaceResource
   * @param body (optional)
   * @return Success
   */
  updateSpaceResource(
    request?: { id: string; body?: UpdateSpaceResourceRequest | undefined },
    cancelToken?: CancelToken | undefined
  ): Promise<UpdateSpaceResourceResponseApiResponse> {
    let url_ = this.baseUrl + "/v1/spaceresources/{id}";
    if (request?.id === undefined || request?.id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + request?.id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(request?.body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "PATCH",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processUpdateSpaceResource(_response);
      });
  }

  protected processUpdateSpaceResource(
    response: AxiosResponse
  ): Promise<UpdateSpaceResourceResponseApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<UpdateSpaceResourceResponseApiResponse>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<UpdateSpaceResourceResponseApiResponse>(null as any);
  }

  /**
   * Delete SpaceResource by id
   * @return Success
   */
  deleteSpaceResource(
    request?: { id: string },
    cancelToken?: CancelToken | undefined
  ): Promise<DeleteSpaceResourceResponseApiResponse> {
    let url_ = this.baseUrl + "/v1/spaceresources/{id}";
    if (request?.id === undefined || request?.id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + request?.id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processDeleteSpaceResource(_response);
      });
  }

  protected processDeleteSpaceResource(
    response: AxiosResponse
  ): Promise<DeleteSpaceResourceResponseApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<DeleteSpaceResourceResponseApiResponse>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<DeleteSpaceResourceResponseApiResponse>(null as any);
  }

  /**
   * Get SpaceResource Restrictions by id
   * @param limit (optional)
   * @param page (optional)
   * @param sort (optional)
   * @param q (optional)
   * @param expand (optional)
   * @return Success
   */
  getSpaceResourceRestrictions(
    request?: {
      id: string;
      limit?: number | undefined;
      page?: number | undefined;
      sort?: string | undefined;
      q?: string | undefined;
      expand?: string | undefined;
    },
    cancelToken?: CancelToken | undefined
  ): Promise<GetSpaceResourceRestrictionResponsePagedApiResponse> {
    let url_ = this.baseUrl + "/v1/spaceresources/{id}/restrictions?";
    if (request?.id === undefined || request?.id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + request?.id));
    if (request?.limit === null)
      throw new Error("The parameter 'limit' cannot be null.");
    else if (request?.limit !== undefined)
      url_ += "limit=" + encodeURIComponent("" + request?.limit) + "&";
    if (request?.page === null)
      throw new Error("The parameter 'page' cannot be null.");
    else if (request?.page !== undefined)
      url_ += "page=" + encodeURIComponent("" + request?.page) + "&";
    if (request?.sort === null)
      throw new Error("The parameter 'sort' cannot be null.");
    else if (request?.sort !== undefined)
      url_ += "sort=" + encodeURIComponent("" + request?.sort) + "&";
    if (request?.q === null)
      throw new Error("The parameter 'q' cannot be null.");
    else if (request?.q !== undefined)
      url_ += "q=" + encodeURIComponent("" + request?.q) + "&";
    if (request?.expand === null)
      throw new Error("The parameter 'expand' cannot be null.");
    else if (request?.expand !== undefined)
      url_ += "expand=" + encodeURIComponent("" + request?.expand) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetSpaceResourceRestrictions(_response);
      });
  }

  protected processGetSpaceResourceRestrictions(
    response: AxiosResponse
  ): Promise<GetSpaceResourceRestrictionResponsePagedApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<GetSpaceResourceRestrictionResponsePagedApiResponse>(
        result200
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<GetSpaceResourceRestrictionResponsePagedApiResponse>(
      null as any
    );
  }

  /**
   * Get SpaceResource features by id
   * @param limit (optional)
   * @param page (optional)
   * @param sort (optional)
   * @param q (optional)
   * @param expand (optional)
   * @return Success
   */
  getSpaceResourceFeatures(
    request?: {
      id: string;
      limit?: number | undefined;
      page?: number | undefined;
      sort?: string | undefined;
      q?: string | undefined;
      expand?: string | undefined;
    },
    cancelToken?: CancelToken | undefined
  ): Promise<GetSpaceResourceFeatureResponsePagedApiResponse> {
    let url_ = this.baseUrl + "/v1/spaceresources/{id}/features?";
    if (request?.id === undefined || request?.id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + request?.id));
    if (request?.limit === null)
      throw new Error("The parameter 'limit' cannot be null.");
    else if (request?.limit !== undefined)
      url_ += "limit=" + encodeURIComponent("" + request?.limit) + "&";
    if (request?.page === null)
      throw new Error("The parameter 'page' cannot be null.");
    else if (request?.page !== undefined)
      url_ += "page=" + encodeURIComponent("" + request?.page) + "&";
    if (request?.sort === null)
      throw new Error("The parameter 'sort' cannot be null.");
    else if (request?.sort !== undefined)
      url_ += "sort=" + encodeURIComponent("" + request?.sort) + "&";
    if (request?.q === null)
      throw new Error("The parameter 'q' cannot be null.");
    else if (request?.q !== undefined)
      url_ += "q=" + encodeURIComponent("" + request?.q) + "&";
    if (request?.expand === null)
      throw new Error("The parameter 'expand' cannot be null.");
    else if (request?.expand !== undefined)
      url_ += "expand=" + encodeURIComponent("" + request?.expand) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetSpaceResourceFeatures(_response);
      });
  }

  protected processGetSpaceResourceFeatures(
    response: AxiosResponse
  ): Promise<GetSpaceResourceFeatureResponsePagedApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<GetSpaceResourceFeatureResponsePagedApiResponse>(
        result200
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<GetSpaceResourceFeatureResponsePagedApiResponse>(
      null as any
    );
  }

  /**
   * Get List of SpaceZones
   * @return Success
   */
  listSpaceResourceZones(
    request?: { id: string },
    cancelToken?: CancelToken | undefined
  ): Promise<ListSpaceZoneItemPagedApiResponse> {
    let url_ = this.baseUrl + "/v1/spaceresources/{id}/zones";
    if (request?.id === undefined || request?.id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + request?.id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processListSpaceResourceZones(_response);
      });
  }

  protected processListSpaceResourceZones(
    response: AxiosResponse
  ): Promise<ListSpaceZoneItemPagedApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<ListSpaceZoneItemPagedApiResponse>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<ListSpaceZoneItemPagedApiResponse>(null as any);
  }

  /**
   * Get Counts of SpaceResources
   * @param locationId (optional)
   * @param locationGroupId (optional)
   * @param levelId (optional)
   * @param spaceZoneId (optional)
   * @return Success
   */
  countSpaceResources(
    request?: {
      locationId?: string | undefined;
      locationGroupId?: string | undefined;
      levelId?: string | undefined;
      spaceZoneId?: string | undefined;
    },
    cancelToken?: CancelToken | undefined
  ): Promise<SpaceResourceCountsApiResponse> {
    let url_ = this.baseUrl + "/v1/spaceresources/counts?";
    if (request?.locationId === null)
      throw new Error("The parameter 'locationId' cannot be null.");
    else if (request?.locationId !== undefined)
      url_ +=
        "locationId=" + encodeURIComponent("" + request?.locationId) + "&";
    if (request?.locationGroupId === null)
      throw new Error("The parameter 'locationGroupId' cannot be null.");
    else if (request?.locationGroupId !== undefined)
      url_ +=
        "locationGroupId=" +
        encodeURIComponent("" + request?.locationGroupId) +
        "&";
    if (request?.levelId === null)
      throw new Error("The parameter 'levelId' cannot be null.");
    else if (request?.levelId !== undefined)
      url_ += "levelId=" + encodeURIComponent("" + request?.levelId) + "&";
    if (request?.spaceZoneId === null)
      throw new Error("The parameter 'spaceZoneId' cannot be null.");
    else if (request?.spaceZoneId !== undefined)
      url_ +=
        "spaceZoneId=" + encodeURIComponent("" + request?.spaceZoneId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processCountSpaceResources(_response);
      });
  }

  protected processCountSpaceResources(
    response: AxiosResponse
  ): Promise<SpaceResourceCountsApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<SpaceResourceCountsApiResponse>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<SpaceResourceCountsApiResponse>(null as any);
  }

  /**
   * Get List of SpaceResources
   * @param limit (optional)
   * @param locationId (optional)
   * @param locationGroupId (optional)
   * @param levelId (optional)
   * @param spaceCategoryId (optional)
   * @param capacity (optional)
   * @param features (optional)
   * @param zones (optional)
   * @param page (optional)
   * @param sort (optional)
   * @param q (optional)
   * @param expand (optional)
   * @return Success
   */
  listSpaceResources(
    request?: {
      limit?: number | undefined;
      locationId?: string | undefined;
      locationGroupId?: string | undefined;
      levelId?: string | undefined;
      spaceCategoryId?: string | undefined;
      capacity?: number | undefined;
      features?: string | undefined;
      zones?: string | undefined;
      page?: number | undefined;
      sort?: string | undefined;
      q?: string | undefined;
      expand?: string | undefined;
    },
    cancelToken?: CancelToken | undefined
  ): Promise<ListSpaceResourcesItemPagedApiResponse> {
    let url_ = this.baseUrl + "/v1/spaceresources?";
    if (request?.limit === null)
      throw new Error("The parameter 'limit' cannot be null.");
    else if (request?.limit !== undefined)
      url_ += "limit=" + encodeURIComponent("" + request?.limit) + "&";
    if (request?.locationId === null)
      throw new Error("The parameter 'locationId' cannot be null.");
    else if (request?.locationId !== undefined)
      url_ +=
        "locationId=" + encodeURIComponent("" + request?.locationId) + "&";
    if (request?.locationGroupId === null)
      throw new Error("The parameter 'locationGroupId' cannot be null.");
    else if (request?.locationGroupId !== undefined)
      url_ +=
        "locationGroupId=" +
        encodeURIComponent("" + request?.locationGroupId) +
        "&";
    if (request?.levelId === null)
      throw new Error("The parameter 'levelId' cannot be null.");
    else if (request?.levelId !== undefined)
      url_ += "levelId=" + encodeURIComponent("" + request?.levelId) + "&";
    if (request?.spaceCategoryId === null)
      throw new Error("The parameter 'spaceCategoryId' cannot be null.");
    else if (request?.spaceCategoryId !== undefined)
      url_ +=
        "spaceCategoryId=" +
        encodeURIComponent("" + request?.spaceCategoryId) +
        "&";
    if (request?.capacity === null)
      throw new Error("The parameter 'capacity' cannot be null.");
    else if (request?.capacity !== undefined)
      url_ += "capacity=" + encodeURIComponent("" + request?.capacity) + "&";
    if (request?.features === null)
      throw new Error("The parameter 'features' cannot be null.");
    else if (request?.features !== undefined)
      url_ += "features=" + encodeURIComponent("" + request?.features) + "&";
    if (request?.zones === null)
      throw new Error("The parameter 'zones' cannot be null.");
    else if (request?.zones !== undefined)
      url_ += "zones=" + encodeURIComponent("" + request?.zones) + "&";
    if (request?.page === null)
      throw new Error("The parameter 'page' cannot be null.");
    else if (request?.page !== undefined)
      url_ += "page=" + encodeURIComponent("" + request?.page) + "&";
    if (request?.sort === null)
      throw new Error("The parameter 'sort' cannot be null.");
    else if (request?.sort !== undefined)
      url_ += "sort=" + encodeURIComponent("" + request?.sort) + "&";
    if (request?.q === null)
      throw new Error("The parameter 'q' cannot be null.");
    else if (request?.q !== undefined)
      url_ += "q=" + encodeURIComponent("" + request?.q) + "&";
    if (request?.expand === null)
      throw new Error("The parameter 'expand' cannot be null.");
    else if (request?.expand !== undefined)
      url_ += "expand=" + encodeURIComponent("" + request?.expand) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processListSpaceResources(_response);
      });
  }

  protected processListSpaceResources(
    response: AxiosResponse
  ): Promise<ListSpaceResourcesItemPagedApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<ListSpaceResourcesItemPagedApiResponse>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<ListSpaceResourcesItemPagedApiResponse>(null as any);
  }

  /**
   * Create SpaceResource
   * @param body (optional)
   * @return Success
   */
  createSpaceResource(
    request?: { body?: CreateSpaceResourceRequest | undefined },
    cancelToken?: CancelToken | undefined
  ): Promise<CreateSpaceResourceResponseApiResponse> {
    let url_ = this.baseUrl + "/v1/spaceresources";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(request?.body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processCreateSpaceResource(_response);
      });
  }

  protected processCreateSpaceResource(
    response: AxiosResponse
  ): Promise<CreateSpaceResourceResponseApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 201) {
      const _responseText = response.data;
      let result201: any = null;
      let resultData201 = _responseText;
      result201 = JSON.parse(resultData201);
      return Promise.resolve<CreateSpaceResourceResponseApiResponse>(result201);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<CreateSpaceResourceResponseApiResponse>(null as any);
  }

  /**
   * Import SpaceResources by CSV
   * @param locationId (optional)
   * @param dryRun (optional)
   * @param file (optional)
   * @return Success
   */
  importSpaceResource(
    request?: {
      locationId?: string | undefined;
      dryRun?: boolean | undefined;
      file?: FileParameter | undefined;
    },
    cancelToken?: CancelToken | undefined
  ): Promise<ImportSpaceResourceResponseApiResponse> {
    let url_ = this.baseUrl + "/v1/spaceresources/import?";
    if (request?.locationId === null)
      throw new Error("The parameter 'locationId' cannot be null.");
    else if (request?.locationId !== undefined)
      url_ +=
        "locationId=" + encodeURIComponent("" + request?.locationId) + "&";
    if (request?.dryRun === null)
      throw new Error("The parameter 'dryRun' cannot be null.");
    else if (request?.dryRun !== undefined)
      url_ += "dryRun=" + encodeURIComponent("" + request?.dryRun) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = new FormData();
    if (request?.file === null || request?.file === undefined)
      throw new Error("The parameter 'file' cannot be null.");
    else
      content_.append(
        "file",
        request?.file.data,
        request?.file.fileName ? request?.file.fileName : "file"
      );

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processImportSpaceResource(_response);
      });
  }

  protected processImportSpaceResource(
    response: AxiosResponse
  ): Promise<ImportSpaceResourceResponseApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<ImportSpaceResourceResponseApiResponse>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<ImportSpaceResourceResponseApiResponse>(null as any);
  }

  /**
   * Get downloaded CSV template
   * @return Success
   */
  getSpaceResourceCSVTemplate(
    cancelToken?: CancelToken | undefined
  ): Promise<FileResponse> {
    let url_ = this.baseUrl + "/v1/spaceresources/import/template";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      responseType: "blob",
      method: "GET",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetSpaceResourceCSVTemplate(_response);
      });
  }

  protected processGetSpaceResourceCSVTemplate(
    response: AxiosResponse
  ): Promise<FileResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers["content-disposition"]
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return Promise.resolve({
        fileName: fileName,
        status: status,
        data: new Blob([response.data], {
          type: response.headers["content-type"],
        }),
        headers: _headers,
      });
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<FileResponse>(null as any);
  }

  /**
   * Get Level Map image with SpaceResource position
   * @return Success
   */
  getSpaceResourceMapImage(
    request?: { id: string },
    cancelToken?: CancelToken | undefined
  ): Promise<FileResponse> {
    let url_ = this.baseUrl + "/v1/spaceresources/{id}/map";
    if (request?.id === undefined || request?.id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + request?.id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      responseType: "blob",
      method: "GET",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetSpaceResourceMapImage(_response);
      });
  }

  protected processGetSpaceResourceMapImage(
    response: AxiosResponse
  ): Promise<FileResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers["content-disposition"]
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return Promise.resolve({
        fileName: fileName,
        status: status,
        data: new Blob([response.data], {
          type: response.headers["content-type"],
        }),
        headers: _headers,
      });
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<FileResponse>(null as any);
  }

  /**
   * Get a QR Code for the SpaceResource
   * @return Success
   */
  getSpaceResourceQRCode(
    request?: { id: string },
    cancelToken?: CancelToken | undefined
  ): Promise<FileResponse> {
    let url_ = this.baseUrl + "/v1/spaceresources/{id}/qr";
    if (request?.id === undefined || request?.id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + request?.id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      responseType: "blob",
      method: "GET",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetSpaceResourceQRCode(_response);
      });
  }

  protected processGetSpaceResourceQRCode(
    response: AxiosResponse
  ): Promise<FileResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers["content-disposition"]
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return Promise.resolve({
        fileName: fileName,
        status: status,
        data: new Blob([response.data], {
          type: response.headers["content-type"],
        }),
        headers: _headers,
      });
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<FileResponse>(null as any);
  }

  /**
   * Generate QR Codes for multiple SpaceResources
   * @param format L7120, L7159, L7160, 94106, 94107, 94207, 94237
   * @param spaceResourceIds (optional)
   * @param locationId (optional)
   * @param locationGroupId (optional)
   * @param levelId (optional)
   * @param spaceCategoryId (optional)
   * @return Success
   */
  listSpaceResourceQRCodes(
    request?: {
      format: string;
      spaceResourceIds?: string[] | undefined;
      locationId?: string | undefined;
      locationGroupId?: string | undefined;
      levelId?: string | undefined;
      spaceCategoryId?: string | undefined;
    },
    cancelToken?: CancelToken | undefined
  ): Promise<FileResponse> {
    let url_ = this.baseUrl + "/v1/spaceresources/qr/{format}?";
    if (request?.format === undefined || request?.format === null)
      throw new Error("The parameter 'format' must be defined.");
    url_ = url_.replace("{format}", encodeURIComponent("" + request?.format));
    if (request?.spaceResourceIds === null)
      throw new Error("The parameter 'spaceResourceIds' cannot be null.");
    else if (request?.spaceResourceIds !== undefined)
      request?.spaceResourceIds &&
        request?.spaceResourceIds.forEach((item) => {
          url_ += "spaceResourceIds=" + encodeURIComponent("" + item) + "&";
        });
    if (request?.locationId === null)
      throw new Error("The parameter 'locationId' cannot be null.");
    else if (request?.locationId !== undefined)
      url_ +=
        "locationId=" + encodeURIComponent("" + request?.locationId) + "&";
    if (request?.locationGroupId === null)
      throw new Error("The parameter 'locationGroupId' cannot be null.");
    else if (request?.locationGroupId !== undefined)
      url_ +=
        "locationGroupId=" +
        encodeURIComponent("" + request?.locationGroupId) +
        "&";
    if (request?.levelId === null)
      throw new Error("The parameter 'levelId' cannot be null.");
    else if (request?.levelId !== undefined)
      url_ += "levelId=" + encodeURIComponent("" + request?.levelId) + "&";
    if (request?.spaceCategoryId === null)
      throw new Error("The parameter 'spaceCategoryId' cannot be null.");
    else if (request?.spaceCategoryId !== undefined)
      url_ +=
        "spaceCategoryId=" +
        encodeURIComponent("" + request?.spaceCategoryId) +
        "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      responseType: "blob",
      method: "GET",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processListSpaceResourceQRCodes(_response);
      });
  }

  protected processListSpaceResourceQRCodes(
    response: AxiosResponse
  ): Promise<FileResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers["content-disposition"]
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return Promise.resolve({
        fileName: fileName,
        status: status,
        data: new Blob([response.data], {
          type: response.headers["content-type"],
        }),
        headers: _headers,
      });
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<FileResponse>(null as any);
  }

  /**
   * Bulk delete SpaceResources
   * @param body (optional)
   * @return Success
   */
  removeSpaceResources(
    request?: { body?: BulkSpaceResourceRequest | undefined },
    cancelToken?: CancelToken | undefined
  ): Promise<BulkSpaceResourceResponseApiResponse> {
    let url_ = this.baseUrl + "/v1/spaceresources/remove";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(request?.body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processRemoveSpaceResources(_response);
      });
  }

  protected processRemoveSpaceResources(
    response: AxiosResponse
  ): Promise<BulkSpaceResourceResponseApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<BulkSpaceResourceResponseApiResponse>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<BulkSpaceResourceResponseApiResponse>(null as any);
  }

  /**
   * Get Filered Space Resources with Bookings
   * @param startTime (optional)
   * @param endTime (optional)
   * @param limit (optional)
   * @param locationId (optional)
   * @param locationGroupId (optional)
   * @param levelId (optional)
   * @param spaceCategoryId (optional)
   * @param capacity (optional)
   * @param features (optional)
   * @param zones (optional)
   * @param page (optional)
   * @param sort (optional)
   * @param q (optional)
   * @param expand (optional)
   * @return Success
   */
  spaceResourcesWithBookings(
    request?: {
      startTime?: Date | undefined;
      endTime?: Date | undefined;
      limit?: number | undefined;
      locationId?: string | undefined;
      locationGroupId?: string | undefined;
      levelId?: string | undefined;
      spaceCategoryId?: string | undefined;
      capacity?: number | undefined;
      features?: string | undefined;
      zones?: string | undefined;
      page?: number | undefined;
      sort?: string | undefined;
      q?: string | undefined;
      expand?: string | undefined;
    },
    cancelToken?: CancelToken | undefined
  ): Promise<GetSpaceResourcesWithBookingsResponsePagedApiResponse> {
    let url_ = this.baseUrl + "/v1/spaceresources/spaceresourceswithbookings?";
    if (request?.startTime === null)
      throw new Error("The parameter 'startTime' cannot be null.");
    else if (request?.startTime !== undefined)
      url_ +=
        "startTime=" +
        encodeURIComponent(
          request?.startTime ? "" + request?.startTime.toISOString() : ""
        ) +
        "&";
    if (request?.endTime === null)
      throw new Error("The parameter 'endTime' cannot be null.");
    else if (request?.endTime !== undefined)
      url_ +=
        "endTime=" +
        encodeURIComponent(
          request?.endTime ? "" + request?.endTime.toISOString() : ""
        ) +
        "&";
    if (request?.limit === null)
      throw new Error("The parameter 'limit' cannot be null.");
    else if (request?.limit !== undefined)
      url_ += "limit=" + encodeURIComponent("" + request?.limit) + "&";
    if (request?.locationId === null)
      throw new Error("The parameter 'locationId' cannot be null.");
    else if (request?.locationId !== undefined)
      url_ +=
        "locationId=" + encodeURIComponent("" + request?.locationId) + "&";
    if (request?.locationGroupId === null)
      throw new Error("The parameter 'locationGroupId' cannot be null.");
    else if (request?.locationGroupId !== undefined)
      url_ +=
        "locationGroupId=" +
        encodeURIComponent("" + request?.locationGroupId) +
        "&";
    if (request?.levelId === null)
      throw new Error("The parameter 'levelId' cannot be null.");
    else if (request?.levelId !== undefined)
      url_ += "levelId=" + encodeURIComponent("" + request?.levelId) + "&";
    if (request?.spaceCategoryId === null)
      throw new Error("The parameter 'spaceCategoryId' cannot be null.");
    else if (request?.spaceCategoryId !== undefined)
      url_ +=
        "spaceCategoryId=" +
        encodeURIComponent("" + request?.spaceCategoryId) +
        "&";
    if (request?.capacity === null)
      throw new Error("The parameter 'capacity' cannot be null.");
    else if (request?.capacity !== undefined)
      url_ += "capacity=" + encodeURIComponent("" + request?.capacity) + "&";
    if (request?.features === null)
      throw new Error("The parameter 'features' cannot be null.");
    else if (request?.features !== undefined)
      url_ += "features=" + encodeURIComponent("" + request?.features) + "&";
    if (request?.zones === null)
      throw new Error("The parameter 'zones' cannot be null.");
    else if (request?.zones !== undefined)
      url_ += "zones=" + encodeURIComponent("" + request?.zones) + "&";
    if (request?.page === null)
      throw new Error("The parameter 'page' cannot be null.");
    else if (request?.page !== undefined)
      url_ += "page=" + encodeURIComponent("" + request?.page) + "&";
    if (request?.sort === null)
      throw new Error("The parameter 'sort' cannot be null.");
    else if (request?.sort !== undefined)
      url_ += "sort=" + encodeURIComponent("" + request?.sort) + "&";
    if (request?.q === null)
      throw new Error("The parameter 'q' cannot be null.");
    else if (request?.q !== undefined)
      url_ += "q=" + encodeURIComponent("" + request?.q) + "&";
    if (request?.expand === null)
      throw new Error("The parameter 'expand' cannot be null.");
    else if (request?.expand !== undefined)
      url_ += "expand=" + encodeURIComponent("" + request?.expand) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processSpaceResourcesWithBookings(_response);
      });
  }

  protected processSpaceResourcesWithBookings(
    response: AxiosResponse
  ): Promise<GetSpaceResourcesWithBookingsResponsePagedApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<GetSpaceResourcesWithBookingsResponsePagedApiResponse>(
        result200
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<GetSpaceResourcesWithBookingsResponsePagedApiResponse>(
      null as any
    );
  }

  /**
   * Get SpaceZone by id
   * @return Success
   */
  getSpaceZone(
    request?: { id: string },
    cancelToken?: CancelToken | undefined
  ): Promise<GetSpaceZoneResponseApiResponse> {
    let url_ = this.baseUrl + "/v1/spacezones/{id}";
    if (request?.id === undefined || request?.id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + request?.id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetSpaceZone(_response);
      });
  }

  protected processGetSpaceZone(
    response: AxiosResponse
  ): Promise<GetSpaceZoneResponseApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<GetSpaceZoneResponseApiResponse>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<GetSpaceZoneResponseApiResponse>(null as any);
  }

  /**
   * Create or replace SpaceZone
   * @param body (optional)
   * @return Success
   */
  upsertSpaceZone(
    request?: { id: string; body?: UpsertSpaceZoneRequest | undefined },
    cancelToken?: CancelToken | undefined
  ): Promise<UpsertSpaceZoneResponseApiResponse> {
    let url_ = this.baseUrl + "/v1/spacezones/{id}";
    if (request?.id === undefined || request?.id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + request?.id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(request?.body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processUpsertSpaceZone(_response);
      });
  }

  protected processUpsertSpaceZone(
    response: AxiosResponse
  ): Promise<UpsertSpaceZoneResponseApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<UpsertSpaceZoneResponseApiResponse>(result200);
    } else if (status === 201) {
      const _responseText = response.data;
      let result201: any = null;
      let resultData201 = _responseText;
      result201 = JSON.parse(resultData201);
      return Promise.resolve<UpsertSpaceZoneResponseApiResponse>(result201);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<UpsertSpaceZoneResponseApiResponse>(null as any);
  }

  /**
   * Update SpaceZone
   * @param body (optional)
   * @return Success
   */
  updateSpaceZone(
    request?: { id: string; body?: UpdateSpaceZoneRequest | undefined },
    cancelToken?: CancelToken | undefined
  ): Promise<UpdateSpaceZoneResponseApiResponse> {
    let url_ = this.baseUrl + "/v1/spacezones/{id}";
    if (request?.id === undefined || request?.id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + request?.id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(request?.body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "PATCH",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processUpdateSpaceZone(_response);
      });
  }

  protected processUpdateSpaceZone(
    response: AxiosResponse
  ): Promise<UpdateSpaceZoneResponseApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<UpdateSpaceZoneResponseApiResponse>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<UpdateSpaceZoneResponseApiResponse>(null as any);
  }

  /**
   * Delete SpaceZone by id
   * @return Success
   */
  deleteSpaceZone(
    request?: { id: string },
    cancelToken?: CancelToken | undefined
  ): Promise<StringApiResponse> {
    let url_ = this.baseUrl + "/v1/spacezones/{id}";
    if (request?.id === undefined || request?.id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + request?.id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processDeleteSpaceZone(_response);
      });
  }

  protected processDeleteSpaceZone(
    response: AxiosResponse
  ): Promise<StringApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<StringApiResponse>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<StringApiResponse>(null as any);
  }

  /**
   * Get List of SpaceZones
   * @param levelId (optional)
   * @param spaceResourceId (optional)
   * @param limit (optional)
   * @param page (optional)
   * @param sort (optional)
   * @param q (optional)
   * @param expand (optional)
   * @return Success
   */
  listSpaceZones(
    request?: {
      levelId?: string | undefined;
      spaceResourceId?: string | undefined;
      limit?: number | undefined;
      page?: number | undefined;
      sort?: string | undefined;
      q?: string | undefined;
      expand?: string | undefined;
    },
    cancelToken?: CancelToken | undefined
  ): Promise<ListSpaceZoneItemPagedApiResponse> {
    let url_ = this.baseUrl + "/v1/spacezones?";
    if (request?.levelId === null)
      throw new Error("The parameter 'levelId' cannot be null.");
    else if (request?.levelId !== undefined)
      url_ += "levelId=" + encodeURIComponent("" + request?.levelId) + "&";
    if (request?.spaceResourceId === null)
      throw new Error("The parameter 'spaceResourceId' cannot be null.");
    else if (request?.spaceResourceId !== undefined)
      url_ +=
        "spaceResourceId=" +
        encodeURIComponent("" + request?.spaceResourceId) +
        "&";
    if (request?.limit === null)
      throw new Error("The parameter 'limit' cannot be null.");
    else if (request?.limit !== undefined)
      url_ += "limit=" + encodeURIComponent("" + request?.limit) + "&";
    if (request?.page === null)
      throw new Error("The parameter 'page' cannot be null.");
    else if (request?.page !== undefined)
      url_ += "page=" + encodeURIComponent("" + request?.page) + "&";
    if (request?.sort === null)
      throw new Error("The parameter 'sort' cannot be null.");
    else if (request?.sort !== undefined)
      url_ += "sort=" + encodeURIComponent("" + request?.sort) + "&";
    if (request?.q === null)
      throw new Error("The parameter 'q' cannot be null.");
    else if (request?.q !== undefined)
      url_ += "q=" + encodeURIComponent("" + request?.q) + "&";
    if (request?.expand === null)
      throw new Error("The parameter 'expand' cannot be null.");
    else if (request?.expand !== undefined)
      url_ += "expand=" + encodeURIComponent("" + request?.expand) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processListSpaceZones(_response);
      });
  }

  protected processListSpaceZones(
    response: AxiosResponse
  ): Promise<ListSpaceZoneItemPagedApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<ListSpaceZoneItemPagedApiResponse>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<ListSpaceZoneItemPagedApiResponse>(null as any);
  }

  /**
   * Create SpaceZone
   * @param body (optional)
   * @return Success
   */
  createSpaceZone(
    request?: { body?: CreateSpaceZoneRequest | undefined },
    cancelToken?: CancelToken | undefined
  ): Promise<BaseSpaceZoneResponseApiResponse> {
    let url_ = this.baseUrl + "/v1/spacezones";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(request?.body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processCreateSpaceZone(_response);
      });
  }

  protected processCreateSpaceZone(
    response: AxiosResponse
  ): Promise<BaseSpaceZoneResponseApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 201) {
      const _responseText = response.data;
      let result201: any = null;
      let resultData201 = _responseText;
      result201 = JSON.parse(resultData201);
      return Promise.resolve<BaseSpaceZoneResponseApiResponse>(result201);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<BaseSpaceZoneResponseApiResponse>(null as any);
  }

  /**
   * Get Subscription for Authorised Company
   * @param expand (optional)
   * @return Success
   */
  getSubscription(
    request?: { expand?: string | undefined },
    cancelToken?: CancelToken | undefined
  ): Promise<GetSubscriptionResponseApiResponse> {
    let url_ = this.baseUrl + "/v1/subscriptions?";
    if (request?.expand === null)
      throw new Error("The parameter 'expand' cannot be null.");
    else if (request?.expand !== undefined)
      url_ += "expand=" + encodeURIComponent("" + request?.expand) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetSubscription(_response);
      });
  }

  protected processGetSubscription(
    response: AxiosResponse
  ): Promise<GetSubscriptionResponseApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<GetSubscriptionResponseApiResponse>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<GetSubscriptionResponseApiResponse>(null as any);
  }

  /**
   * Get List of users
   * @param limit (optional)
   * @param locationId (optional)
   * @param locationGroupId (optional)
   * @param departmentId (optional)
   * @param since (optional)
   * @param page (optional)
   * @param sort (optional)
   * @param q (optional)
   * @param expand (optional)
   * @return Success
   */
  listUsers(
    request?: {
      limit?: number | undefined;
      locationId?: string | undefined;
      locationGroupId?: string | undefined;
      departmentId?: string | undefined;
      since?: string | undefined;
      page?: number | undefined;
      sort?: string | undefined;
      q?: string | undefined;
      expand?: string | undefined;
    },
    cancelToken?: CancelToken | undefined
  ): Promise<ListUsersItemPagedApiResponse> {
    let url_ = this.baseUrl + "/v1/users?";
    if (request?.limit === null)
      throw new Error("The parameter 'limit' cannot be null.");
    else if (request?.limit !== undefined)
      url_ += "limit=" + encodeURIComponent("" + request?.limit) + "&";
    if (request?.locationId === null)
      throw new Error("The parameter 'locationId' cannot be null.");
    else if (request?.locationId !== undefined)
      url_ +=
        "locationId=" + encodeURIComponent("" + request?.locationId) + "&";
    if (request?.locationGroupId === null)
      throw new Error("The parameter 'locationGroupId' cannot be null.");
    else if (request?.locationGroupId !== undefined)
      url_ +=
        "locationGroupId=" +
        encodeURIComponent("" + request?.locationGroupId) +
        "&";
    if (request?.departmentId === null)
      throw new Error("The parameter 'departmentId' cannot be null.");
    else if (request?.departmentId !== undefined)
      url_ +=
        "departmentId=" + encodeURIComponent("" + request?.departmentId) + "&";
    if (request?.since === null)
      throw new Error("The parameter 'since' cannot be null.");
    else if (request?.since !== undefined)
      url_ += "since=" + encodeURIComponent("" + request?.since) + "&";
    if (request?.page === null)
      throw new Error("The parameter 'page' cannot be null.");
    else if (request?.page !== undefined)
      url_ += "page=" + encodeURIComponent("" + request?.page) + "&";
    if (request?.sort === null)
      throw new Error("The parameter 'sort' cannot be null.");
    else if (request?.sort !== undefined)
      url_ += "sort=" + encodeURIComponent("" + request?.sort) + "&";
    if (request?.q === null)
      throw new Error("The parameter 'q' cannot be null.");
    else if (request?.q !== undefined)
      url_ += "q=" + encodeURIComponent("" + request?.q) + "&";
    if (request?.expand === null)
      throw new Error("The parameter 'expand' cannot be null.");
    else if (request?.expand !== undefined)
      url_ += "expand=" + encodeURIComponent("" + request?.expand) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processListUsers(_response);
      });
  }

  protected processListUsers(
    response: AxiosResponse
  ): Promise<ListUsersItemPagedApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<ListUsersItemPagedApiResponse>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<ListUsersItemPagedApiResponse>(null as any);
  }

  /**
   * Get user by id
   * @param expand (optional)
   * @return Success
   */
  getUser(
    request?: { id: string; expand?: string | undefined },
    cancelToken?: CancelToken | undefined
  ): Promise<GetUserResponseApiResponse> {
    let url_ = this.baseUrl + "/v1/users/{id}?";
    if (request?.id === undefined || request?.id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + request?.id));
    if (request?.expand === null)
      throw new Error("The parameter 'expand' cannot be null.");
    else if (request?.expand !== undefined)
      url_ += "expand=" + encodeURIComponent("" + request?.expand) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetUser(_response);
      });
  }

  protected processGetUser(
    response: AxiosResponse
  ): Promise<GetUserResponseApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<GetUserResponseApiResponse>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<GetUserResponseApiResponse>(null as any);
  }

  /**
   * Get user in/out/remote counts
   * @param locationId (optional)
   * @param locationGroupId (optional)
   * @return Success
   */
  getEmployeeCounts(
    request?: {
      locationId?: string | undefined;
      locationGroupId?: string | undefined;
    },
    cancelToken?: CancelToken | undefined
  ): Promise<GetUserInOutCountsResponseApiResponse> {
    let url_ = this.baseUrl + "/v1/users/counts?";
    if (request?.locationId === null)
      throw new Error("The parameter 'locationId' cannot be null.");
    else if (request?.locationId !== undefined)
      url_ +=
        "locationId=" + encodeURIComponent("" + request?.locationId) + "&";
    if (request?.locationGroupId === null)
      throw new Error("The parameter 'locationGroupId' cannot be null.");
    else if (request?.locationGroupId !== undefined)
      url_ +=
        "locationGroupId=" +
        encodeURIComponent("" + request?.locationGroupId) +
        "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetEmployeeCounts(_response);
      });
  }

  protected processGetEmployeeCounts(
    response: AxiosResponse
  ): Promise<GetUserInOutCountsResponseApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<GetUserInOutCountsResponseApiResponse>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<GetUserInOutCountsResponseApiResponse>(null as any);
  }

  /**
   * Get Visit by id
   * @param expand (optional)
   * @return Success
   */
  getVisit(
    request?: { id: string; expand?: string | undefined },
    cancelToken?: CancelToken | undefined
  ): Promise<GetVisitResponseApiResponse> {
    let url_ = this.baseUrl + "/v1/visits/{id}?";
    if (request?.id === undefined || request?.id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + request?.id));
    if (request?.expand === null)
      throw new Error("The parameter 'expand' cannot be null.");
    else if (request?.expand !== undefined)
      url_ += "expand=" + encodeURIComponent("" + request?.expand) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetVisit(_response);
      });
  }

  protected processGetVisit(
    response: AxiosResponse
  ): Promise<GetVisitResponseApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<GetVisitResponseApiResponse>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<GetVisitResponseApiResponse>(null as any);
  }

  /**
   * Get Visit fields by id
   * @param limit (optional)
   * @param page (optional)
   * @param sort (optional)
   * @param q (optional)
   * @param expand (optional)
   * @return Success
   */
  getVisitFields(
    request?: {
      id: string;
      limit?: number | undefined;
      page?: number | undefined;
      sort?: string | undefined;
      q?: string | undefined;
      expand?: string | undefined;
    },
    cancelToken?: CancelToken | undefined
  ): Promise<ListVisitFieldsItemPagedApiResponse> {
    let url_ = this.baseUrl + "/v1/visits/{id}/fields?";
    if (request?.id === undefined || request?.id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + request?.id));
    if (request?.limit === null)
      throw new Error("The parameter 'limit' cannot be null.");
    else if (request?.limit !== undefined)
      url_ += "limit=" + encodeURIComponent("" + request?.limit) + "&";
    if (request?.page === null)
      throw new Error("The parameter 'page' cannot be null.");
    else if (request?.page !== undefined)
      url_ += "page=" + encodeURIComponent("" + request?.page) + "&";
    if (request?.sort === null)
      throw new Error("The parameter 'sort' cannot be null.");
    else if (request?.sort !== undefined)
      url_ += "sort=" + encodeURIComponent("" + request?.sort) + "&";
    if (request?.q === null)
      throw new Error("The parameter 'q' cannot be null.");
    else if (request?.q !== undefined)
      url_ += "q=" + encodeURIComponent("" + request?.q) + "&";
    if (request?.expand === null)
      throw new Error("The parameter 'expand' cannot be null.");
    else if (request?.expand !== undefined)
      url_ += "expand=" + encodeURIComponent("" + request?.expand) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetVisitFields(_response);
      });
  }

  protected processGetVisitFields(
    response: AxiosResponse
  ): Promise<ListVisitFieldsItemPagedApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<ListVisitFieldsItemPagedApiResponse>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<ListVisitFieldsItemPagedApiResponse>(null as any);
  }

  /**
   * Get List of completed Inductions for a Visit
   * @param limit (optional)
   * @param page (optional)
   * @param sort (optional)
   * @param q (optional)
   * @param expand (optional)
   * @return Success
   */
  listVisitCompletedInductions(
    request?: {
      id: string;
      limit?: number | undefined;
      page?: number | undefined;
      sort?: string | undefined;
      q?: string | undefined;
      expand?: string | undefined;
    },
    cancelToken?: CancelToken | undefined
  ): Promise<ListVisitInductionsItemPagedApiResponse> {
    let url_ = this.baseUrl + "/v1/visits/{id}/inductions?";
    if (request?.id === undefined || request?.id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + request?.id));
    if (request?.limit === null)
      throw new Error("The parameter 'limit' cannot be null.");
    else if (request?.limit !== undefined)
      url_ += "limit=" + encodeURIComponent("" + request?.limit) + "&";
    if (request?.page === null)
      throw new Error("The parameter 'page' cannot be null.");
    else if (request?.page !== undefined)
      url_ += "page=" + encodeURIComponent("" + request?.page) + "&";
    if (request?.sort === null)
      throw new Error("The parameter 'sort' cannot be null.");
    else if (request?.sort !== undefined)
      url_ += "sort=" + encodeURIComponent("" + request?.sort) + "&";
    if (request?.q === null)
      throw new Error("The parameter 'q' cannot be null.");
    else if (request?.q !== undefined)
      url_ += "q=" + encodeURIComponent("" + request?.q) + "&";
    if (request?.expand === null)
      throw new Error("The parameter 'expand' cannot be null.");
    else if (request?.expand !== undefined)
      url_ += "expand=" + encodeURIComponent("" + request?.expand) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processListVisitCompletedInductions(_response);
      });
  }

  protected processListVisitCompletedInductions(
    response: AxiosResponse
  ): Promise<ListVisitInductionsItemPagedApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<ListVisitInductionsItemPagedApiResponse>(
        result200
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<ListVisitInductionsItemPagedApiResponse>(
      null as any
    );
  }

  /**
   * Get a List of Vists
   * @param locationId (optional)
   * @param locationGroupId (optional)
   * @param hostId (optional)
   * @param reviewStatus (optional)
   * @param complete (optional)
   * @param categoryName (optional)
   * @param limit (optional)
   * @param page (optional)
   * @param sort (optional)
   * @param q (optional)
   * @param expand (optional)
   * @return Success
   */
  listVisits(
    request?: {
      startedAt: string;
      finishedAt: string;
      locationId?: string | undefined;
      locationGroupId?: string | undefined;
      hostId?: string | undefined;
      reviewStatus?: string | undefined;
      complete?: boolean | undefined;
      categoryName?: string | undefined;
      limit?: number | undefined;
      page?: number | undefined;
      sort?: string | undefined;
      q?: string | undefined;
      expand?: string | undefined;
    },
    cancelToken?: CancelToken | undefined
  ): Promise<ListVisitItemPagedApiResponse> {
    let url_ = this.baseUrl + "/v1/visits?";
    if (request?.startedAt === undefined || request?.startedAt === null)
      throw new Error(
        "The parameter 'startedAt' must be defined and cannot be null."
      );
    else
      url_ += "startedAt=" + encodeURIComponent("" + request?.startedAt) + "&";
    if (request?.finishedAt === undefined || request?.finishedAt === null)
      throw new Error(
        "The parameter 'finishedAt' must be defined and cannot be null."
      );
    else
      url_ +=
        "finishedAt=" + encodeURIComponent("" + request?.finishedAt) + "&";
    if (request?.locationId === null)
      throw new Error("The parameter 'locationId' cannot be null.");
    else if (request?.locationId !== undefined)
      url_ +=
        "locationId=" + encodeURIComponent("" + request?.locationId) + "&";
    if (request?.locationGroupId === null)
      throw new Error("The parameter 'locationGroupId' cannot be null.");
    else if (request?.locationGroupId !== undefined)
      url_ +=
        "locationGroupId=" +
        encodeURIComponent("" + request?.locationGroupId) +
        "&";
    if (request?.hostId === null)
      throw new Error("The parameter 'hostId' cannot be null.");
    else if (request?.hostId !== undefined)
      url_ += "hostId=" + encodeURIComponent("" + request?.hostId) + "&";
    if (request?.reviewStatus === null)
      throw new Error("The parameter 'reviewStatus' cannot be null.");
    else if (request?.reviewStatus !== undefined)
      url_ +=
        "reviewStatus=" + encodeURIComponent("" + request?.reviewStatus) + "&";
    if (request?.complete === null)
      throw new Error("The parameter 'complete' cannot be null.");
    else if (request?.complete !== undefined)
      url_ += "complete=" + encodeURIComponent("" + request?.complete) + "&";
    if (request?.categoryName === null)
      throw new Error("The parameter 'categoryName' cannot be null.");
    else if (request?.categoryName !== undefined)
      url_ +=
        "categoryName=" + encodeURIComponent("" + request?.categoryName) + "&";
    if (request?.limit === null)
      throw new Error("The parameter 'limit' cannot be null.");
    else if (request?.limit !== undefined)
      url_ += "limit=" + encodeURIComponent("" + request?.limit) + "&";
    if (request?.page === null)
      throw new Error("The parameter 'page' cannot be null.");
    else if (request?.page !== undefined)
      url_ += "page=" + encodeURIComponent("" + request?.page) + "&";
    if (request?.sort === null)
      throw new Error("The parameter 'sort' cannot be null.");
    else if (request?.sort !== undefined)
      url_ += "sort=" + encodeURIComponent("" + request?.sort) + "&";
    if (request?.q === null)
      throw new Error("The parameter 'q' cannot be null.");
    else if (request?.q !== undefined)
      url_ += "q=" + encodeURIComponent("" + request?.q) + "&";
    if (request?.expand === null)
      throw new Error("The parameter 'expand' cannot be null.");
    else if (request?.expand !== undefined)
      url_ += "expand=" + encodeURIComponent("" + request?.expand) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processListVisits(_response);
      });
  }

  protected processListVisits(
    response: AxiosResponse
  ): Promise<ListVisitItemPagedApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<ListVisitItemPagedApiResponse>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<ListVisitItemPagedApiResponse>(null as any);
  }

  /**
   * Get a count of Visits
   * @param locationId (optional)
   * @param locationGroupId (optional)
   * @param hostId (optional)
   * @param reviewStatus (optional)
   * @param complete (optional)
   * @param categoryName (optional)
   * @param limit (optional)
   * @param page (optional)
   * @param sort (optional)
   * @param q (optional)
   * @param expand (optional)
   * @return Success
   */
  countVisits(
    request?: {
      startedAt: string;
      finishedAt: string;
      locationId?: string | undefined;
      locationGroupId?: string | undefined;
      hostId?: string | undefined;
      reviewStatus?: string | undefined;
      complete?: boolean | undefined;
      categoryName?: string | undefined;
      limit?: number | undefined;
      page?: number | undefined;
      sort?: string | undefined;
      q?: string | undefined;
      expand?: string | undefined;
    },
    cancelToken?: CancelToken | undefined
  ): Promise<CountVisitResponseApiResponse> {
    let url_ = this.baseUrl + "/v1/visits/counts?";
    if (request?.startedAt === undefined || request?.startedAt === null)
      throw new Error(
        "The parameter 'startedAt' must be defined and cannot be null."
      );
    else
      url_ += "startedAt=" + encodeURIComponent("" + request?.startedAt) + "&";
    if (request?.finishedAt === undefined || request?.finishedAt === null)
      throw new Error(
        "The parameter 'finishedAt' must be defined and cannot be null."
      );
    else
      url_ +=
        "finishedAt=" + encodeURIComponent("" + request?.finishedAt) + "&";
    if (request?.locationId === null)
      throw new Error("The parameter 'locationId' cannot be null.");
    else if (request?.locationId !== undefined)
      url_ +=
        "locationId=" + encodeURIComponent("" + request?.locationId) + "&";
    if (request?.locationGroupId === null)
      throw new Error("The parameter 'locationGroupId' cannot be null.");
    else if (request?.locationGroupId !== undefined)
      url_ +=
        "locationGroupId=" +
        encodeURIComponent("" + request?.locationGroupId) +
        "&";
    if (request?.hostId === null)
      throw new Error("The parameter 'hostId' cannot be null.");
    else if (request?.hostId !== undefined)
      url_ += "hostId=" + encodeURIComponent("" + request?.hostId) + "&";
    if (request?.reviewStatus === null)
      throw new Error("The parameter 'reviewStatus' cannot be null.");
    else if (request?.reviewStatus !== undefined)
      url_ +=
        "reviewStatus=" + encodeURIComponent("" + request?.reviewStatus) + "&";
    if (request?.complete === null)
      throw new Error("The parameter 'complete' cannot be null.");
    else if (request?.complete !== undefined)
      url_ += "complete=" + encodeURIComponent("" + request?.complete) + "&";
    if (request?.categoryName === null)
      throw new Error("The parameter 'categoryName' cannot be null.");
    else if (request?.categoryName !== undefined)
      url_ +=
        "categoryName=" + encodeURIComponent("" + request?.categoryName) + "&";
    if (request?.limit === null)
      throw new Error("The parameter 'limit' cannot be null.");
    else if (request?.limit !== undefined)
      url_ += "limit=" + encodeURIComponent("" + request?.limit) + "&";
    if (request?.page === null)
      throw new Error("The parameter 'page' cannot be null.");
    else if (request?.page !== undefined)
      url_ += "page=" + encodeURIComponent("" + request?.page) + "&";
    if (request?.sort === null)
      throw new Error("The parameter 'sort' cannot be null.");
    else if (request?.sort !== undefined)
      url_ += "sort=" + encodeURIComponent("" + request?.sort) + "&";
    if (request?.q === null)
      throw new Error("The parameter 'q' cannot be null.");
    else if (request?.q !== undefined)
      url_ += "q=" + encodeURIComponent("" + request?.q) + "&";
    if (request?.expand === null)
      throw new Error("The parameter 'expand' cannot be null.");
    else if (request?.expand !== undefined)
      url_ += "expand=" + encodeURIComponent("" + request?.expand) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processCountVisits(_response);
      });
  }

  protected processCountVisits(
    response: AxiosResponse
  ): Promise<CountVisitResponseApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<CountVisitResponseApiResponse>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<CountVisitResponseApiResponse>(null as any);
  }

  /**
   * Get Visitor by id
   * @param locationId (optional)
   * @return Success
   */
  getVisitor(
    request?: { id: string; locationId?: string | undefined },
    cancelToken?: CancelToken | undefined
  ): Promise<GetVisitorResponseApiResponse> {
    let url_ = this.baseUrl + "/v1/visitors/{id}?";
    if (request?.id === undefined || request?.id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + request?.id));
    if (request?.locationId === null)
      throw new Error("The parameter 'locationId' cannot be null.");
    else if (request?.locationId !== undefined)
      url_ +=
        "locationId=" + encodeURIComponent("" + request?.locationId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetVisitor(_response);
      });
  }

  protected processGetVisitor(
    response: AxiosResponse
  ): Promise<GetVisitorResponseApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<GetVisitorResponseApiResponse>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<GetVisitorResponseApiResponse>(null as any);
  }

  /**
   * Get List of visitors
   * @param locationId (optional)
   * @param locationGroupId (optional)
   * @param fullName (optional)
   * @param companyName (optional)
   * @param complete (optional)
   * @param categoryName (optional)
   * @param limit (optional)
   * @param page (optional)
   * @param sort (optional)
   * @param q (optional)
   * @param expand (optional)
   * @return Success
   */
  listVisitors(
    request?: {
      locationId?: string | undefined;
      locationGroupId?: string | undefined;
      fullName?: string | undefined;
      companyName?: string | undefined;
      complete?: boolean | undefined;
      categoryName?: string | undefined;
      limit?: number | undefined;
      page?: number | undefined;
      sort?: string | undefined;
      q?: string | undefined;
      expand?: string | undefined;
    },
    cancelToken?: CancelToken | undefined
  ): Promise<ListVisitorsItemPagedApiResponse> {
    let url_ = this.baseUrl + "/v1/visitors?";
    if (request?.locationId === null)
      throw new Error("The parameter 'locationId' cannot be null.");
    else if (request?.locationId !== undefined)
      url_ +=
        "locationId=" + encodeURIComponent("" + request?.locationId) + "&";
    if (request?.locationGroupId === null)
      throw new Error("The parameter 'locationGroupId' cannot be null.");
    else if (request?.locationGroupId !== undefined)
      url_ +=
        "locationGroupId=" +
        encodeURIComponent("" + request?.locationGroupId) +
        "&";
    if (request?.fullName === null)
      throw new Error("The parameter 'fullName' cannot be null.");
    else if (request?.fullName !== undefined)
      url_ += "fullName=" + encodeURIComponent("" + request?.fullName) + "&";
    if (request?.companyName === null)
      throw new Error("The parameter 'companyName' cannot be null.");
    else if (request?.companyName !== undefined)
      url_ +=
        "companyName=" + encodeURIComponent("" + request?.companyName) + "&";
    if (request?.complete === null)
      throw new Error("The parameter 'complete' cannot be null.");
    else if (request?.complete !== undefined)
      url_ += "complete=" + encodeURIComponent("" + request?.complete) + "&";
    if (request?.categoryName === null)
      throw new Error("The parameter 'categoryName' cannot be null.");
    else if (request?.categoryName !== undefined)
      url_ +=
        "categoryName=" + encodeURIComponent("" + request?.categoryName) + "&";
    if (request?.limit === null)
      throw new Error("The parameter 'limit' cannot be null.");
    else if (request?.limit !== undefined)
      url_ += "limit=" + encodeURIComponent("" + request?.limit) + "&";
    if (request?.page === null)
      throw new Error("The parameter 'page' cannot be null.");
    else if (request?.page !== undefined)
      url_ += "page=" + encodeURIComponent("" + request?.page) + "&";
    if (request?.sort === null)
      throw new Error("The parameter 'sort' cannot be null.");
    else if (request?.sort !== undefined)
      url_ += "sort=" + encodeURIComponent("" + request?.sort) + "&";
    if (request?.q === null)
      throw new Error("The parameter 'q' cannot be null.");
    else if (request?.q !== undefined)
      url_ += "q=" + encodeURIComponent("" + request?.q) + "&";
    if (request?.expand === null)
      throw new Error("The parameter 'expand' cannot be null.");
    else if (request?.expand !== undefined)
      url_ += "expand=" + encodeURIComponent("" + request?.expand) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processListVisitors(_response);
      });
  }

  protected processListVisitors(
    response: AxiosResponse
  ): Promise<ListVisitorsItemPagedApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<ListVisitorsItemPagedApiResponse>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<ListVisitorsItemPagedApiResponse>(null as any);
  }

  /**
   * Get List of completed Inductions for a Visitor
   * @param limit (optional)
   * @param page (optional)
   * @param sort (optional)
   * @param q (optional)
   * @param expand (optional)
   * @return Success
   */
  listVisitorCompletedInductions(
    request?: {
      id: string;
      limit?: number | undefined;
      page?: number | undefined;
      sort?: string | undefined;
      q?: string | undefined;
      expand?: string | undefined;
    },
    cancelToken?: CancelToken | undefined
  ): Promise<ListVisitorInductionsItemPagedApiResponse> {
    let url_ = this.baseUrl + "/v1/visitors/{id}/inductions?";
    if (request?.id === undefined || request?.id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + request?.id));
    if (request?.limit === null)
      throw new Error("The parameter 'limit' cannot be null.");
    else if (request?.limit !== undefined)
      url_ += "limit=" + encodeURIComponent("" + request?.limit) + "&";
    if (request?.page === null)
      throw new Error("The parameter 'page' cannot be null.");
    else if (request?.page !== undefined)
      url_ += "page=" + encodeURIComponent("" + request?.page) + "&";
    if (request?.sort === null)
      throw new Error("The parameter 'sort' cannot be null.");
    else if (request?.sort !== undefined)
      url_ += "sort=" + encodeURIComponent("" + request?.sort) + "&";
    if (request?.q === null)
      throw new Error("The parameter 'q' cannot be null.");
    else if (request?.q !== undefined)
      url_ += "q=" + encodeURIComponent("" + request?.q) + "&";
    if (request?.expand === null)
      throw new Error("The parameter 'expand' cannot be null.");
    else if (request?.expand !== undefined)
      url_ += "expand=" + encodeURIComponent("" + request?.expand) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processListVisitorCompletedInductions(_response);
      });
  }

  protected processListVisitorCompletedInductions(
    response: AxiosResponse
  ): Promise<ListVisitorInductionsItemPagedApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<ListVisitorInductionsItemPagedApiResponse>(
        result200
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<ListVisitorInductionsItemPagedApiResponse>(
      null as any
    );
  }

  /**
   * Get a count of Visitors
   * @param locationId (optional)
   * @param locationGroupId (optional)
   * @param fullName (optional)
   * @param companyName (optional)
   * @param complete (optional)
   * @param categoryName (optional)
   * @param limit (optional)
   * @param page (optional)
   * @param sort (optional)
   * @param q (optional)
   * @param expand (optional)
   * @return Success
   */
  countVisitors(
    request?: {
      locationId?: string | undefined;
      locationGroupId?: string | undefined;
      fullName?: string | undefined;
      companyName?: string | undefined;
      complete?: boolean | undefined;
      categoryName?: string | undefined;
      limit?: number | undefined;
      page?: number | undefined;
      sort?: string | undefined;
      q?: string | undefined;
      expand?: string | undefined;
    },
    cancelToken?: CancelToken | undefined
  ): Promise<CountVisitorResponseApiResponse> {
    let url_ = this.baseUrl + "/v1/visitors/counts?";
    if (request?.locationId === null)
      throw new Error("The parameter 'locationId' cannot be null.");
    else if (request?.locationId !== undefined)
      url_ +=
        "locationId=" + encodeURIComponent("" + request?.locationId) + "&";
    if (request?.locationGroupId === null)
      throw new Error("The parameter 'locationGroupId' cannot be null.");
    else if (request?.locationGroupId !== undefined)
      url_ +=
        "locationGroupId=" +
        encodeURIComponent("" + request?.locationGroupId) +
        "&";
    if (request?.fullName === null)
      throw new Error("The parameter 'fullName' cannot be null.");
    else if (request?.fullName !== undefined)
      url_ += "fullName=" + encodeURIComponent("" + request?.fullName) + "&";
    if (request?.companyName === null)
      throw new Error("The parameter 'companyName' cannot be null.");
    else if (request?.companyName !== undefined)
      url_ +=
        "companyName=" + encodeURIComponent("" + request?.companyName) + "&";
    if (request?.complete === null)
      throw new Error("The parameter 'complete' cannot be null.");
    else if (request?.complete !== undefined)
      url_ += "complete=" + encodeURIComponent("" + request?.complete) + "&";
    if (request?.categoryName === null)
      throw new Error("The parameter 'categoryName' cannot be null.");
    else if (request?.categoryName !== undefined)
      url_ +=
        "categoryName=" + encodeURIComponent("" + request?.categoryName) + "&";
    if (request?.limit === null)
      throw new Error("The parameter 'limit' cannot be null.");
    else if (request?.limit !== undefined)
      url_ += "limit=" + encodeURIComponent("" + request?.limit) + "&";
    if (request?.page === null)
      throw new Error("The parameter 'page' cannot be null.");
    else if (request?.page !== undefined)
      url_ += "page=" + encodeURIComponent("" + request?.page) + "&";
    if (request?.sort === null)
      throw new Error("The parameter 'sort' cannot be null.");
    else if (request?.sort !== undefined)
      url_ += "sort=" + encodeURIComponent("" + request?.sort) + "&";
    if (request?.q === null)
      throw new Error("The parameter 'q' cannot be null.");
    else if (request?.q !== undefined)
      url_ += "q=" + encodeURIComponent("" + request?.q) + "&";
    if (request?.expand === null)
      throw new Error("The parameter 'expand' cannot be null.");
    else if (request?.expand !== undefined)
      url_ += "expand=" + encodeURIComponent("" + request?.expand) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "text/plain",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processCountVisitors(_response);
      });
  }

  protected processCountVisitors(
    response: AxiosResponse
  ): Promise<CountVisitorResponseApiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<CountVisitorResponseApiResponse>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<CountVisitorResponseApiResponse>(null as any);
  }
}

export interface ApiErrorResponse {
  code: number;
  success: boolean;
  error: ErrorDto;
}

export interface ApiKeyPermissions {}

export enum ApiKeyType {
  Publishable = "publishable",
  Secret = "secret",
  Restricted = "restricted",
}

export enum AppVersionPlatform {
  None = "None",
  IPadOS = "iPadOS",
}

export interface Base64File {
  fileName: string;
  content: string;
}

export interface BaseSpaceZoneResponse {
  id: string;
  links?: Link[] | undefined;
  levelId?: string | undefined;
  name?: string | undefined;
  accessRestrictions?: SpaceZoneAccessRestrictionResponse[] | undefined;
}

export interface BaseSpaceZoneResponseApiResponse {
  code: number;
  success: boolean;
  data: BaseSpaceZoneResponse;
}

export interface BillingAddress {
  addressLine1?: string | undefined;
  city?: string | undefined;
  region?: string | undefined;
  country?: string | undefined;
  postalCode?: string | undefined;
}

export interface BulkDeleteRoomRequest {
  roomIds?: string[] | undefined;
}

export interface BulkDeleteRoomResponse {
  updatedCount: number;
}

export interface BulkDeleteRoomResponseApiResponse {
  code: number;
  success: boolean;
  data: BulkDeleteRoomResponse;
}

export interface BulkInductionRequest {
  inductionIds?: string[] | undefined;
}

export interface BulkInductionResponse {
  updatedCount: number;
}

export interface BulkInductionResponseApiResponse {
  code: number;
  success: boolean;
  data: BulkInductionResponse;
}

export interface BulkSpaceResourceRequest {
  spaceResourceIds?: string[] | undefined;
}

export interface BulkSpaceResourceResponse {
  updatedCount: number;
}

export interface BulkSpaceResourceResponseApiResponse {
  code: number;
  success: boolean;
  data: BulkSpaceResourceResponse;
}

export enum CalendarIntegrationStatus {
  NotConnected = "NotConnected",
  Microsoft = "Microsoft",
  Google = "Google",
}

export interface Cognito {
  userPool?: string | undefined;
  dashboardClient?: string | undefined;
  pocketClient?: string | undefined;
}

export enum CompanyFieldState {
  Required = "required",
  Optional = "optional",
  Disabled = "disabled",
}

export interface CompleteInductionResponse {
  inductionId: string;
  preregistrationId: string;
  createdAt?: Date | undefined;
  updatedAt?: Date | undefined;
  expiredAt?: Date | undefined;
}

export interface CompleteInductionResponseApiResponse {
  code: number;
  success: boolean;
  data: CompleteInductionResponse;
}

export interface CountMovementResponse {
  total: number;
  remote: number;
  in: number;
}

export interface CountMovementResponseApiResponse {
  code: number;
  success: boolean;
  data: CountMovementResponse;
}

export interface CountVisitorResponse {
  total: number;
  in: number;
}

export interface CountVisitorResponseApiResponse {
  code: number;
  success: boolean;
  data: CountVisitorResponse;
}

export interface CountVisitResponse {
  total: number;
  in: number;
}

export interface CountVisitResponseApiResponse {
  code: number;
  success: boolean;
  data: CountVisitResponse;
}

export interface CreateApiKeyRequest {
  name?: string | undefined;
  note?: string | undefined;
}

export interface CreateApiKeyResponse {
  id: string;
  links?: Link[] | undefined;
  type?: ApiKeyType | undefined;
  name?: string | undefined;
  note?: string | undefined;
  secret?: string | undefined;
  secretRedacted?: string | undefined;
  permissions?: ApiKeyPermissions | undefined;
  useCount?: number | undefined;
  lastUsedAt?: Date | undefined;
  expiredAt?: Date | undefined;
  createdAt?: Date | undefined;
  updatedAt?: Date | undefined;
}

export interface CreateApiKeyResponseApiResponse {
  code: number;
  success: boolean;
  data: CreateApiKeyResponse;
}

export interface CreateAppVersionRequest {
  version?: string | undefined;
  platform: AppVersionPlatform;
  minOsVersion?: string | undefined;
  metadata?: string | undefined;
  releasedAt: Date;
}

export interface CreateAppVersionResponse {
  id: string;
  links?: Link[] | undefined;
  version?: string | undefined;
  platform: AppVersionPlatform;
  minOsVersion?: string | undefined;
  metadata?: any | undefined;
  releasedAt: Date;
  createdAt: Date;
  updatedAt: Date;
}

export interface CreateAppVersionResponseApiResponse {
  code: number;
  success: boolean;
  data: CreateAppVersionResponse;
}

export interface CreateAssetResponse {
  temporaryFileName?: string | undefined;
}

export interface CreateAssetResponseApiResponse {
  code: number;
  success: boolean;
  data: CreateAssetResponse;
}

export interface CreateDepartmentRequest {
  name?: string | undefined;
}

export interface CreateDepartmentResponse {
  id: string;
  links?: Link[] | undefined;
  name: string;
  metadata: DepartmentMetadata;
  createdAt?: Date | undefined;
  updatedAt?: Date | undefined;
  deletedAt?: Date | undefined;
}

export interface CreateDepartmentResponseApiResponse {
  code: number;
  success: boolean;
  data: CreateDepartmentResponse;
}

export interface CreateInductionRequest {
  name?: string | undefined;
  validityDurationDays?: number | undefined;
  steps?: InductionStep[] | undefined;
}

export interface CreateInductionResponse {
  id: string;
  links?: Link[] | undefined;
  name?: string | undefined;
  validityDurationDays?: number | undefined;
  steps?: InductionStep[] | undefined;
  createdAt: Date;
  updatedAt: Date;
}

export interface CreateInductionResponseApiResponse {
  code: number;
  success: boolean;
  data: CreateInductionResponse;
}

export interface CreateLevelRequest {
  name?: string | undefined;
  locationId?: string | undefined;
  isActive: boolean;
  mapImage?: Base64File | undefined;
  map?: { [key: string]: JsonNode } | undefined;
  order: number;
}

export interface CreateLevelResponse {
  id: string;
  links?: Link[] | undefined;
  name: string;
  isActive: boolean;
  order: number;
  mapData: MapData;
}

export interface CreateLevelResponseApiResponse {
  code: number;
  success: boolean;
  data: CreateLevelResponse;
}

export interface CreateMicrosoftCalendarIntegrationRequest {
  tenantId?: string | undefined;
  adminEmail?: string | undefined;
}

export interface CreateMicrosoftCalendarIntegrationResponse {}

export interface CreateMicrosoftCalendarIntegrationResponseApiResponse {
  code: number;
  success: boolean;
  data: CreateMicrosoftCalendarIntegrationResponse;
}

export interface CreateRoomDeviceRequest {
  name?: string | undefined;
  locationId?: string | undefined;
  status?: string | undefined;
  locale?: string | undefined;
  addedBySuperAdmin: boolean;
  settings?: string | undefined;
  ipAddresses?: string | undefined;
  osName?: string | undefined;
  appVersionId?: number | undefined;
  appVersion?: string | undefined;
  iosVersion?: string | undefined;
  machineCode?: string | undefined;
  deviceToken?: string | undefined;
}

export interface CreateRoomDeviceResponse {
  deviceId?: string | undefined;
  setup?: boolean | undefined;
  name?: string | undefined;
  settings?: DeviceSettings | undefined;
  lastVisit?: Date | undefined;
  createdAt: Date;
  updatedAt: Date;
  appVersion?: string | undefined;
  appVersionStatus?: string | undefined;
  iosVersion?: string | undefined;
  locale?: string | undefined;
}

export interface CreateRoomDeviceResponseApiResponse {
  code: number;
  success: boolean;
  data: CreateRoomDeviceResponse;
}

export interface CreateRoomRequest {
  name?: string | undefined;
  notes?: string | undefined;
  features?: string[] | undefined;
  spaceZones?: string[] | undefined;
  image?: Base64File | undefined;
  backgroundImage?: Base64File | undefined;
  showOrganiser?: boolean | undefined;
  showMeetingName?: boolean | undefined;
  allowExtend?: boolean | undefined;
  requireApproval?: boolean | undefined;
  conjuctionBookingAvailable?: boolean | undefined;
  providerId?: string | undefined;
  levelId?: string | undefined;
}

export interface CreateRoomResponse {
  id: string;
  links?: Link[] | undefined;
  levelId?: string | undefined;
  spaceCategoryId?: string | undefined;
  name?: string | undefined;
  notes?: string | undefined;
  capacity?: number | undefined;
  spaceBookingCount: number;
  imageUrl?: string | undefined;
  backgroundImageUrl?: string | undefined;
  showOrganiser: boolean;
  showMeetingName: boolean;
  allowExtend: boolean;
  requireApproval: boolean;
  conjuctionBookingAvailable: boolean;
  location?: ExpandedLocation | undefined;
  spaceCategory?: ExpandedSpaceCategory | undefined;
  level?: ExpandedLevel | undefined;
  createdAt?: Date | undefined;
  updatedAt?: Date | undefined;
}

export interface CreateRoomResponseApiResponse {
  code: number;
  success: boolean;
  data: CreateRoomResponse;
}

export interface CreateSpaceBookingRequest {
  spaceResourceId?: string | undefined;
  userId?: string | undefined;
  title?: string | undefined;
  startTime?: Date | undefined;
  endTime?: Date | undefined;
}

export interface CreateSpaceBookingResponse {
  id: string;
  links?: Link[] | undefined;
  title?: string | undefined;
  startTime?: Date | undefined;
  endTime?: Date | undefined;
  user?: ExpandedUser | undefined;
  spaceResource?: ExpandedSpaceResource | undefined;
  spaceCategory?: ExpandedSpaceCategory | undefined;
  level?: ExpandedLevel | undefined;
  location?: ExpandedLocation | undefined;
  spaceRecurringBooking?: ExpandedSpaceRecurringBooking | undefined;
}

export interface CreateSpaceBookingResponseApiResponse {
  code: number;
  success: boolean;
  data: CreateSpaceBookingResponse;
}

export interface CreateSpaceCategoryRequest {
  name?: string | undefined;
  icon?: string | undefined;
  bookingLimitDays?: number | undefined;
  recurringBookings?: boolean | undefined;
  locationGroupId?: string | undefined;
}

export interface CreateSpaceCategoryResponse {
  id: string;
  links?: Link[] | undefined;
  name: string;
  type?: SpaceCategoryType | undefined;
  icon?: string | undefined;
  bookingLimitDays?: number | undefined;
  recurringBookings?: boolean | undefined;
}

export interface CreateSpaceCategoryResponseApiResponse {
  code: number;
  success: boolean;
  data: CreateSpaceCategoryResponse;
}

export interface CreateSpaceFeatureRequest {
  name?: string | undefined;
  spaceCategoryId?: string | undefined;
}

export interface CreateSpaceFeatureResponse {
  id: string;
  links?: Link[] | undefined;
  name: string;
  spaceCategoryId: string;
}

export interface CreateSpaceFeatureResponseApiResponse {
  code: number;
  success: boolean;
  data: CreateSpaceFeatureResponse;
}

export interface CreateSpaceRecurringBookingRequest {
  spaceResourceId: string;
  title?: string | undefined;
  userId: string;
  startTime: Date;
  endTime: Date;
  frequency: SpaceRecurringFrequency;
  until?: Date | undefined;
  count?: number | undefined;
}

export interface CreateSpaceRecurringBookingResponse {
  id: string;
  links?: Link[] | undefined;
  spaceResourceId?: string | undefined;
  userId?: string | undefined;
  title?: string | undefined;
  startTime?: Date | undefined;
  endTime?: Date | undefined;
  frequency?: SpaceRecurringFrequency | undefined;
  until?: Date | undefined;
  count?: number | undefined;
  exceptions?: Date[] | undefined;
  createdAt?: Date | undefined;
  updatedAt?: Date | undefined;
  user?: ExpandedUser | undefined;
  spaceResource?: ExpandedSpaceResource | undefined;
  spaceCategory?: ExpandedSpaceCategory | undefined;
  level?: ExpandedLevel | undefined;
  location?: ExpandedLocation | undefined;
}

export interface CreateSpaceRecurringBookingResponseApiResponse {
  code: number;
  success: boolean;
  data: CreateSpaceRecurringBookingResponse;
}

export interface CreateSpaceResourceRequest {
  levelId?: string | undefined;
  spaceCategoryId?: string | undefined;
  name?: string | undefined;
  features?: string[] | undefined;
  notes?: string | undefined;
  isActive: boolean;
  capacity: number;
  image?: Base64File | undefined;
  accessRestrictions?: SpaceResourceAccessRestrictions | undefined;
}

export interface CreateSpaceResourceResponse {
  id: string;
  links?: Link[] | undefined;
  levelId?: string | undefined;
  spaceCategoryId?: string | undefined;
  name?: string | undefined;
  notes?: string | undefined;
  isActive: boolean;
  capacity?: number | undefined;
  spaceBookingCount: number;
  imageUrl?: string | undefined;
  location?: ExpandedLocation | undefined;
  spaceCategory?: ExpandedSpaceCategory | undefined;
  level?: ExpandedLevel | undefined;
  createdAt?: Date | undefined;
  updatedAt?: Date | undefined;
}

export interface CreateSpaceResourceResponseApiResponse {
  code: number;
  success: boolean;
  data: CreateSpaceResourceResponse;
}

export interface CreateSpaceZoneRequest {
  levelId: string;
  name: string;
  accessRestrictions?: SpaceZoneAccessRestrictionsRequest | undefined;
  spaceResources?: string[] | undefined;
}

export interface DeleteApiKeyResponse {}

export interface DeleteApiKeyResponseApiResponse {
  code: number;
  success: boolean;
  data: DeleteApiKeyResponse;
}

export interface DeleteInductionResponse {}

export interface DeleteInductionResponseApiResponse {
  code: number;
  success: boolean;
  data: DeleteInductionResponse;
}

export interface DeleteLevelResponse {}

export interface DeleteLevelResponseApiResponse {
  code: number;
  success: boolean;
  data: DeleteLevelResponse;
}

export interface DeleteRoomResponse {}

export interface DeleteRoomResponseApiResponse {
  code: number;
  success: boolean;
  data: DeleteRoomResponse;
}

export interface DeleteSpaceCategoryResponse {}

export interface DeleteSpaceCategoryResponseApiResponse {
  code: number;
  success: boolean;
  data: DeleteSpaceCategoryResponse;
}

export interface DeleteSpaceRecurringBookingResponse {
  id: string;
  links?: Link[] | undefined;
}

export interface DeleteSpaceRecurringBookingResponseApiResponse {
  code: number;
  success: boolean;
  data: DeleteSpaceRecurringBookingResponse;
}

export interface DeleteSpaceResourceResponse {}

export interface DeleteSpaceResourceResponseApiResponse {
  code: number;
  success: boolean;
  data: DeleteSpaceResourceResponse;
}

export interface DepartmentDirectoryData {
  syncName?: string | undefined;
}

export interface DepartmentMetadata {
  directoryData?: DepartmentDirectoryData | undefined;
}

export interface DeviceSettings {
  remember_me_cb: boolean;
  sign_out_v: boolean;
  reg_hc_fields_v: boolean;
  swipe_e: boolean;
  visitor_in_out: boolean;
  deliveries: boolean;
  is_catering_enabled: boolean;
  swipedon_logo: boolean;
}

export interface Endpoint {
  url?: string | undefined;
}

export interface Endpoints {
  platform?: PlatformEndpoint | undefined;
  rest?: Endpoint | undefined;
  api?: Endpoint | undefined;
  socket?: Endpoint | undefined;
  push?: Endpoint | undefined;
  contactless?: Endpoint | undefined;
  appSync?: EnhancedEndpoint | undefined;
}

export interface EnhancedEndpoint {
  url?: string | undefined;
  dashboardKey?: string | undefined;
  dashboardSecret?: string | undefined;
  deviceKey?: string | undefined;
  deviceSecret?: string | undefined;
}

export interface ErrorDto {
  message: string;
  items?: ValidationError[] | undefined;
}

export interface ExpandedCurrentMovement {
  startedAt: Date;
  isRemote?: number | undefined;
  statusId: string;
  reviewStatus: ReviewStatus;
}

export interface ExpandedDepartment {
  id: string;
  name: string;
  userCount?: number | undefined;
}

export interface ExpandedFeature {
  id?: string | undefined;
  name?: string | undefined;
  readonly isAddOn?: boolean | undefined;
  quantity?: number | undefined;
  bundled: boolean;
}

export interface ExpandedInduction {
  id: string;
  name: string;
}

export interface ExpandedLevel {
  id: string;
  name: string;
}

export interface ExpandedLocation {
  id: string;
  name: string;
  timeZone: string;
}

export interface ExpandedPlan {
  id: string;
  name: string;
}

export interface ExpandedPlanFeature {
  id?: string | undefined;
  name?: string | undefined;
  readonly isAddOn?: boolean | undefined;
  quantity?: number | undefined;
  bundled: boolean;
}

export interface ExpandedProfileField {
  id: string;
  name: string;
  value?: string | undefined;
}

export interface ExpandedSettings {
  employeeRemote?: boolean | undefined;
  employeeRemoteFollow?: boolean | undefined;
}

export interface ExpandedSpaceCategory {
  id: string;
  name: string;
  type: SpaceCategoryType;
  icon?: string | undefined;
}

export interface ExpandedSpaceRecurringBooking {
  id: string;
  frequency: SpaceRecurringFrequency;
  startTime: Date;
  endTime: Date;
  count?: number | undefined;
  until?: Date | undefined;
}

export interface ExpandedSpaceResource {
  id: string;
  name: string;
  capacity?: number | undefined;
}

export interface ExpandedStatus {
  readonly id: string;
  name: string;
  notes?: string | undefined;
  readonly type?: StatusType | undefined;
}

export interface ExpandedSubscriptionResource {
  locations?: number | undefined;
  desks?: number | undefined;
  rooms?: number | undefined;
  equipment?: number | undefined;
  carParks?: number | undefined;
  vehicles?: number | undefined;
  custom?: number | undefined;
  devices?: number | undefined;
  users?: number | undefined;
  totalResources?: TotalResources | undefined;
  includedResources?: IncludedResources | undefined;
  readonly purchasedResources?: PurchasedResources | undefined;
  readonly availableResources?: number | undefined;
  readonly availableRooms?: number | undefined;
}

export interface ExpandedUser {
  id: string;
  firstName?: string | undefined;
  lastName?: string | undefined;
  avatar?: string | undefined;
  userId?: number | undefined;
  deletedAt?: Date | undefined;
  anonymizedAt?: Date | undefined;
}

export interface ExpandedVisit {
  id: string;
}

export interface ExpandedVisitorCategory {
  id: string;
  name: string;
}

export interface GetApiKeyResponse {
  id: string;
  links?: Link[] | undefined;
  type?: ApiKeyType | undefined;
  name?: string | undefined;
  note?: string | undefined;
  secret?: string | undefined;
  secretRedacted?: string | undefined;
  permissions?: ApiKeyPermissions | undefined;
  useCount?: number | undefined;
  lastUsedAt?: Date | undefined;
  expiredAt?: Date | undefined;
  createdAt?: Date | undefined;
  updatedAt?: Date | undefined;
}

export interface GetApiKeyResponseApiResponse {
  code: number;
  success: boolean;
  data: GetApiKeyResponse;
}

export interface GetAppVersionResponse {
  id: string;
  links?: Link[] | undefined;
  version?: string | undefined;
  platform: AppVersionPlatform;
  minOsVersion?: string | undefined;
  readonly metadata?: any | undefined;
  releasedAt: Date;
  createdAt: Date;
  updatedAt: Date;
}

export interface GetAppVersionResponseApiResponse {
  code: number;
  success: boolean;
  data: GetAppVersionResponse;
}

export interface GetAppVersionResponsePagedApiResponse {
  code: number;
  success: boolean;
  pagination: Pagination;
  data: GetAppVersionResponse[];
}

export interface GetCalendarIntegrationStatusResponse {
  status: CalendarIntegrationStatus;
}

export interface GetCalendarIntegrationStatusResponseApiResponse {
  code: number;
  success: boolean;
  data: GetCalendarIntegrationStatusResponse;
}

export interface GetDepartmentResponse {
  id: string;
  links?: Link[] | undefined;
  name?: string | undefined;
  metadata: DepartmentMetadata;
}

export interface GetDepartmentResponseApiResponse {
  code: number;
  success: boolean;
  data: GetDepartmentResponse;
}

export interface GetDeviceResponse {
  id: string;
  links?: Link[] | undefined;
  status?: string | undefined;
  name?: string | undefined;
  settings?: DeviceSettings | undefined;
  lastVisit?: Date | undefined;
  createdAt: Date;
  updatedAt: Date;
  appVersion?: string | undefined;
  appVersionStatus?: string | undefined;
  iosVersion?: string | undefined;
  locale?: string | undefined;
  beacon?: string | undefined;
  hardware?: string | undefined;
  pin?: string | undefined;
}

export interface GetDeviceResponseApiResponse {
  code: number;
  success: boolean;
  data: GetDeviceResponse;
}

export interface GetDeviceResponsePagedApiResponse {
  code: number;
  success: boolean;
  pagination: Pagination;
  data: GetDeviceResponse[];
}

export interface GetInductionResponse {
  id: string;
  links?: Link[] | undefined;
  name?: string | undefined;
  validityDurationDays?: number | undefined;
  steps?: InductionStep[] | undefined;
  createdAt: Date;
  updatedAt: Date;
}

export interface GetInductionResponseApiResponse {
  code: number;
  success: boolean;
  data: GetInductionResponse;
}

export interface GetInsightResponseItem {
  date?: string | undefined;
  count?: number | undefined;
}

export interface GetInsightResponseItemListApiResponse {
  code: number;
  success: boolean;
  data: GetInsightResponseItem[];
}

export interface GetLevelResponse {
  id: string;
  links?: Link[] | undefined;
  name: string;
  isActive: boolean;
  order: number;
  spaceResourceCount: number;
  locationId?: string | undefined;
  mapData: MapData;
  location?: ExpandedLocation | undefined;
}

export interface GetLevelResponseApiResponse {
  code: number;
  success: boolean;
  data: GetLevelResponse;
}

export interface GetLevelResponsePagedApiResponse {
  code: number;
  success: boolean;
  pagination: Pagination;
  data: GetLevelResponse[];
}

export interface GetMovementResponse {
  id: string;
  links?: Link[] | undefined;
  movementId?: number | undefined;
  userId?: string | undefined;
  locationId?: string | undefined;
  statusId?: string | undefined;
  isRemote?: boolean | undefined;
  verifiedIn?: boolean | undefined;
  verifiedOut?: boolean | undefined;
  sourceIn?: SourceTypes | undefined;
  sourceOut?: SourceTypes | undefined;
  photoIn?: string | undefined;
  photoOut?: string | undefined;
  startedAt?: Date | undefined;
  finishedAt?: Date | undefined;
  reviewStatus?: ReviewStatus | undefined;
  reviewerId?: string | undefined;
  reviewedAt?: Date | undefined;
  anonymizedAt?: Date | undefined;
  user?: ExpandedUser | undefined;
  location?: ExpandedLocation | undefined;
  status?: ExpandedStatus | undefined;
}

export interface GetMovementResponseApiResponse {
  code: number;
  success: boolean;
  data: GetMovementResponse;
}

export interface GetPlanResponse {
  id: string;
  links?: Link[] | undefined;
  planName?: string | undefined;
  group?: string | undefined;
  level?: string | undefined;
  currency?: string | undefined;
  frequency?: string | undefined;
  price?: number | undefined;
  priceAnnual?: number | undefined;
  providerId?: string | undefined;
  features: ExpandedPlanFeature[];
  resources: PlanResource[];
}

export interface GetPlanResponseApiResponse {
  code: number;
  success: boolean;
  data: GetPlanResponse;
}

export interface GetPreregistrationResponse {
  id: string;
  links?: Link[] | undefined;
  locationId?: string | undefined;
  visitorCategoryId?: string | undefined;
  hostId?: string | undefined;
  fullName?: string | undefined;
  companyName?: string | undefined;
  email?: string | undefined;
  phone?: string | undefined;
  startDate?: Date | undefined;
  startTime?: string | undefined;
  endDate?: Date | undefined;
  updatedAt?: Date | undefined;
  createdAt?: Date | undefined;
  message?: string | undefined;
  notify?: boolean | undefined;
  induction?: boolean | undefined;
  address?: PreregistrationAddress | undefined;
  location?: ExpandedLocation | undefined;
  visitorCategory?: ExpandedVisitorCategory | undefined;
  host?: ExpandedUser | undefined;
}

export interface GetPreregistrationResponseApiResponse {
  code: number;
  success: boolean;
  data: GetPreregistrationResponse;
}

export interface GetRegionResponse {
  region?: Region | undefined;
  endpoints?: Endpoints | undefined;
  cognito?: Cognito | undefined;
}

export interface GetRegionResponseIEnumerableApiResponse {
  code: number;
  success: boolean;
  data: GetRegionResponse[];
}

export interface GetRoomCategoryResponse {
  id: string;
  links?: Link[] | undefined;
  name?: string | undefined;
  spaceCategoryType?: SpaceCategoryType | undefined;
  bookingLimitDays?: number | undefined;
  recurringBookings?: boolean | undefined;
  autoReleaseTime?: number | undefined;
  conserveBatteryBetweenHrs?: boolean | undefined;
  displayLanguage?: string | undefined;
  timeFormat?: string | undefined;
  freeUpRooms?: boolean | undefined;
}

export interface GetRoomCategoryResponseApiResponse {
  code: number;
  success: boolean;
  data: GetRoomCategoryResponse;
}

export interface GetRoomResponse {
  id: string;
  links?: Link[] | undefined;
  levelId?: string | undefined;
  spaceCategoryId?: string | undefined;
  name?: string | undefined;
  notes?: string | undefined;
  capacity?: number | undefined;
  spaceBookingCount: number;
  imageUrl?: string | undefined;
  backgroundImageUrl?: string | undefined;
  showOrganiser: boolean;
  showMeetingName: boolean;
  allowExtend: boolean;
  requireApproval: boolean;
  conjuctionBookingAvailable: boolean;
  location?: ExpandedLocation | undefined;
  spaceCategory?: ExpandedSpaceCategory | undefined;
  level?: ExpandedLevel | undefined;
  createdAt?: Date | undefined;
  updatedAt?: Date | undefined;
}

export interface GetRoomResponseApiResponse {
  code: number;
  success: boolean;
  data: GetRoomResponse;
}

export interface GetSpaceBookingResponse {
  id: string;
  links?: Link[] | undefined;
  title?: string | undefined;
  startTime?: Date | undefined;
  endTime?: Date | undefined;
  checkInTime?: Date | undefined;
  checkOutTime?: Date | undefined;
  status: SpaceBookingStatus;
  checkedIn?: boolean | undefined;
  user?: ExpandedUser | undefined;
  spaceResource?: ExpandedSpaceResource | undefined;
  spaceCategory?: ExpandedSpaceCategory | undefined;
  level?: ExpandedLevel | undefined;
  location?: ExpandedLocation | undefined;
  spaceRecurringBooking?: ExpandedSpaceRecurringBooking | undefined;
}

export interface GetSpaceBookingResponseApiResponse {
  code: number;
  success: boolean;
  data: GetSpaceBookingResponse;
}

export interface GetSpaceCategoryResponse {
  id: string;
  links?: Link[] | undefined;
  name: string;
  type?: SpaceCategoryType | undefined;
  icon?: string | undefined;
  bookingLimitDays?: number | undefined;
  recurringBookings?: boolean | undefined;
  spaceResourcesCount: number;
}

export interface GetSpaceCategoryResponseApiResponse {
  code: number;
  success: boolean;
  data: GetSpaceCategoryResponse;
}

export interface GetSpaceFeatureResponse {
  id: string;
  links?: Link[] | undefined;
  name: string;
  spacesCount: number;
  spaceCategoryId: string;
}

export interface GetSpaceFeatureResponseApiResponse {
  code: number;
  success: boolean;
  data: GetSpaceFeatureResponse;
}

export interface GetSpaceFeatureResponsePagedApiResponse {
  code: number;
  success: boolean;
  pagination: Pagination;
  data: GetSpaceFeatureResponse[];
}

export interface GetSpaceResourceFeatureResponse {
  id?: string | undefined;
  name?: string | undefined;
}

export interface GetSpaceResourceFeatureResponsePagedApiResponse {
  code: number;
  success: boolean;
  pagination: Pagination;
  data: GetSpaceResourceFeatureResponse[];
}

export interface GetSpaceResourceResponse {
  id: string;
  links?: Link[] | undefined;
  levelId?: string | undefined;
  spaceCategoryId?: string | undefined;
  name?: string | undefined;
  notes?: string | undefined;
  isActive: boolean;
  capacity?: number | undefined;
  spaceBookingCount: number;
  imageUrl?: string | undefined;
  location?: ExpandedLocation | undefined;
  spaceCategory?: ExpandedSpaceCategory | undefined;
  level?: ExpandedLevel | undefined;
  createdAt?: Date | undefined;
  updatedAt?: Date | undefined;
}

export interface GetSpaceResourceResponseApiResponse {
  code: number;
  success: boolean;
  data: GetSpaceResourceResponse;
}

export interface GetSpaceResourceRestrictionResponse {
  userId?: string | undefined;
  user?: ExpandedUser | undefined;
  departmentId?: string | undefined;
  department?: ExpandedDepartment | undefined;
}

export interface GetSpaceResourceRestrictionResponsePagedApiResponse {
  code: number;
  success: boolean;
  pagination: Pagination;
  data: GetSpaceResourceRestrictionResponse[];
}

export interface GetSpaceResourcesWithBookingsResponse {
  spaceResourceId?: string | undefined;
  name?: string | undefined;
  spaceCategoryId?: string | undefined;
  imageUrl?: string | undefined;
  location?: ExpandedLocation | undefined;
  level?: ExpandedLevel | undefined;
  bookings?: ResourceSpaceBooking[] | undefined;
}

export interface GetSpaceResourcesWithBookingsResponsePagedApiResponse {
  code: number;
  success: boolean;
  pagination: Pagination;
  data: GetSpaceResourcesWithBookingsResponse[];
}

export interface GetSpaceZoneResponse {
  id: string;
  links?: Link[] | undefined;
  levelId?: string | undefined;
  name?: string | undefined;
  accessRestrictions?: SpaceZoneAccessRestrictionResponse[] | undefined;
}

export interface GetSpaceZoneResponseApiResponse {
  code: number;
  success: boolean;
  data: GetSpaceZoneResponse;
}

export interface GetSubscriptionResponse {
  name: string;
  features?: ExpandedFeature[] | undefined;
  plan?: ExpandedPlan | undefined;
  subscriptionResources?: ExpandedSubscriptionResource | undefined;
}

export interface GetSubscriptionResponseApiResponse {
  code: number;
  success: boolean;
  data: GetSubscriptionResponse;
}

export interface GetUserInOutCountsResponse {
  total: number;
  in: number;
  out: number;
  remote: number;
}

export interface GetUserInOutCountsResponseApiResponse {
  code: number;
  success: boolean;
  data: GetUserInOutCountsResponse;
}

export interface GetUserResponse {
  id: string;
  links?: Link[] | undefined;
  email?: string | undefined;
  firstName?: string | undefined;
  lastName?: string | undefined;
  phone?: string | undefined;
  photoKey?: string | undefined;
  departmentId?: string | undefined;
  locationId?: string | undefined;
  isRemote?: boolean | undefined;
  location?: ExpandedLocation | undefined;
  currentMovement?: ExpandedCurrentMovement | undefined;
  status?: ExpandedStatus | undefined;
  settings?: ExpandedSettings | undefined;
  updatedAt: Date;
  profileField?: ExpandedProfileField | undefined;
  department?: ExpandedDepartment | undefined;
  userId?: number | undefined;
}

export interface GetUserResponseApiResponse {
  code: number;
  success: boolean;
  data: GetUserResponse;
}

export interface GetUserSSOConfigurationResponse {
  microsoft: boolean;
  google: boolean;
}

export interface GetUserSSOConfigurationResponseApiResponse {
  code: number;
  success: boolean;
  data: GetUserSSOConfigurationResponse;
}

export interface GetVisitorResponse {
  id: string;
  links?: Link[] | undefined;
  fullName?: string | undefined;
  companyName?: string | undefined;
  updatedAt?: Date | undefined;
  createdAt?: Date | undefined;
  visitorId?: number | undefined;
  latestVisit?: ExpandedVisit | undefined;
}

export interface GetVisitorResponseApiResponse {
  code: number;
  success: boolean;
  data: GetVisitorResponse;
}

export interface GetVisitResponse {
  id: string;
  links?: Link[] | undefined;
  visitId?: number | undefined;
  locationId?: string | undefined;
  hostId?: string | undefined;
  visitorId?: string | undefined;
  preregistrationId?: string | undefined;
  agreementId?: string | undefined;
  fullName?: string | undefined;
  companyName?: string | undefined;
  email?: string | undefined;
  phone?: string | undefined;
  sourceIn?: SourceTypes | undefined;
  sourceOut?: SourceTypes | undefined;
  photo?: string | undefined;
  photoIn?: string | undefined;
  categoryName?: string | undefined;
  reviewStatus?: ReviewStatus | undefined;
  reviewerId?: string | undefined;
  reviewedAt?: Date | undefined;
  notes?: string | undefined;
  startedAt?: Date | undefined;
  finishedAt?: Date | undefined;
  updatedAt?: Date | undefined;
  createdAt?: Date | undefined;
  anonymizedAt?: Date | undefined;
  randomSelection?: boolean | undefined;
  location?: ExpandedLocation | undefined;
  host?: ExpandedUser | undefined;
}

export interface GetVisitResponseApiResponse {
  code: number;
  success: boolean;
  data: GetVisitResponse;
}

export interface ImportError {
  message?: string | undefined;
  type?: ValidationErrorType | undefined;
  column?: string | undefined;
  value?: string | undefined;
}

export interface ImportPreregistrationsCounts {
  created: number;
  notified: number;
  errors: number;
}

export interface ImportPreregistrationsError {
  message?: string | undefined;
  type?: ValidationErrorType | undefined;
  column?: string | undefined;
  value?: string | undefined;
}

export interface ImportPreregistrationsErrorItem {
  fullName?: string | undefined;
  companyName?: string | undefined;
  companyFieldState?: CompanyFieldState | undefined;
  companyFieldLabel?: string | undefined;
  visitorEmail?: string | undefined;
  startDate?: Date | undefined;
  endDate?: Date | undefined;
  arrivalTime?: string | undefined;
  hostEmail?: string | undefined;
}

export interface ImportPreregistrationsErrors {
  error: ImportPreregistrationsError;
  item?: ImportPreregistrationsErrorItem | undefined;
}

export interface ImportPreregistrationsResponse {
  counts: ImportPreregistrationsCounts;
  errors?: ImportPreregistrationsErrors[] | undefined;
}

export interface ImportPreregistrationsResponseApiResponse {
  code: number;
  success: boolean;
  data: ImportPreregistrationsResponse;
}

export interface ImportSpaceResourceCounts {
  created: number;
  updated: number;
  errors: number;
}

export interface ImportSpaceResourceErrorItem {
  resourceName?: string | undefined;
  space?: string | undefined;
  resourceCategory?: string | undefined;
  notes?: string | undefined;
  capacity?: number | undefined;
}

export interface ImportSpaceResourceErrors {
  error: ImportError;
  item?: ImportSpaceResourceErrorItem | undefined;
}

export interface ImportSpaceResourceResponse {
  counts: ImportSpaceResourceCounts;
  errors?: ImportSpaceResourceErrors[] | undefined;
}

export interface ImportSpaceResourceResponseApiResponse {
  code: number;
  success: boolean;
  data: ImportSpaceResourceResponse;
}

export interface IncludedResources {
  resources?: number | undefined;
  rooms?: number | undefined;
}

export interface InductionMedia {
  type?: string | undefined;
  title?: string | undefined;
  value?: string | undefined;
  readonly presignedUrl?: string | undefined;
}

export interface InductionOption {
  value?: string | undefined;
  correct: boolean;
}

export interface InductionQuestion {
  title?: string | undefined;
  options?: InductionOption[] | undefined;
}

export interface InductionStep {
  media?: InductionMedia | undefined;
  questions?: InductionQuestion[] | undefined;
}

export interface JsonNode {
  readonly options?: JsonNodeOptions | undefined;
  readonly parent?: JsonNode | undefined;
  readonly root: JsonNode;
}

export interface JsonNodeOptions {
  propertyNameCaseInsensitive: boolean;
}

export interface Link {
  rel: string;
  href: string;
  protocol: string;
}

export interface ListApiKeyItem {
  id: string;
  links?: Link[] | undefined;
  type?: ApiKeyType | undefined;
  name?: string | undefined;
  note?: string | undefined;
  secret?: string | undefined;
  secretRedacted?: string | undefined;
  permissions?: ApiKeyPermissions | undefined;
  useCount?: number | undefined;
  lastUsedAt?: Date | undefined;
  expiredAt?: Date | undefined;
  createdAt?: Date | undefined;
  updatedAt?: Date | undefined;
}

export interface ListApiKeyItemPagedApiResponse {
  code: number;
  success: boolean;
  pagination: Pagination;
  data: ListApiKeyItem[];
}

export interface ListDepartmentItem {
  id: string;
  links?: Link[] | undefined;
  name: string;
  userCount: number;
  metadata: DepartmentMetadata;
}

export interface ListDepartmentItemPagedApiResponse {
  code: number;
  success: boolean;
  pagination: Pagination;
  data: ListDepartmentItem[];
}

export interface ListInductionItem {
  id: string;
  links?: Link[] | undefined;
  name?: string | undefined;
  validityDurationDays?: number | undefined;
  steps?: InductionStep[] | undefined;
  createdAt: Date;
  updatedAt: Date;
  completedCount: number;
}

export interface ListInductionItemPagedApiResponse {
  code: number;
  success: boolean;
  pagination: Pagination;
  data: ListInductionItem[];
}

export interface ListMovementFieldsItem {
  id?: string | undefined;
  value: string;
  name?: string | undefined;
  fieldType?: MovementFieldTypes | undefined;
}

export interface ListMovementFieldsItemPagedApiResponse {
  code: number;
  success: boolean;
  pagination: Pagination;
  data: ListMovementFieldsItem[];
}

export interface ListMovementItem {
  id: string;
  links?: Link[] | undefined;
  movementId?: number | undefined;
  userId?: string | undefined;
  locationId?: string | undefined;
  statusId?: string | undefined;
  isRemote?: boolean | undefined;
  verifiedIn?: boolean | undefined;
  verifiedOut?: boolean | undefined;
  sourceIn?: SourceTypes | undefined;
  sourceOut?: SourceTypes | undefined;
  photoIn?: string | undefined;
  photoOut?: string | undefined;
  startedAt?: Date | undefined;
  finishedAt?: Date | undefined;
  reviewStatus?: ReviewStatus | undefined;
  reviewerId?: string | undefined;
  reviewedAt?: Date | undefined;
  anonymizedAt?: Date | undefined;
  user?: ExpandedUser | undefined;
  location?: ExpandedLocation | undefined;
  status?: ExpandedStatus | undefined;
}

export interface ListMovementItemPagedApiResponse {
  code: number;
  success: boolean;
  pagination: Pagination;
  data: ListMovementItem[];
}

export interface ListPlanItem {
  id: string;
  links?: Link[] | undefined;
  planName?: string | undefined;
  group?: string | undefined;
  level?: string | undefined;
  currency?: string | undefined;
  frequency?: string | undefined;
  price?: number | undefined;
  priceAnnual?: number | undefined;
  providerId?: string | undefined;
  employees?: number | undefined;
  devices?: number | undefined;
  locations?: number | undefined;
  features: ExpandedPlanFeature[];
}

export interface ListPlanItemPagedApiResponse {
  code: number;
  success: boolean;
  pagination: Pagination;
  data: ListPlanItem[];
}

export interface ListPreregistrationFieldsItem {
  id?: string | undefined;
  value?: any | undefined;
}

export interface ListPreregistrationFieldsItemPagedApiResponse {
  code: number;
  success: boolean;
  pagination: Pagination;
  data: ListPreregistrationFieldsItem[];
}

export interface ListPreregistrationInductionsItem {
  inductionId: string;
  preregistrationId: string;
  createdAt?: Date | undefined;
  updatedAt?: Date | undefined;
  expiredAt?: Date | undefined;
  induction?: ExpandedInduction | undefined;
}

export interface ListPreregistrationInductionsItemPagedApiResponse {
  code: number;
  success: boolean;
  pagination: Pagination;
  data: ListPreregistrationInductionsItem[];
}

export interface ListPreregistrationsItem {
  id: string;
  links?: Link[] | undefined;
  locationId?: string | undefined;
  visitorCategoryId?: string | undefined;
  hostId?: string | undefined;
  fullName?: string | undefined;
  companyName?: string | undefined;
  email?: string | undefined;
  phone?: string | undefined;
  startDate?: Date | undefined;
  startTime?: string | undefined;
  endDate?: Date | undefined;
  updatedAt?: Date | undefined;
  createdAt?: Date | undefined;
  location?: ExpandedLocation | undefined;
  visitorCategory?: ExpandedVisitorCategory | undefined;
  host?: ExpandedUser | undefined;
}

export interface ListPreregistrationsItemPagedApiResponse {
  code: number;
  success: boolean;
  pagination: Pagination;
  data: ListPreregistrationsItem[];
}

export interface ListRoomDevicesResponse {
  deviceId?: string | undefined;
  setup?: boolean | undefined;
  name?: string | undefined;
  settings?: DeviceSettings | undefined;
  lastVisit?: Date | undefined;
  createdAt: Date;
  updatedAt: Date;
  appVersion?: string | undefined;
  appVersionStatus?: string | undefined;
  iosVersion?: string | undefined;
  locale?: string | undefined;
}

export interface ListRoomDevicesResponsePagedApiResponse {
  code: number;
  success: boolean;
  pagination: Pagination;
  data: ListRoomDevicesResponse[];
}

export interface ListRoomItem {
  id: string;
  links?: Link[] | undefined;
  providerId: string;
  name?: string | undefined;
  physicalAddress?: string | undefined;
  emailAddress?: string | undefined;
  capacity?: number | undefined;
  locationId?: string | undefined;
  levelId?: string | undefined;
  isImported: boolean;
  location?: ExpandedLocation | undefined;
  spaceCategory?: ExpandedSpaceCategory | undefined;
  level?: ExpandedLevel | undefined;
}

export interface ListRoomItemPagedApiResponse {
  code: number;
  success: boolean;
  pagination: Pagination;
  data: ListRoomItem[];
}

export interface ListSpaceAvailabilityItem {
  id: string;
  links?: Link[] | undefined;
  name: string;
  levelId?: string | undefined;
  spaceCategoryId?: string | undefined;
  isActive: boolean;
  spaceCategory?: ExpandedSpaceCategory | undefined;
  level?: ExpandedLevel | undefined;
  location?: ExpandedLocation | undefined;
  capacity?: number | undefined;
  recommended: boolean;
  restricted: boolean;
  imageUrl?: string | undefined;
}

export interface ListSpaceAvailabilityItemPagedApiResponse {
  code: number;
  success: boolean;
  pagination: Pagination;
  data: ListSpaceAvailabilityItem[];
}

export interface ListSpaceBookingItem {
  id: string;
  links?: Link[] | undefined;
  title?: string | undefined;
  startTime?: Date | undefined;
  endTime?: Date | undefined;
  checkInTime?: Date | undefined;
  checkOutTime?: Date | undefined;
  status: SpaceBookingStatus;
  checkedIn?: boolean | undefined;
  user?: ExpandedUser | undefined;
  spaceResource?: ExpandedSpaceResource | undefined;
  spaceCategory?: ExpandedSpaceCategory | undefined;
  level?: ExpandedLevel | undefined;
  location?: ExpandedLocation | undefined;
  spaceRecurringBooking?: ExpandedSpaceRecurringBooking | undefined;
}

export interface ListSpaceBookingItemPagedApiResponse {
  code: number;
  success: boolean;
  pagination: Pagination;
  data: ListSpaceBookingItem[];
}

export interface ListSpaceCategoryItem {
  id: string;
  links?: Link[] | undefined;
  name: string;
  type?: SpaceCategoryType | undefined;
  spaceResourcesCount: number;
  icon?: string | undefined;
  bookingLimitDays?: number | undefined;
  recurringBookings?: boolean | undefined;
}

export interface ListSpaceCategoryItemPagedApiResponse {
  code: number;
  success: boolean;
  pagination: Pagination;
  data: ListSpaceCategoryItem[];
}

export interface ListSpaceResourcesItem {
  id: string;
  links?: Link[] | undefined;
  name: string;
  isActive: boolean;
  levelId?: string | undefined;
  spaceCategoryId?: string | undefined;
  capacity?: number | undefined;
  imageUrl?: string | undefined;
  notes?: string | undefined;
  spaceBookingCount: number;
  location?: ExpandedLocation | undefined;
  spaceCategory?: ExpandedSpaceCategory | undefined;
  level?: ExpandedLevel | undefined;
  createdAt?: Date | undefined;
  updatedAt?: Date | undefined;
}

export interface ListSpaceResourcesItemPagedApiResponse {
  code: number;
  success: boolean;
  pagination: Pagination;
  data: ListSpaceResourcesItem[];
}

export interface ListSpaceZoneItem {
  id: string;
  links?: Link[] | undefined;
  name: string;
}

export interface ListSpaceZoneItemPagedApiResponse {
  code: number;
  success: boolean;
  pagination: Pagination;
  data: ListSpaceZoneItem[];
}

export interface ListUsersItem {
  id: string;
  links?: Link[] | undefined;
  email?: string | undefined;
  firstName?: string | undefined;
  lastName?: string | undefined;
  phone?: string | undefined;
  photoKey?: string | undefined;
  departmentId?: string | undefined;
  locationId?: string | undefined;
  isRemote?: boolean | undefined;
  location?: ExpandedLocation | undefined;
  currentMovement?: ExpandedCurrentMovement | undefined;
  status?: ExpandedStatus | undefined;
  settings?: ExpandedSettings | undefined;
  updatedAt: Date;
  profileField?: ExpandedProfileField | undefined;
  department?: ExpandedDepartment | undefined;
  userId?: number | undefined;
}

export interface ListUsersItemPagedApiResponse {
  code: number;
  success: boolean;
  pagination: Pagination;
  data: ListUsersItem[];
}

export interface ListVisitFieldsItem {
  fieldId?: number | undefined;
  id?: string | undefined;
  value?: any | undefined;
  name?: string | undefined;
  url?: string | undefined;
  fieldType?: VisitFieldTypes | undefined;
}

export interface ListVisitFieldsItemPagedApiResponse {
  code: number;
  success: boolean;
  pagination: Pagination;
  data: ListVisitFieldsItem[];
}

export interface ListVisitInductionsItem {
  inductionId: string;
  visitId: string;
  expiredAt?: Date | undefined;
  createdAt?: Date | undefined;
  updatedAt?: Date | undefined;
  induction?: ExpandedInduction | undefined;
}

export interface ListVisitInductionsItemPagedApiResponse {
  code: number;
  success: boolean;
  pagination: Pagination;
  data: ListVisitInductionsItem[];
}

export interface ListVisitItem {
  id: string;
  links?: Link[] | undefined;
  visitId?: number | undefined;
  locationId?: string | undefined;
  hostId?: string | undefined;
  visitorId?: string | undefined;
  preregistrationId?: string | undefined;
  agreementId?: string | undefined;
  fullName?: string | undefined;
  companyName?: string | undefined;
  email?: string | undefined;
  phone?: string | undefined;
  sourceIn?: SourceTypes | undefined;
  sourceOut?: SourceTypes | undefined;
  photo?: string | undefined;
  photoIn?: string | undefined;
  categoryName?: string | undefined;
  reviewStatus?: ReviewStatus | undefined;
  reviewerId?: string | undefined;
  reviewedAt?: Date | undefined;
  notes?: string | undefined;
  startedAt?: Date | undefined;
  finishedAt?: Date | undefined;
  updatedAt?: Date | undefined;
  createdAt?: Date | undefined;
  anonymizedAt?: Date | undefined;
  randomSelection?: boolean | undefined;
  location?: ExpandedLocation | undefined;
  host?: ExpandedUser | undefined;
}

export interface ListVisitItemPagedApiResponse {
  code: number;
  success: boolean;
  pagination: Pagination;
  data: ListVisitItem[];
}

export interface ListVisitorInductionsItem {
  inductionId: string;
  visitId: string;
  expiredAt?: Date | undefined;
  createdAt?: Date | undefined;
  updatedAt?: Date | undefined;
  induction?: ExpandedInduction | undefined;
}

export interface ListVisitorInductionsItemPagedApiResponse {
  code: number;
  success: boolean;
  pagination: Pagination;
  data: ListVisitorInductionsItem[];
}

export interface ListVisitorsItem {
  id: string;
  links?: Link[] | undefined;
  fullName?: string | undefined;
  companyName?: string | undefined;
  updatedAt?: Date | undefined;
  createdAt?: Date | undefined;
  visitorId?: number | undefined;
  latestVisit?: ExpandedVisit | undefined;
}

export interface ListVisitorsItemPagedApiResponse {
  code: number;
  success: boolean;
  pagination: Pagination;
  data: ListVisitorsItem[];
}

export interface MapData {
  imageUrl?: string | undefined;
  resources: { [key: string]: ResourceMarker };
  zones: { [key: string]: MapDataZone };
  rooms: { [key: string]: MapDataRoom };
}

export interface MapDataRoom {
  points: XYPoint[];
}

export interface MapDataZone {
  points: XYPoint[];
  color: string;
}

export enum MovementFieldTypes {
  String = "string",
  Yesno = "yesno",
}

export interface MsGraphWebHookNotificationsResponse {}

export interface Pagination {
  page: number;
  items: number;
  pages: number;
  limit: number;
  next?: string | undefined;
  previous?: string | undefined;
}

export interface PlanResource {
  category?: string | undefined;
  price?: number | undefined;
  priceAnnual?: number | undefined;
  providerId?: string | undefined;
  includedInPlan?: number | undefined;
}

export interface PlatformEndpoint {
  url?: string | undefined;
  primaryUrl?: string | undefined;
}

export interface PreregistrationAddress {
  location?: string | undefined;
  description?: string | undefined;
}

export interface PurchasedResources {
  resources?: number | undefined;
  rooms?: number | undefined;
}

export interface RecurringSpaceResourcesAvailabilityResponse {
  spaceResourceId?: string | undefined;
  userId?: string | undefined;
  startTime: Date;
  endTime: Date;
  frequency?: SpaceRecurringFrequency | undefined;
  until?: Date | undefined;
  count?: number | undefined;
  exceptions?: Date[] | undefined;
}

export interface RecurringSpaceResourcesAvailabilityResponseApiResponse {
  code: number;
  success: boolean;
  data: RecurringSpaceResourcesAvailabilityResponse;
}

export interface Region {
  name?: string | undefined;
  aws?: string | undefined;
  code?: string | undefined;
}

export interface RemoveCalendarIntegrationResponse {}

export interface RemoveCalendarIntegrationResponseApiResponse {
  code: number;
  success: boolean;
  data: RemoveCalendarIntegrationResponse;
}

export interface ResourceMarker {
  x: number;
  y: number;
  spaceCategoryType?: SpaceCategoryType | undefined;
}

export interface ResourceSpaceBooking {
  startTime?: Date | undefined;
  endTime?: Date | undefined;
}

export enum ReviewStatus {
  Pending = "pending",
  Allow = "allow",
  Deny = "deny",
  Lapsed = "lapsed",
}

export enum SourceTypes {
  Kiosk = "kiosk",
  Mobile = "mobile",
  Dashboard = "dashboard",
  Contactless = "contactless",
  Api = "api",
}

export interface SpaceBookingCounts {
  total?: number | undefined;
}

export interface SpaceBookingCountsApiResponse {
  code: number;
  success: boolean;
  data: SpaceBookingCounts;
}

export enum SpaceBookingStatus {
  Pending = "Pending",
  Accepted = "Accepted",
  CheckedIn = "CheckedIn",
  CheckedOut = "CheckedOut",
  Expired = "Expired",
  Cancelled = "Cancelled",
}

export enum SpaceCategoryType {
  Desk = "desk",
  Room = "room",
  Equipment = "equipment",
  Vehicle = "vehicle",
  Carpark = "carpark",
  Custom = "custom",
}

export enum SpaceRecurringFrequency {
  Daily = "Daily",
  Weekdays = "Weekdays",
  Weekly = "Weekly",
  Fortnightly = "Fortnightly",
  Monthly = "Monthly",
}

export interface SpaceResourceAccessRestrictions {
  users?: string[] | undefined;
  departments?: string[] | undefined;
}

export interface SpaceResourceCategoryCounts {
  id?: string | undefined;
  name?: string | undefined;
  type?: SpaceCategoryType | undefined;
  total?: number | undefined;
  active?: number | undefined;
}

export interface SpaceResourceCounts {
  total?: number | undefined;
  active?: number | undefined;
  categories?: SpaceResourceCategoryCounts[] | undefined;
}

export interface SpaceResourceCountsApiResponse {
  code: number;
  success: boolean;
  data: SpaceResourceCounts;
}

export interface SpaceZoneAccessRestrictionResponse {
  userId?: string | undefined;
  user?: ExpandedUser | undefined;
  departmentId?: string | undefined;
  department?: ExpandedDepartment | undefined;
}

export interface SpaceZoneAccessRestrictionsRequest {
  users?: string[] | undefined;
  departments?: string[] | undefined;
}

export enum StatusType {
  Base = "base",
  Company = "company",
  User = "user",
}

export interface StringApiResponse {
  code: number;
  success: boolean;
  data: string;
}

export interface TotalResources {
  resources?: number | undefined;
  rooms?: number | undefined;
}

export interface UpdateApiKeyRequest {
  name?: string | undefined;
  note?: string | undefined;
}

export interface UpdateApiKeyResponse {
  id: string;
  links?: Link[] | undefined;
  type?: ApiKeyType | undefined;
  name?: string | undefined;
  note?: string | undefined;
  secret?: string | undefined;
  secretRedacted?: string | undefined;
  permissions?: ApiKeyPermissions | undefined;
  useCount?: number | undefined;
  lastUsedAt?: Date | undefined;
  expiredAt?: Date | undefined;
  createdAt?: Date | undefined;
  updatedAt?: Date | undefined;
}

export interface UpdateApiKeyResponseApiResponse {
  code: number;
  success: boolean;
  data: UpdateApiKeyResponse;
}

export interface UpdateAppVersionRequest {
  version?: string | undefined;
  platform: AppVersionPlatform;
  minOsVersion?: string | undefined;
  metadata?: string | undefined;
  releasedAt: Date;
}

export interface UpdateAppVersionResponse {
  id: string;
  links?: Link[] | undefined;
  version?: string | undefined;
  platform: AppVersionPlatform;
  minOsVersion?: string | undefined;
  readonly metadata?: any | undefined;
  releasedAt: Date;
  createdAt: Date;
  updatedAt: Date;
}

export interface UpdateAppVersionResponseApiResponse {
  code: number;
  success: boolean;
  data: UpdateAppVersionResponse;
}

export interface UpdateDepartmentRequest {
  name?: string | undefined;
}

export interface UpdateDepartmentResponse {
  id: string;
  links?: Link[] | undefined;
  name: string;
  metadata: DepartmentMetadata;
}

export interface UpdateDepartmentResponseApiResponse {
  code: number;
  success: boolean;
  data: UpdateDepartmentResponse;
}

export interface UpdateDeviceRequest {
  deviceId?: string | undefined;
}

export interface UpdateDeviceResponse {
  deviceId: string;
}

export interface UpdateDeviceResponseApiResponse {
  code: number;
  success: boolean;
  data: UpdateDeviceResponse;
}

export interface UpdateInductionRequest {
  name?: string | undefined;
  validityDurationDays?: number | undefined;
  steps?: InductionStep[] | undefined;
}

export interface UpdateInductionResponse {
  id: string;
  links?: Link[] | undefined;
  name?: string | undefined;
  validityDurationDays?: number | undefined;
  steps?: InductionStep[] | undefined;
  createdAt: Date;
  updatedAt: Date;
}

export interface UpdateInductionResponseApiResponse {
  code: number;
  success: boolean;
  data: UpdateInductionResponse;
}

export interface UpdateLevelRequest {
  name?: string | undefined;
  isActive?: boolean | undefined;
  mapImage?: Base64File | undefined;
  order?: number | undefined;
  resources?: { [key: string]: ResourceMarker } | undefined;
  zones?: { [key: string]: MapDataZone } | undefined;
  rooms?: { [key: string]: MapDataRoom } | undefined;
}

export interface UpdateLevelResponse {
  id: string;
  links?: Link[] | undefined;
  name: string;
  isActive: boolean;
  locationId?: string | undefined;
  order: number;
  mapData: MapData;
}

export interface UpdateLevelResponseApiResponse {
  code: number;
  success: boolean;
  data: UpdateLevelResponse;
}

export interface UpdateRoomCategoryRequest {
  locationGroupId?: string | undefined;
  bookingLimitDays?: number | undefined;
  recurringBookings?: boolean | undefined;
  autoReleaseTime?: number | undefined;
  conserveBatteryBetweenHrs?: boolean | undefined;
  displayLanguage?: string | undefined;
  timeFormat?: string | undefined;
  freeUpRooms?: boolean | undefined;
}

export interface UpdateRoomCategoryResponse {
  id: string;
  name?: string | undefined;
  spaceCategoryType?: SpaceCategoryType | undefined;
  bookingLimitDays?: number | undefined;
  recurringBookings?: boolean | undefined;
  freeUpRooms?: boolean | undefined;
  autoReleaseTime?: number | undefined;
  conserveBatteryBetweenHrs?: boolean | undefined;
  displayLanguage?: string | undefined;
  timeFormat?: string | undefined;
}

export interface UpdateRoomCategoryResponseApiResponse {
  code: number;
  success: boolean;
  data: UpdateRoomCategoryResponse;
}

export interface UpdateRoomRequest {
  name?: string | undefined;
  notes?: string | undefined;
  features?: string[] | undefined;
  spaceZones?: string[] | undefined;
  image?: Base64File | undefined;
  backgroundImage?: Base64File | undefined;
  showOrganiser?: boolean | undefined;
  showMeetingName?: boolean | undefined;
  allowExtend?: boolean | undefined;
  requireApproval?: boolean | undefined;
  conjuctionBookingAvailable?: boolean | undefined;
}

export interface UpdateRoomResponse {
  id: string;
  links?: Link[] | undefined;
  levelId?: string | undefined;
  spaceCategoryId?: string | undefined;
  name?: string | undefined;
  notes?: string | undefined;
  capacity?: number | undefined;
  spaceBookingCount: number;
  imageUrl?: string | undefined;
  backgroundImageUrl?: string | undefined;
  showOrganiser: boolean;
  showMeetingName: boolean;
  allowExtend: boolean;
  requireApproval: boolean;
  conjuctionBookingAvailable: boolean;
  location?: ExpandedLocation | undefined;
  spaceCategory?: ExpandedSpaceCategory | undefined;
  level?: ExpandedLevel | undefined;
  createdAt?: Date | undefined;
  updatedAt?: Date | undefined;
}

export interface UpdateRoomResponseApiResponse {
  code: number;
  success: boolean;
  data: UpdateRoomResponse;
}

export interface UpdateSpaceBookingRequest {
  userId?: string | undefined;
  title?: string | undefined;
  startTime?: Date | undefined;
  endTime?: Date | undefined;
}

export interface UpdateSpaceBookingResponse {
  id: string;
  links?: Link[] | undefined;
  title?: string | undefined;
  startTime?: Date | undefined;
  endTime?: Date | undefined;
  user?: ExpandedUser | undefined;
  spaceResource?: ExpandedSpaceResource | undefined;
  spaceCategory?: ExpandedSpaceCategory | undefined;
  level?: ExpandedLevel | undefined;
  location?: ExpandedLocation | undefined;
  spaceRecurringBooking?: ExpandedSpaceRecurringBooking | undefined;
  checkedIn?: boolean | undefined;
}

export interface UpdateSpaceBookingResponseApiResponse {
  code: number;
  success: boolean;
  data: UpdateSpaceBookingResponse;
}

export interface UpdateSpaceCategoryRequest {
  name?: string | undefined;
  icon?: string | undefined;
  bookingLimitDays?: number | undefined;
  recurringBookings?: boolean | undefined;
  locationGroupId?: string | undefined;
}

export interface UpdateSpaceCategoryResponse {
  id: string;
  links?: Link[] | undefined;
  name: string;
  type?: SpaceCategoryType | undefined;
  icon?: string | undefined;
  bookingLimitDays?: number | undefined;
  recurringBookings?: boolean | undefined;
}

export interface UpdateSpaceCategoryResponseApiResponse {
  code: number;
  success: boolean;
  data: UpdateSpaceCategoryResponse;
}

export interface UpdateSpaceFeatureRequest {
  name?: string | undefined;
}

export interface UpdateSpaceFeatureResponse {
  id: string;
  links?: Link[] | undefined;
  name: string;
  spaceCategoryId: string;
}

export interface UpdateSpaceFeatureResponseApiResponse {
  code: number;
  success: boolean;
  data: UpdateSpaceFeatureResponse;
}

export interface UpdateSpaceRecurringBookingRequest {
  userId?: string | undefined;
  title?: string | undefined;
  startTime?: Date | undefined;
  endTime?: Date | undefined;
  frequency?: SpaceRecurringFrequency | undefined;
  until?: Date | undefined;
  count?: number | undefined;
}

export interface UpdateSpaceRecurringBookingResponse {
  id: string;
  links?: Link[] | undefined;
  spaceResourceId?: string | undefined;
  userId?: string | undefined;
  title?: string | undefined;
  startTime?: Date | undefined;
  endTime?: Date | undefined;
  frequency?: SpaceRecurringFrequency | undefined;
  until?: Date | undefined;
  count?: number | undefined;
  exceptions?: Date[] | undefined;
  createdAt?: Date | undefined;
  updatedAt?: Date | undefined;
  user?: ExpandedUser | undefined;
  spaceResource?: ExpandedSpaceResource | undefined;
  spaceCategory?: ExpandedSpaceCategory | undefined;
  level?: ExpandedLevel | undefined;
  location?: ExpandedLocation | undefined;
}

export interface UpdateSpaceRecurringBookingResponseApiResponse {
  code: number;
  success: boolean;
  data: UpdateSpaceRecurringBookingResponse;
}

export interface UpdateSpaceResourceRequest {
  name?: string | undefined;
  notes?: string | undefined;
  capacity?: number | undefined;
  accessRestrictions?: SpaceResourceAccessRestrictions | undefined;
  features?: string[] | undefined;
  spaceZones?: string[] | undefined;
  image?: Base64File | undefined;
}

export interface UpdateSpaceResourceResponse {
  id: string;
  links?: Link[] | undefined;
  levelId?: string | undefined;
  spaceCategoryId?: string | undefined;
  name?: string | undefined;
  notes?: string | undefined;
  isActive: boolean;
  capacity?: number | undefined;
  spaceBookingCount: number;
  imageUrl?: string | undefined;
  location?: ExpandedLocation | undefined;
  spaceCategory?: ExpandedSpaceCategory | undefined;
  level?: ExpandedLevel | undefined;
  createdAt?: Date | undefined;
  updatedAt?: Date | undefined;
}

export interface UpdateSpaceResourceResponseApiResponse {
  code: number;
  success: boolean;
  data: UpdateSpaceResourceResponse;
}

export interface UpdateSpaceZoneRequest {
  name?: string | undefined;
  accessRestrictions?: SpaceZoneAccessRestrictionsRequest | undefined;
  spaceResources?: string[] | undefined;
}

export interface UpdateSpaceZoneResponse {
  id: string;
  links?: Link[] | undefined;
  levelId?: string | undefined;
  name?: string | undefined;
  accessRestrictions?: SpaceZoneAccessRestrictionResponse[] | undefined;
}

export interface UpdateSpaceZoneResponseApiResponse {
  code: number;
  success: boolean;
  data: UpdateSpaceZoneResponse;
}

export interface UpsertApiKeyRequest {
  name?: string | undefined;
  note?: string | undefined;
}

export interface UpsertApiKeyResponse {
  id: string;
  links?: Link[] | undefined;
  type?: ApiKeyType | undefined;
  name?: string | undefined;
  note?: string | undefined;
  secret?: string | undefined;
  secretRedacted?: string | undefined;
  permissions?: ApiKeyPermissions | undefined;
  useCount?: number | undefined;
  lastUsedAt?: Date | undefined;
  expiredAt?: Date | undefined;
  createdAt?: Date | undefined;
  updatedAt?: Date | undefined;
}

export interface UpsertApiKeyResponseApiResponse {
  code: number;
  success: boolean;
  data: UpsertApiKeyResponse;
}

export interface UpsertAppVersionRequest {
  version?: string | undefined;
  platform: AppVersionPlatform;
  minOsVersion?: string | undefined;
  metadata?: string | undefined;
  releasedAt: Date;
}

export interface UpsertAppVersionResponse {
  id: string;
  links?: Link[] | undefined;
  version?: string | undefined;
  platform: AppVersionPlatform;
  minOsVersion?: string | undefined;
  metadata?: any | undefined;
  releasedAt: Date;
  createdAt: Date;
  updatedAt: Date;
}

export interface UpsertAppVersionResponseApiResponse {
  code: number;
  success: boolean;
  data: UpsertAppVersionResponse;
}

export interface UpsertInductionRequest {
  name?: string | undefined;
  validityDurationDays?: number | undefined;
  steps?: InductionStep[] | undefined;
}

export interface UpsertInductionResponse {
  id: string;
  links?: Link[] | undefined;
  name?: string | undefined;
  validityDurationDays?: number | undefined;
  steps?: InductionStep[] | undefined;
  createdAt: Date;
  updatedAt: Date;
}

export interface UpsertInductionResponseApiResponse {
  code: number;
  success: boolean;
  data: UpsertInductionResponse;
}

export interface UpsertLevelRequest {
  name?: string | undefined;
  locationId?: string | undefined;
  isActive: boolean;
  mapImage?: Base64File | undefined;
  order: number;
}

export interface UpsertLevelResponse {
  id: string;
  links?: Link[] | undefined;
  name: string;
  isActive: boolean;
  locationId?: string | undefined;
  order: number;
  mapData: MapData;
}

export interface UpsertLevelResponseApiResponse {
  code: number;
  success: boolean;
  data: UpsertLevelResponse;
}

export interface UpsertRoomRequest {
  name?: string | undefined;
  notes?: string | undefined;
  features?: string[] | undefined;
  spaceZones?: string[] | undefined;
  image?: Base64File | undefined;
  backgroundImage?: Base64File | undefined;
  showOrganiser?: boolean | undefined;
  showMeetingName?: boolean | undefined;
  allowExtend?: boolean | undefined;
  requireApproval?: boolean | undefined;
  conjuctionBookingAvailable?: boolean | undefined;
  providerId?: string | undefined;
  levelId?: string | undefined;
}

export interface UpsertRoomResponse {
  id: string;
  links?: Link[] | undefined;
  levelId?: string | undefined;
  spaceCategoryId?: string | undefined;
  name?: string | undefined;
  notes?: string | undefined;
  capacity?: number | undefined;
  spaceBookingCount: number;
  imageUrl?: string | undefined;
  backgroundImageUrl?: string | undefined;
  showOrganiser: boolean;
  showMeetingName: boolean;
  allowExtend: boolean;
  requireApproval: boolean;
  conjuctionBookingAvailable: boolean;
  location?: ExpandedLocation | undefined;
  spaceCategory?: ExpandedSpaceCategory | undefined;
  level?: ExpandedLevel | undefined;
  createdAt?: Date | undefined;
  updatedAt?: Date | undefined;
}

export interface UpsertRoomResponseApiResponse {
  code: number;
  success: boolean;
  data: UpsertRoomResponse;
}

export interface UpsertSpaceBookingRequest {
  spaceResourceId?: string | undefined;
  userId?: string | undefined;
  title?: string | undefined;
  startTime?: Date | undefined;
  endTime?: Date | undefined;
}

export interface UpsertSpaceCategoryRequest {
  name?: string | undefined;
  icon?: string | undefined;
  bookingLimitDays?: number | undefined;
  recurringBookings?: boolean | undefined;
  locationGroupId?: string | undefined;
}

export interface UpsertSpaceCategoryResponse {
  id: string;
  links?: Link[] | undefined;
  name: string;
  type?: SpaceCategoryType | undefined;
  icon?: string | undefined;
  bookingLimitDays?: number | undefined;
  recurringBookings?: boolean | undefined;
}

export interface UpsertSpaceCategoryResponseApiResponse {
  code: number;
  success: boolean;
  data: UpsertSpaceCategoryResponse;
}

export interface UpsertSpaceFeatureRequest {
  name?: string | undefined;
  spaceCategoryId?: string | undefined;
}

export interface UpsertSpaceFeatureResponse {
  id: string;
  links?: Link[] | undefined;
  name: string;
  spaceCategoryId: string;
  isEdit?: boolean | undefined;
}

export interface UpsertSpaceFeatureResponseApiResponse {
  code: number;
  success: boolean;
  data: UpsertSpaceFeatureResponse;
}

export interface UpsertSpaceRecurringBookingRequest {
  spaceResourceId: string;
  title?: string | undefined;
  userId: string;
  startTime: Date;
  endTime: Date;
  frequency: SpaceRecurringFrequency;
  until?: Date | undefined;
  count?: number | undefined;
}

export interface UpsertSpaceRecurringBookingResponse {
  id: string;
  links?: Link[] | undefined;
  spaceResourceId?: string | undefined;
  userId?: string | undefined;
  title?: string | undefined;
  startTime?: Date | undefined;
  endTime?: Date | undefined;
  frequency?: SpaceRecurringFrequency | undefined;
  until?: Date | undefined;
  count?: number | undefined;
  exceptions?: Date[] | undefined;
  createdAt?: Date | undefined;
  updatedAt?: Date | undefined;
  user?: ExpandedUser | undefined;
  spaceResource?: ExpandedSpaceResource | undefined;
  spaceCategory?: ExpandedSpaceCategory | undefined;
  level?: ExpandedLevel | undefined;
  location?: ExpandedLocation | undefined;
}

export interface UpsertSpaceRecurringBookingResponseApiResponse {
  code: number;
  success: boolean;
  data: UpsertSpaceRecurringBookingResponse;
}

export interface UpsertSpaceResourceResponse {
  id: string;
  links?: Link[] | undefined;
  levelId?: string | undefined;
  spaceCategoryId?: string | undefined;
  name?: string | undefined;
  notes?: string | undefined;
  isActive: boolean;
  capacity?: number | undefined;
  spaceBookingCount: number;
  imageUrl?: string | undefined;
  location?: ExpandedLocation | undefined;
  spaceCategory?: ExpandedSpaceCategory | undefined;
  level?: ExpandedLevel | undefined;
  createdAt?: Date | undefined;
  updatedAt?: Date | undefined;
}

export interface UpsertSpaceResourceResponseApiResponse {
  code: number;
  success: boolean;
  data: UpsertSpaceResourceResponse;
}

export interface UpsertSpaceZoneRequest {
  levelId: string;
  name: string;
  accessRestrictions?: SpaceZoneAccessRestrictionsRequest | undefined;
  spaceResources?: string[] | undefined;
}

export interface UpsertSpaceZoneResponse {
  id: string;
  links?: Link[] | undefined;
  levelId?: string | undefined;
  name?: string | undefined;
  accessRestrictions?: SpaceZoneAccessRestrictionResponse[] | undefined;
}

export interface UpsertSpaceZoneResponseApiResponse {
  code: number;
  success: boolean;
  data: UpsertSpaceZoneResponse;
}

export interface ValidateCalendarIntegrationUserResponse {
  validUser: boolean;
}

export interface ValidateCalendarIntegrationUserResponseApiResponse {
  code: number;
  success: boolean;
  data: ValidateCalendarIntegrationUserResponse;
}

export interface ValidationError {
  message: string;
  errorCode: ValidationErrorType;
  attribute: string;
}

export enum ValidationErrorType {
  Required = "required",
  NotFound = "notFound",
  Invalid = "invalid",
  Unique = "unique",
  Immutable = "immutable",
  OutOfRange = "outOfRange",
}

export interface VerifyAccountAddressResponse {
  isValid: boolean;
  address: BillingAddress;
}

export interface VerifyAccountAddressResponseApiResponse {
  code: number;
  success: boolean;
  data: VerifyAccountAddressResponse;
}

export enum VisitFieldTypes {
  String = "string",
  Email = "email",
  Phone = "phone",
  Yesno = "yesno",
  Dob = "dob",
  Multiselect = "multiselect",
  Multichoice = "multichoice",
  Document = "document",
  Vaccinepass = "vaccinepass",
  Pronouns = "pronouns",
}

export interface XYPoint {
  x: number;
  y: number;
}

export interface FileParameter {
  data: any;
  fileName: string;
}

export interface FileResponse {
  data: Blob;
  status: number;
  fileName?: string;
  headers?: { [name: string]: any };
}

export class ApiException extends Error {
  override message: string;
  status: number;
  response: string;
  headers: { [key: string]: any };
  result: any;

  constructor(
    message: string,
    status: number,
    response: string,
    headers: { [key: string]: any },
    result: any
  ) {
    super();

    this.message = message;
    this.status = status;
    this.response = response;
    this.headers = headers;
    this.result = result;
  }

  protected isApiException = true;

  static isApiException(obj: any): obj is ApiException {
    return obj.isApiException === true;
  }
}

function throwException(
  message: string,
  status: number,
  response: string,
  headers: { [key: string]: any },
  result?: any
): any {
  if (result !== null && result !== undefined) throw result;
  else throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any | undefined): obj is AxiosError {
  return obj && obj.isAxiosError === true;
}

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

// this file is used to generate zoolander.ts and is merged with it
// modify with CAUTION

// remove axios default transform of the response and let nswag code handle it

const zoolanderAxiosInstance = axios.create({
  transformResponse: (data) => data,
});
zoolanderAxiosInstance.defaults.headers.common.accept =
  "application/vnd.swipedon+json; version=2";
zoolanderAxiosInstance.interceptors.request.use(handlers.preRequest);
zoolanderAxiosInstance.interceptors.response.use(
  undefined,
  handlers.errorResponse
);

interface ApiClientOptions {
  service?: ServiceType;
  withCredentials?: boolean;
}

const defaultApiClientOptions: ApiClientOptions = {
  service: "api",
  withCredentials: true,
};
export class ApiClient extends Client {
  constructor(options: ApiClientOptions = defaultApiClientOptions) {
    const store = useApiStore();
    const endpoint = store.getEndpoint(options.service ?? "api");
    zoolanderAxiosInstance.defaults.withCredentials = options.withCredentials;
    super(endpoint, zoolanderAxiosInstance);
  }
}
